export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any }
  /** Represents untyped JSON */
  JSON: { input: any; output: any }
  /** Represents a numeric value that can be either Integer, Float, or BigDecimal */
  Numeric: { input: number; output: number }
  Upload: { input: any; output: any }
}

export type ActionGoal = {
  __typename?: 'ActionGoal'
  cadence: ActionGoalCadence
  category: ActionGoalCategory
  description: Scalars['String']['output']
  displayUnits?: Maybe<Scalars['String']['output']>
  goalText?: Maybe<Scalars['String']['output']>
  icon: UiIcon
  id: Scalars['ID']['output']
  kind: ActionGoalKind
  macroGoal?: Maybe<Scalars['String']['output']>
  metricKind: ActionGoalMetricKind
  metricValue?: Maybe<Scalars['Float']['output']>
  numberDays: Scalars['Int']['output']
  startDate: Scalars['ISO8601Date']['output']
  status: ActionGoalStatus
  summaryDescription: Scalars['String']['output']
  title: Scalars['String']['output']
}

export enum ActionGoalCadence {
  Weekly = 'weekly',
}

export enum ActionGoalCategory {
  Fitness = 'fitness',
  Glucose = 'glucose',
  Habits = 'habits',
  Nutrition = 'nutrition',
}

export type ActionGoalCompletion = {
  __typename?: 'ActionGoalCompletion'
  date: Scalars['ISO8601Date']['output']
}

export enum ActionGoalKind {
  CaloriesGoal = 'calories_goal',
  CarbsGoal = 'carbs_goal',
  CustomTextGoal = 'custom_text_goal',
  CyclingDistanceGoal = 'cycling_distance_goal',
  ExerciseGoal = 'exercise_goal',
  FastingGoal = 'fasting_goal',
  FiberGoal = 'fiber_goal',
  FlightsClimbedGoal = 'flights_climbed_goal',
  GlucoseMeanGoal = 'glucose_mean_goal',
  GlucoseMinGoal = 'glucose_min_goal',
  GlucoseMorningAverageGoal = 'glucose_morning_average_goal',
  GlucosePeakGoal = 'glucose_peak_goal',
  GlucoseSleepAverageGoal = 'glucose_sleep_average_goal',
  GlucoseStandardDeviationGoal = 'glucose_standard_deviation_goal',
  GlucoseTimeInRangeGoal = 'glucose_time_in_range_goal',
  GlucoseTimeOutsideRangeGoal = 'glucose_time_outside_range_goal',
  GlucoseTotalScoreGoal = 'glucose_total_score_goal',
  MealPresenceGoal = 'meal_presence_goal',
  MeditationGoal = 'meditation_goal',
  NetCarbsGoal = 'net_carbs_goal',
  ProteinGoal = 'protein_goal',
  RunningDistanceGoal = 'running_distance_goal',
  SaturatedFatGoal = 'saturated_fat_goal',
  SleepGoal = 'sleep_goal',
  SodiumGoal = 'sodium_goal',
  StepsGoal = 'steps_goal',
  SugarGoal = 'sugar_goal',
  SwimmingDistanceGoal = 'swimming_distance_goal',
  TotalFatGoal = 'total_fat_goal',
  VideoCallPresenceGoal = 'video_call_presence_goal',
}

export enum ActionGoalMetricKind {
  CaloriesGteMetric = 'calories_gte_metric',
  CaloriesLteMetric = 'calories_lte_metric',
  CarbsGteMetric = 'carbs_gte_metric',
  CarbsLteMetric = 'carbs_lte_metric',
  CyclingDistanceMetric = 'cycling_distance_metric',
  ExerciseDurationGteMetric = 'exercise_duration_gte_metric',
  ExercisePresenceMetric = 'exercise_presence_metric',
  FastingDurationGteMetric = 'fasting_duration_gte_metric',
  FastingPresenceMetric = 'fasting_presence_metric',
  FiberGteMetric = 'fiber_gte_metric',
  FlightsClimbedMetric = 'flights_climbed_metric',
  GlucoseMaxStatsGteMetric = 'glucose_max_stats_gte_metric',
  GlucoseMaxStatsLteMetric = 'glucose_max_stats_lte_metric',
  GlucoseMeanScoreMetric = 'glucose_mean_score_metric',
  GlucoseMinStatsGteMetric = 'glucose_min_stats_gte_metric',
  GlucoseMinStatsLteMetric = 'glucose_min_stats_lte_metric',
  GlucoseMorningAverageStatsGteMetric = 'glucose_morning_average_stats_gte_metric',
  GlucoseMorningAverageStatsLteMetric = 'glucose_morning_average_stats_lte_metric',
  GlucosePeakScoreMetric = 'glucose_peak_score_metric',
  GlucoseSleepAverageStatsGteMetric = 'glucose_sleep_average_stats_gte_metric',
  GlucoseSleepAverageStatsLteMetric = 'glucose_sleep_average_stats_lte_metric',
  GlucoseStandardDeviationScoreMetric = 'glucose_standard_deviation_score_metric',
  GlucoseStandardDeviationStatsLteMetric = 'glucose_standard_deviation_stats_lte_metric',
  GlucoseTimeInRangeStatsGteMetric = 'glucose_time_in_range_stats_gte_metric',
  GlucoseTimeOutsideRangeScoreMetric = 'glucose_time_outside_range_score_metric',
  GlucoseTotalScoreMetric = 'glucose_total_score_metric',
  ManualTextMetric = 'manual_text_metric',
  MealPresenceMetric = 'meal_presence_metric',
  MeditationDurationGteMetric = 'meditation_duration_gte_metric',
  MeditationPresenceMetric = 'meditation_presence_metric',
  NetCarbsLteMetric = 'net_carbs_lte_metric',
  ProteinGteMetric = 'protein_gte_metric',
  RunningDistanceMetric = 'running_distance_metric',
  SaturatedFatLteMetric = 'saturated_fat_lte_metric',
  SleepDurationGteMetric = 'sleep_duration_gte_metric',
  SodiumLteMetric = 'sodium_lte_metric',
  StepCountMetric = 'step_count_metric',
  SugarLteMetric = 'sugar_lte_metric',
  SwimmingDistanceMetric = 'swimming_distance_metric',
  TotalFatGteMetric = 'total_fat_gte_metric',
  TotalFatLteMetric = 'total_fat_lte_metric',
  VideoCallPresenceMetric = 'video_call_presence_metric',
}

export type ActionGoalOption = {
  __typename?: 'ActionGoalOption'
  allowsMultipleActiveGoalsForKind: Scalars['Boolean']['output']
  category: ActionGoalCategory
  description: Scalars['String']['output']
  icon: UiIcon
  kind: ActionGoalKind
  metricOptions: Array<MetricOption>
  requiresGoalText: Scalars['Boolean']['output']
  title: Scalars['String']['output']
}

export enum ActionGoalStatus {
  Active = 'active',
  Deleted = 'deleted',
}

export type ActionGoalSummary = {
  __typename?: 'ActionGoalSummary'
  actionGoal: ActionGoal
  completions?: Maybe<Array<ActionGoalCompletion>>
  id: Scalars['ID']['output']
}

export type ActionGoalSummaryCollection = {
  __typename?: 'ActionGoalSummaryCollection'
  actionGoalSummaries: Array<ActionGoalSummary>
  startDate: Scalars['ISO8601Date']['output']
}

export type ActiveActionTunnel = {
  __typename?: 'ActiveActionTunnel'
  actionKey?: Maybe<Scalars['String']['output']>
  draft?: Maybe<Scalars['JSON']['output']>
  missingFields?: Maybe<Array<Scalars['String']['output']>>
}

export type Activity = {
  __typename?: 'Activity'
  allDay: Scalars['Boolean']['output']
  autoGenerated: Scalars['Boolean']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  description: Scalars['String']['output']
  endedAt: Scalars['ISO8601DateTime']['output']
  externalSource?: Maybe<Scalars['String']['output']>
  favorite: Scalars['Boolean']['output']
  glucose: EntryGlucose
  id: Scalars['ID']['output']
  length: Scalars['Int']['output']
  occurredAt: Scalars['ISO8601DateTime']['output']
  startedAt: Scalars['ISO8601DateTime']['output']
  statistics: EntryStatistics
  status?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  type: Scalars['String']['output']
}

export type ActivityCollection = {
  __typename?: 'ActivityCollection'
  activities: Array<Activity>
}

export type ActivityFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>
  endHour?: InputMaybe<Scalars['Int']['input']>
  excludeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  favorite?: InputMaybe<Scalars['Boolean']['input']>
  graph?: InputMaybe<Scalars['String']['input']>
  includeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  order?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  scope?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  startHour?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<KeyValueStringArray>>
}

export type AddonLimit = {
  __typename?: 'AddonLimit'
  description?: Maybe<Scalars['String']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  productId: Scalars['ID']['output']
  purchasedAmount: Scalars['Int']['output']
}

export type Address = {
  __typename?: 'Address'
  city: Scalars['String']['output']
  country?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  state?: Maybe<AddressState>
  street: Scalars['String']['output']
  street2: Scalars['String']['output']
  zipCode: Scalars['String']['output']
}

export enum AddressCountries {
  Ca = 'CA',
  Gb = 'GB',
  Us = 'US',
}

export enum AddressCountry {
  Ca = 'CA',
  Gb = 'GB',
  Us = 'US',
}

export enum AddressState {
  Aa = 'AA',
  Ab = 'AB',
  Ae = 'AE',
  Ak = 'AK',
  Al = 'AL',
  Ap = 'AP',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Bc = 'BC',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Fm = 'FM',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Mb = 'MB',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nb = 'NB',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nl = 'NL',
  Nm = 'NM',
  Ns = 'NS',
  Nt = 'NT',
  Nu = 'NU',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  On = 'ON',
  Or = 'OR',
  Other = 'Other',
  Pa = 'PA',
  Pe = 'PE',
  Pr = 'PR',
  Pw = 'PW',
  Qc = 'QC',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Sk = 'SK',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY',
  Yt = 'YT',
}

export type AllowEarlyExitBehavior = {
  __typename?: 'AllowEarlyExitBehavior'
  followupSurvey?: Maybe<SurveysConfigKind>
}

export type Answer = {
  __typename?: 'Answer'
  /** @deprecated Use followups instead */
  followup?: Maybe<Followup>
  followups: Array<Followup>
  inlineAlert?: Maybe<InlineAlert>
  label: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type AnswersGroup = {
  __typename?: 'AnswersGroup'
  answers: Array<Answer>
  answersOrder: SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswersOrder
}

export enum AppointmentDynamicEhrFilterField {
  MeetingAt = 'meeting_at',
}

export enum AppointmentEhrSortField {
  MeetingAt = 'meeting_at',
}

export type ApprovalRequest = {
  __typename?: 'ApprovalRequest'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  kind: UserApprovalRequestKind
  state: UserApprovalRequestState
  user: User
}

export type Article = {
  __typename?: 'Article'
  category?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  latestVersionId: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type ArticleList = {
  __typename?: 'ArticleList'
  articles: Array<Article>
}

export type ArticleVersion = {
  __typename?: 'ArticleVersion'
  category?: Maybe<Scalars['String']['output']>
  htmlBody: Scalars['String']['output']
  id: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type ArticleVersionList = {
  __typename?: 'ArticleVersionList'
  articleVersions: Array<ArticleVersion>
}

export type Availability = {
  __typename?: 'Availability'
  appointmentKind: EhrAppointmentKind
  dayOfWeek: Scalars['Int']['output']
  rangeEndAt: Scalars['ISO8601DateTime']['output']
  rangeStartAt: Scalars['ISO8601DateTime']['output']
}

export type Behavior = {
  __typename?: 'Behavior'
  allowEarlyExit: Scalars['Boolean']['output']
  allowMultipleSubmissions: Scalars['Boolean']['output']
  redirectOnOutcome: Scalars['Boolean']['output']
  showAlertOnClose: Scalars['Boolean']['output']
  showProgressIndicator: Scalars['Boolean']['output']
  trackResponses: Scalars['Boolean']['output']
  warnBeforeStopping: Scalars['Boolean']['output']
}

export type BenefitsCheck = {
  __typename?: 'BenefitsCheck'
  dateOfBirth: Scalars['ISO8601Date']['output']
  firstName: Scalars['String']['output']
  groupNumber?: Maybe<Scalars['String']['output']>
  holderDateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>
  holderFirstName?: Maybe<Scalars['String']['output']>
  holderLastName?: Maybe<Scalars['String']['output']>
  holderRelationship: UserInsurancePolicyHolderRelationship
  lastName: Scalars['String']['output']
  memberId: Scalars['String']['output']
  sex: Scalars['String']['output']
  success: Scalars['Boolean']['output']
}

export type BillingAllowance = {
  __typename?: 'BillingAllowance'
  allocated: Scalars['Int']['output']
  id: Scalars['ID']['output']
  kind: BillingAllowanceKind
  remaining: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type BillingAllowanceCollection = {
  __typename?: 'BillingAllowanceCollection'
  allowances: Array<BillingAllowance>
}

export enum BillingAllowanceKind {
  CoachingCall = 'coaching_call',
  LabPanelDiscount = 'lab_panel_discount',
}

export enum BillingOneTimePaymentsCheckoutState {
  Completed = 'completed',
  Created = 'created',
  Failed = 'failed',
  Processed = 'processed',
  Processing = 'processing',
}

export enum BillingProduct {
  AmazonNutrisenseMonthly = 'amazon_nutrisense_monthly',
  AutoCancelNutrisenseMonthly = 'auto_cancel_nutrisense_monthly',
  AutoCancelNutrisenseMonthlyGoogleShopping = 'auto_cancel_nutrisense_monthly_google_shopping',
  BundledFixedMember = 'bundled_fixed_member',
  BundledFixedMemberBuyNowPayLater = 'bundled_fixed_member_buy_now_pay_later',
  CancellationFee = 'cancellation_fee',
  Cgm = 'cgm',
  CgmBundleFixed = 'cgm_bundle_fixed',
  CompoundedSemaglutide = 'compounded_semaglutide',
  CompoundedSemaglutideWithSupport = 'compounded_semaglutide_with_support',
  DexcomCgm = 'dexcom_cgm',
  DexcomPatch = 'dexcom_patch',
  DmDietitian_4Video_30Min = 'dm_dietitian_4_video_30_min',
  DmDietitianVideo_30Min = 'dm_dietitian_video_30_min',
  DmMealPlan = 'dm_meal_plan',
  DmQGlucoseCompare = 'dm_q_glucose_compare',
  DmQGlucoseEvent = 'dm_q_glucose_event',
  DmQGlucoseFasting = 'dm_q_glucose_fasting',
  DmQGlucoseMetrics = 'dm_q_glucose_metrics',
  DmQGlucoseTrends = 'dm_q_glucose_trends',
  DmSupplementReview = 'dm_supplement_review',
  DmWeeklyGoals = 'dm_weekly_goals',
  DowngradeFee = 'downgrade_fee',
  DowngradeFee_6To_3Cycle_1 = 'downgrade_fee_6_to_3_cycle_1',
  DowngradeFee_6To_3Cycle_2 = 'downgrade_fee_6_to_3_cycle_2',
  DowngradeFee_12To_3Cycle_1 = 'downgrade_fee_12_to_3_cycle_1',
  DowngradeFee_12To_3Cycle_2 = 'downgrade_fee_12_to_3_cycle_2',
  DowngradeFee_12To_6Cycle_1 = 'downgrade_fee_12_to_6_cycle_1',
  DowngradeFee_12To_6Cycle_2 = 'downgrade_fee_12_to_6_cycle_2',
  DowngradeFee_12To_6Cycle_3 = 'downgrade_fee_12_to_6_cycle_3',
  DowngradeFee_12To_6Cycle_4 = 'downgrade_fee_12_to_6_cycle_4',
  DowngradeFee_12To_6Cycle_5 = 'downgrade_fee_12_to_6_cycle_5',
  FlexNutrisenseMonthly = 'flex_nutrisense_monthly',
  FlexNutrisenseMonthly_3 = 'flex_nutrisense_monthly_3',
  FlexNutrisenseMonthly_6 = 'flex_nutrisense_monthly_6',
  FreeCgmReplacement = 'free_cgm_replacement',
  FreeSoftwareOnlyDppAnnualMembership = 'free_software_only_dpp_annual_membership',
  FreeSoftwareOnlyMedicalAnnualMembership = 'free_software_only_medical_annual_membership',
  FreeSoftwareOnlyOwnSensorAnnualMembership = 'free_software_only_own_sensor_annual_membership',
  FreeSoftwareOnlyVideoCallsAnnualMembership = 'free_software_only_video_calls_annual_membership',
  FullscriptComprehensive = 'fullscript_comprehensive',
  FullscriptComprehensiveEvery_3Months = 'fullscript_comprehensive_every_3_months',
  FullscriptComprehensiveEvery_6Months = 'fullscript_comprehensive_every_6_months',
  FullscriptCore = 'fullscript_core',
  FullscriptCoreEvery_3Months = 'fullscript_core_every_3_months',
  FullscriptCoreEvery_6Months = 'fullscript_core_every_6_months',
  FullscriptElite = 'fullscript_elite',
  FullscriptEliteEvery_3Months = 'fullscript_elite_every_3_months',
  FullscriptEliteEvery_6Months = 'fullscript_elite_every_6_months',
  Influencer_1 = 'influencer_1',
  Influencer_2 = 'influencer_2',
  InternationalOptionExercise = 'international_option_exercise',
  MedicalConsultAddon = 'medical_consult_addon',
  MedicalConsultLateCancellationFee = 'medical_consult_late_cancellation_fee',
  MedicalConsultLateRescheduleFee = 'medical_consult_late_reschedule_fee',
  MedicalConsultNoShowFee = 'medical_consult_no_show_fee',
  NonRecurring_1_16Rd = 'non_recurring_1_16_rd',
  NonRecurring_1_32Rd = 'non_recurring_1_32_rd',
  NonRecurring_1NoRd = 'non_recurring_1_no_rd',
  NonRecurring_2_32Rd = 'non_recurring_2_32_rd',
  NonRecurring_2Cgm_1Call = 'non_recurring_2_cgm_1_call',
  NonRecurring_2NoRd = 'non_recurring_2_no_rd',
  NonTaxablePrepaidNutrisenseMonthly_1 = 'non_taxable_prepaid_nutrisense_monthly_1',
  NonTaxablePrepaidNutrisenseMonthly_3 = 'non_taxable_prepaid_nutrisense_monthly_3',
  NonTaxablePrepaidNutrisenseMonthly_6 = 'non_taxable_prepaid_nutrisense_monthly_6',
  NonTaxablePrepaidNutrisenseMonthly_12 = 'non_taxable_prepaid_nutrisense_monthly_12',
  NutrisenseDietitian = 'nutrisense_dietitian',
  NutrisenseDietitianLimited = 'nutrisense_dietitian_limited',
  NutrisenseMonthly = 'nutrisense_monthly',
  NutrisenseMonthly_2Calls = 'nutrisense_monthly_2_calls',
  NutrisenseMonthly_3 = 'nutrisense_monthly_3',
  NutrisenseMonthly_4 = 'nutrisense_monthly_4',
  NutrisenseMonthly_6 = 'nutrisense_monthly_6',
  NutrisenseMonthly_6BuyNowPayLater = 'nutrisense_monthly_6_buy_now_pay_later',
  NutrisenseMonthly_12 = 'nutrisense_monthly_12',
  NutrisenseMonthly_12BuyNowPayLater = 'nutrisense_monthly_12_buy_now_pay_later',
  NutrisenseMonthlyChurnRecovery = 'nutrisense_monthly_churn_recovery',
  NutrisenseMonthlyPreInsurance = 'nutrisense_monthly_pre_insurance',
  NutrisensePeriodic_1_3 = 'nutrisense_periodic_1_3',
  NutrisensePeriodic_1_6 = 'nutrisense_periodic_1_6',
  NutrisensePeriodic_2_3 = 'nutrisense_periodic_2_3',
  NutrisensePeriodic_2_6 = 'nutrisense_periodic_2_6',
  NutrisenseSoftwareOnly = 'nutrisense_software_only',
  NutrisenseTier_1Monthly_6 = 'nutrisense_tier_1_monthly_6',
  NutrisenseTier_2BasicMonthly_6 = 'nutrisense_tier_2_basic_monthly_6',
  NutrisenseTier_2PremiumMonthly_6 = 'nutrisense_tier_2_premium_monthly_6',
  NutrisenseTier_3BasicMonthly_6 = 'nutrisense_tier_3_basic_monthly_6',
  NutrisenseTier_3PremiumMonthly_6 = 'nutrisense_tier_3_premium_monthly_6',
  NutritionCoachFocused = 'nutrition_coach_focused',
  OneMonthCgm = 'one_month_cgm',
  PaidCgmReplacement = 'paid_cgm_replacement',
  PaidDexcomPatch = 'paid_dexcom_patch',
  PaidPatch = 'paid_patch',
  PaidReshipCgmReplacement = 'paid_reship_cgm_replacement',
  Patch = 'patch',
  PrepaidNutrisenseMonthly_1 = 'prepaid_nutrisense_monthly_1',
  PrepaidNutrisenseMonthly_3 = 'prepaid_nutrisense_monthly_3',
  PrepaidNutrisenseMonthly_6 = 'prepaid_nutrisense_monthly_6',
  PrepaidNutrisenseMonthly_12 = 'prepaid_nutrisense_monthly_12',
  ReshipCgmReplacement = 'reship_cgm_replacement',
  ShippingFee = 'shipping_fee',
  SoftwareOnlyAnnualMembership = 'software_only_annual_membership',
  SoftwareOnlyOwnSensorAnnualMembership = 'software_only_own_sensor_annual_membership',
  SoftwareOnlyOwnSensorAnnualMembershipChurnRecovery = 'software_only_own_sensor_annual_membership_churn_recovery',
  SoftwareOnlyOwnSensorMonthlyMembership = 'software_only_own_sensor_monthly_membership',
  SoftwareOnlyOwnSensorMonthlyMembershipChurnRecovery = 'software_only_own_sensor_monthly_membership_churn_recovery',
  SteloCgm_1 = 'stelo_cgm_1',
  SteloCgm_2 = 'stelo_cgm_2',
  SteloCgm_2Monthly = 'stelo_cgm_2_monthly',
  StressManagementCall_60Min_1 = 'stress_management_call_60_min_1',
  SupplementMg_2 = 'supplement_mg_2',
  SupplementMg_6 = 'supplement_mg_6',
  SupplementMvt_2 = 'supplement_mvt_2',
  SupplementMvt_6 = 'supplement_mvt_6',
  SupplementQ10_2 = 'supplement_q10_2',
  SupplementQ10_6 = 'supplement_q10_6',
  Tax = 'tax',
  UhcVideoCalls_30Min_2Monthly = 'uhc_video_calls_30_min_2_monthly',
  UhcVideoCalls_30Min_2NonRecurring = 'uhc_video_calls_30_min_2_non_recurring',
  Unknown = 'unknown',
  UpsellNutrisenseMonthly = 'upsell_nutrisense_monthly',
  UpsellNutrisenseMonthly_3 = 'upsell_nutrisense_monthly_3',
  UpsellNutrisenseMonthly_6 = 'upsell_nutrisense_monthly_6',
  VideoCall_30Min_1 = 'video_call_30_min_1',
  VideoCallLateCancellationFee = 'video_call_late_cancellation_fee',
  VideoCallLateRescheduleFee = 'video_call_late_reschedule_fee',
  VideoCallNoShowFee = 'video_call_no_show_fee',
  VideoCallPayAsYouGoMnt_30Min = 'video_call_pay_as_you_go_mnt_30_min',
  VideoCallPayAsYouGoMnt_60Min = 'video_call_pay_as_you_go_mnt_60_min',
  VideoCallPayAsYouGoStressManagement_60Min = 'video_call_pay_as_you_go_stress_management_60_min',
  VideoCalls_30Min_2 = 'video_calls_30_min_2',
  WelcomeKit = 'welcome_kit',
}

export enum BillingProductCategory {
  ByosAnnualUpgrade = 'byos_annual_upgrade',
  ChurnRecoveryCgmUpsell = 'churn_recovery_cgm_upsell',
  ChurnRecoveryLearnedEverythingNeeded = 'churn_recovery_learned_everything_needed',
  ChurnRecoveryMembershipUpsell = 'churn_recovery_membership_upsell',
  ChurnRecoveryNotUsedOften = 'churn_recovery_not_used_often',
  ChurnRecoveryReachedHealthGoal = 'churn_recovery_reached_health_goal',
  ChurnRecoveryTooExpensive = 'churn_recovery_too_expensive',
  ChurnRecoveryUpsellAdhesiveSkinIrritation = 'churn_recovery_upsell_adhesive_skin_irritation',
  ChurnRecoveryUpsellDidNotLikeProduct = 'churn_recovery_upsell_did_not_like_product',
  ChurnRecoveryUpsellDidNotLikeSensor = 'churn_recovery_upsell_did_not_like_sensor',
  ChurnRecoveryUpsellLearnedEverythingNeeded = 'churn_recovery_upsell_learned_everything_needed',
  ChurnRecoveryUpsellNotUsedOften = 'churn_recovery_upsell_not_used_often',
  ChurnRecoveryUpsellOther = 'churn_recovery_upsell_other',
  ChurnRecoveryUpsellReachedHealthGoal = 'churn_recovery_upsell_reached_health_goal',
  ChurnRecoveryUpsellServiceNotValuable = 'churn_recovery_upsell_service_not_valuable',
  ChurnRecoveryUpsellTooExpensive = 'churn_recovery_upsell_too_expensive',
  Fee = 'fee',
  FreeTrial = 'free_trial',
  Glp = 'glp',
  JhMarketplace = 'jh_marketplace',
  Labs = 'labs',
  Marketplace = 'marketplace',
  NutritionistHub = 'nutritionist_hub',
  Onboarding = 'onboarding',
  SteloCgm = 'stelo_cgm',
  StressManagement = 'stress_management',
}

export enum BillingProductGroupKind {
  Commitment = 'commitment',
  Dropdown = 'dropdown',
}

export enum BillingProductInterval {
  Every_3Months = 'every_3_months',
  Every_6Months = 'every_6_months',
  Monthly = 'monthly',
  NoInterval = 'no_interval',
  NonRecurring_1M = 'non_recurring_1_m',
  NonRecurring_2M = 'non_recurring_2_m',
  Yearly = 'yearly',
}

export type BiomarkerConfig = {
  __typename?: 'BiomarkerConfig'
  kind: HealthDataMetricBiomarker
  label: Scalars['String']['output']
  unit?: Maybe<Scalars['String']['output']>
}

export type BiteAi = {
  __typename?: 'BiteAi'
  dailyValues: Array<KeyValuePairFloat>
  units: Array<BiteAiKeyValuePairString>
}

export type BiteAiKeyValuePairString = {
  __typename?: 'BiteAiKeyValuePairString'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type BloodPressureMeasurement = {
  __typename?: 'BloodPressureMeasurement'
  diastolic: Scalars['Float']['output']
  systolic: Scalars['Float']['output']
}

export type CalendarDate = {
  __typename?: 'CalendarDate'
  date: Scalars['ISO8601Date']['output']
  score?: Maybe<Scalars['Int']['output']>
}

export type Charge = {
  __typename?: 'Charge'
  amount: Scalars['Float']['output']
  amountCaptured?: Maybe<Scalars['Float']['output']>
  amountRefunded: Scalars['Float']['output']
  created: Scalars['ISO8601DateTime']['output']
  disputeStripeId?: Maybe<Scalars['String']['output']>
  disputed: Scalars['Boolean']['output']
  failureMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  invoice?: Maybe<Invoice>
  paid: Scalars['Boolean']['output']
  providerPaymentMethodId?: Maybe<Scalars['String']['output']>
  refundable: Scalars['Boolean']['output']
  refunded: Scalars['Boolean']['output']
  status: Scalars['String']['output']
  stripeId: Scalars['String']['output']
  user: User
}

export type Chart = {
  __typename?: 'Chart'
  description: Scalars['String']['output']
  meta: ChartMeta
  range: ChartRange
  title: Scalars['String']['output']
  type: Scalars['String']['output']
  values: Array<ValuePair>
  xAxis: Scalars['String']['output']
  yAxis: Scalars['String']['output']
}

export type ChartData = {
  __typename?: 'ChartData'
  data: Array<ValuePair>
  key: Scalars['String']['output']
  range?: Maybe<ChartRange>
  section: Scalars['String']['output']
}

export type ChartFilter = {
  endDate: Scalars['String']['input']
  period: Period
  startDate: Scalars['String']['input']
  types: Array<KeyValueStringArray>
}

export type ChartMeta = {
  __typename?: 'ChartMeta'
  key?: Maybe<Scalars['String']['output']>
  section?: Maybe<Scalars['String']['output']>
  tag?: Maybe<Scalars['String']['output']>
}

export type ChartRange = {
  __typename?: 'ChartRange'
  goal?: Maybe<Scalars['Float']['output']>
  goalMax?: Maybe<Scalars['Float']['output']>
  goalMin?: Maybe<Scalars['Float']['output']>
  max?: Maybe<Scalars['Float']['output']>
  min?: Maybe<Scalars['Float']['output']>
  tickCount?: Maybe<Scalars['Int']['output']>
}

export type Charts = {
  __typename?: 'Charts'
  charts: Array<Chart>
}

export type ChartsConfig = {
  __typename?: 'ChartsConfig'
  filters: ChartsFilters
}

export type ChartsData = {
  __typename?: 'ChartsData'
  values?: Maybe<Array<ChartData>>
}

export type ChartsFilters = {
  __typename?: 'ChartsFilters'
  types: Array<KeyValuePairStringArray>
}

export type ChatConversation = {
  __typename?: 'ChatConversation'
  assignee?: Maybe<User>
  candidateRead: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  intercomBackfillState?: Maybe<ChatConversationIntercomBackfillState>
  intercomCreatedAt: Scalars['ISO8601DateTime']['output']
  intercomId: Scalars['String']['output']
  kind: ChatConversationKind
  lastMessage?: Maybe<ChatConversationMessage>
  lastNote?: Maybe<ChatConversationNote>
  lastUserMessage?: Maybe<ChatConversationMessage>
  read: Scalars['Boolean']['output']
  state: ChatConversationState
  user: User
}

export enum ChatConversationIntercomBackfillState {
  Completed = 'completed',
  InProgress = 'in_progress',
  Pending = 'pending',
}

export enum ChatConversationKind {
  Mnt = 'mnt',
  StressManagement = 'stress_management',
  Support = 'support',
}

export type ChatConversationMessage = {
  __typename?: 'ChatConversationMessage'
  id: Scalars['ID']['output']
  sender?: Maybe<User>
  senderKind: ChatConversationMessageSenderKind
  sentAt: Scalars['ISO8601DateTime']['output']
  value: Scalars['String']['output']
}

export type ChatConversationMessageCollection = {
  __typename?: 'ChatConversationMessageCollection'
  messages: Array<WebMembersChatConversationMessage>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export enum ChatConversationMessageSenderKind {
  Automated = 'automated',
  Unknown = 'unknown',
  User = 'user',
}

export enum ChatConversationMessageTemplateKind {
  AutoCoachSwitch_3DayNudge = 'auto_coach_switch_3_day_nudge',
  AutoCoachSwitch_7DayNudge = 'auto_coach_switch_7_day_nudge',
  AutoCoachSwitchGoodbye = 'auto_coach_switch_goodbye',
  AutoCoachSwitchWelcome = 'auto_coach_switch_welcome',
  BasicInitial = 'basic_initial',
  CgmReviewVideoCallsUpsell = 'cgm_review_video_calls_upsell',
  Custom = 'custom',
  DietitianMenuMealPlanInitial = 'dietitian_menu_meal_plan_initial',
  DietitianMenuSupplementReviewInitial = 'dietitian_menu_supplement_review_initial',
  DppInitial = 'dpp_initial',
  DppPostClass = 'dpp_post_class',
  DppPreClass = 'dpp_pre_class',
  Engagement = 'engagement',
  FixedEightWeeksInitial = 'fixed_eight_weeks_initial',
  FreeCallGranted = 'free_call_granted',
  InsuranceVideoCallOptionReminder = 'insurance_video_call_option_reminder',
  LowDailyScoreVideoCallsUpsell = 'low_daily_score_video_calls_upsell',
  MonthlyWrapUp = 'monthly_wrap_up',
  NutritionVideoInitial = 'nutrition_video_initial',
  NutritionistOutOfOffice = 'nutritionist_out_of_office',
  PossibilityOfOpeningVideoCallAvailability = 'possibility_of_opening_video_call_availability',
  PremiumInitial = 'premium_initial',
  PremiumInitialPaid = 'premium_initial_paid',
  StressVideoInitial = 'stress_video_initial',
  ThirtyMinVideoCallPossibility = 'thirty_min_video_call_possibility',
  VideoCallCancelled = 'video_call_cancelled',
  VideoInitialHealthCoaching = 'video_initial_health_coaching',
  VideoPostFreeCall = 'video_post_free_call',
  VideoPreFreeCall = 'video_pre_free_call',
  VideoReminder = 'video_reminder',
  VideoWrapUp = 'video_wrap_up',
}

export type ChatConversationNote = {
  __typename?: 'ChatConversationNote'
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy: User
  id: Scalars['ID']['output']
  value: Scalars['String']['output']
}

export enum ChatConversationState {
  Closed = 'closed',
  Open = 'open',
  Snoozed = 'snoozed',
}

export type Chatbot = {
  __typename?: 'Chatbot'
  /** AI-usage disclosure shown wherever the AI assistant is surfaced */
  disclosure: Scalars['String']['output']
  lastShownCutoffAt: Scalars['ISO8601DateTime']['output']
  responseTimeoutInSeconds: Scalars['Int']['output']
}

export type ChatbotConversation = {
  __typename?: 'ChatbotConversation'
  activeActionTunnel?: Maybe<ActiveActionTunnel>
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  /** @deprecated Use reportId instead */
  isReport: Scalars['Boolean']['output']
  kind: ChatbotConversationKind
  pinned: Scalars['Boolean']['output']
  preview?: Maybe<Scalars['String']['output']>
  providerId: Scalars['String']['output']
  quickPromptId?: Maybe<Scalars['ID']['output']>
  read: Scalars['Boolean']['output']
  reportId?: Maybe<Scalars['ID']['output']>
  tags: Array<ChatbotConversationTag>
  title: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type ChatbotConversationCollection = {
  __typename?: 'ChatbotConversationCollection'
  conversations: Array<ChatbotConversation>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type ChatbotConversationDynamicFilter = {
  field: ChatbotConversationDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum ChatbotConversationDynamicFilterField {
  Kind = 'kind',
  Pinned = 'pinned',
  Tag = 'tag',
}

export type ChatbotConversationDynamicFilterItem = {
  items: Array<ChatbotConversationDynamicFilter>
  operator: DynamicFilterOperator
}

export enum ChatbotConversationKind {
  Conversation = 'conversation',
  MainConversation = 'main_conversation',
  ProactiveExtendedGlucoseElevation = 'proactive_extended_glucose_elevation',
  ProactiveLowGlucose = 'proactive_low_glucose',
  ProactiveMealLoggingDropOff = 'proactive_meal_logging_drop_off',
  ProactivePostActivityWin = 'proactive_post_activity_win',
  ProactivePostMealSpike = 'proactive_post_meal_spike',
  ProactiveRecurringSpikePattern = 'proactive_recurring_spike_pattern',
  ProactiveSleepGlucoseCorrelation = 'proactive_sleep_glucose_correlation',
  Report = 'report',
}

export type ChatbotConversationSort = {
  direction: SortDirection
  field: ChatbotConversationSortField
}

export enum ChatbotConversationSortField {
  CreatedAt = 'created_at',
}

export enum ChatbotConversationTag {
  Activity = 'activity',
  Energy = 'energy',
  Glucose = 'glucose',
  LabResults = 'lab_results',
  Meals = 'meals',
  Sleep = 'sleep',
  Stress = 'stress',
}

export type ChatbotMessageReport = {
  __typename?: 'ChatbotMessageReport'
  id: Scalars['ID']['output']
}

export enum ChatbotMessageReportReason {
  Harmful = 'harmful',
  Inaccurate = 'inaccurate',
  Inappropriate = 'inappropriate',
  Other = 'other',
}

export type ChatbotQuickPrompt = {
  __typename?: 'ChatbotQuickPrompt'
  createdAt: Scalars['ISO8601DateTime']['output']
  custom: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  text: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type ChatbotQuickPromptCollection = {
  __typename?: 'ChatbotQuickPromptCollection'
  quickPrompts: Array<ChatbotQuickPrompt>
}

export type ChatbotSettings = {
  __typename?: 'ChatbotSettings'
  appNotificationsEnabled: Scalars['Boolean']['output']
  communicationStyle: ChatbotSettingsCommunicationStyle
  dataSharingEnabled: Scalars['Boolean']['output']
  emailNotificationsEnabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  proactiveUpdatesEnabled: Scalars['Boolean']['output']
  speechVoice?: Maybe<ChatbotSpeechVoice>
}

export enum ChatbotSettingsCommunicationStyle {
  AccountabilityDriven = 'accountability_driven',
  DataDriven = 'data_driven',
  Friendly = 'friendly',
}

export enum ChatbotSpeechVoice {
  Alloy = 'alloy',
  Nova = 'nova',
}

export type ChecklistItem = {
  __typename?: 'ChecklistItem'
  completed: Scalars['Boolean']['output']
  deepLink: Scalars['String']['output']
  inProgress: Scalars['Boolean']['output']
  key: UserChecklistItem
  title: Scalars['String']['output']
}

export type ChecklistItemCollection = {
  __typename?: 'ChecklistItemCollection'
  checklistItems: Array<ChecklistItem>
}

export type CheckoutOption = {
  __typename?: 'CheckoutOption'
  kind: SubscriptionCheckoutOptionKind
}

export type ClientConfig = {
  __typename?: 'ClientConfig'
  actionGoalOptions: Array<ActionGoalOption>
  activityTypes: Array<Scalars['String']['output']>
  appointmentKinds: Array<ClientConfigEhrAppointmentKind>
  biomarkers: Array<BiomarkerConfig>
  biteAi: BiteAi
  caProvinces: Array<State>
  charts: ChartsConfig
  chatbot: Chatbot
  coaches: CoachesConfig
  customIngredients: CustomIngredients
  dayTabs: Array<KeyValuePairString>
  dexcomClientId: Scalars['String']['output']
  dexcomSteloClientId: Scalars['String']['output']
  education: Education
  events: Events
  featureFlags: Array<FeatureFlag>
  goalMetricOptions: Array<GoalMetricOption>
  goalOptions: Array<GoalOption>
  googleFit: GoogleFit
  healthData: HealthDataConfig
  healthKit: HealthKit
  /** @deprecated health_metrics is replaced by biomarkers */
  healthMetrics: Array<HealthMetricType>
  healthSettings: HealthSettings
  /** @deprecated history is replaced by events in mobile app v3.7.2 */
  history: History
  insights: Config
  insuranceKinds: InsuranceKinds
  journal: JournalConfig
  labResults: LabResultsConfig
  mealTypes: Array<Scalars['String']['output']>
  meals: Meals
  measurements: Array<MeasurementConfig>
  onboarding: Onboarding
  privacyCenterUrl: Scalars['String']['output']
  questionnaireUrl: Scalars['String']['output']
  referral: Referral
  reminders: Array<ReminderKind>
  remindersSettings: RemindersSettings
  researchFaqs: ResearchFaqs
  score: Score
  sensorSettings: SensorSettings
  settings: Settings
  signup: Signup
  specialtyKinds: Array<EhrCoachSpecialtyDef>
  stats: StatsConfig
  tickets: Tickets
  timeZones: Array<Scalars['String']['output']>
  tutorials: Array<Tutorials>
  uhcDeepLinks: UhcDeepLinks
  /** @deprecated us_states from client_config is replaced by a public us_states query */
  usStates: Array<State>
}

export type ClientConfigEhrAppointmentKind = {
  __typename?: 'ClientConfigEhrAppointmentKind'
  coachingKind: CoachesCoachingKindDef
  duration: Scalars['String']['output']
  /** @deprecated Use coaching_kind instead */
  healthCoaching: Scalars['Boolean']['output']
  key: EhrAppointmentKind
  /** @deprecated Use coaching_kind instead */
  mnt: Scalars['Boolean']['output']
  title: Scalars['String']['output']
}

export type Coach = {
  __typename?: 'Coach'
  active: Scalars['Boolean']['output']
  bio?: Maybe<Scalars['String']['output']>
  coachId: Scalars['ID']['output']
  credentials?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['ISO8601Date']['output']>
  fullName: Scalars['String']['output']
  getHealthieId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  kind: EhrAppointmentProviderKind
  manager?: Maybe<User>
  outOfOffice: Scalars['Boolean']['output']
  photo?: Maybe<Scalars['String']['output']>
  priorityChangedAt?: Maybe<Scalars['ISO8601Date']['output']>
  schedulingPriority?: Maybe<Scalars['Int']['output']>
  specialties: Array<EhrCoachSpecialtyDef>
  startDate?: Maybe<Scalars['ISO8601Date']['output']>
  stateLicences: Array<Scalars['String']['output']>
  stressBio?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601Date']['output']
}

export type CoachAssignment = {
  __typename?: 'CoachAssignment'
  assignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  canSendEngagementMessage: Scalars['Boolean']['output']
  coach?: Maybe<User>
  coachingKind: CoachesCoachingKindDef
  createdAt: Scalars['ISO8601DateTime']['output']
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  dietitianMenu: Scalars['Boolean']['output']
  ehrAppointment?: Maybe<EhrAppointment>
  id: Scalars['ID']['output']
  kind?: Maybe<CoachAssignmentKind>
  last: Scalars['Boolean']['output']
  lastCoachMessageDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  referralUrl?: Maybe<Scalars['String']['output']>
  state: CoachAssignmentState
  supportType: CoachAssignmentSupportType
  user: User
}

export type CoachAssignmentCollection = {
  __typename?: 'CoachAssignmentCollection'
  coachAssignments: Array<CoachAssignment>
}

export type CoachAssignmentDynamicFilter = {
  field: CoachAssignmentDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum CoachAssignmentDynamicFilterField {
  CoachingKind = 'coaching_kind',
  Last = 'last',
  State = 'state',
  SupportType = 'support_type',
}

export type CoachAssignmentDynamicFilterItem = {
  items: Array<CoachAssignmentDynamicFilter>
  operator: DynamicFilterOperator
}

export type CoachAssignmentInfo = {
  __typename?: 'CoachAssignmentInfo'
  activeAssignmentsCount: Scalars['Int']['output']
  coachId: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export enum CoachAssignmentKind {
  AnnualMembership = 'annual_membership',
  CoachingPlan = 'coaching_plan',
  Fixed_8Weeks = 'fixed_8_weeks',
  Influencer = 'influencer',
  NoCoreSubscription = 'no_core_subscription',
  NonRecurring = 'non_recurring',
  Recurring_12Weeks = 'recurring_12_weeks',
  Regular = 'regular',
}

export type CoachAssignmentSort = {
  direction: SortDirection
  field: CoachAssignmentSortField
}

export enum CoachAssignmentSortField {
  CoachingKind = 'coaching_kind',
  CreatedAt = 'created_at',
  Last = 'last',
  State = 'state',
  SupportType = 'support_type',
  UpdatedAt = 'updated_at',
}

export enum CoachAssignmentState {
  Active = 'active',
  Inactive = 'inactive',
  Paused = 'paused',
  Pending = 'pending',
}

export enum CoachAssignmentSupportType {
  AsyncChat = 'async_chat',
  MealPlan = 'meal_plan',
  SupplementReview = 'supplement_review',
  VideoCall = 'video_call',
  VideoChat = 'video_chat',
}

export type CoachProfile = {
  __typename?: 'CoachProfile'
  /** @deprecated Use `state` instead */
  active: Scalars['Boolean']['output']
  additionalLanguages?: Maybe<Scalars['String']['output']>
  averageRating?: Maybe<Scalars['Float']['output']>
  bio?: Maybe<Scalars['String']['output']>
  cdrCnsCard?: Maybe<Scalars['String']['output']>
  cdrCnsExpirationDate?: Maybe<Scalars['ISO8601Date']['output']>
  cdrCnsNumber?: Maybe<Scalars['String']['output']>
  coachId: Scalars['ID']['output']
  credentials?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['ISO8601Date']['output']>
  ethnicity?: Maybe<Scalars['String']['output']>
  fullName: Scalars['String']['output']
  gender?: Maybe<EhrCoachGender>
  getHealthieId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  licenceMode?: Maybe<EhrCoachLicenceMode>
  manager?: Maybe<User>
  outOfOffice: Scalars['Boolean']['output']
  pendingRegisterNote?: Maybe<Scalars['String']['output']>
  photo?: Maybe<Scalars['String']['output']>
  premium: Scalars['Boolean']['output']
  priorityChangedAt?: Maybe<Scalars['ISO8601Date']['output']>
  registrationStatus: EhrCoachRegistrationStatus
  reviewsCount: Scalars['Int']['output']
  schedulingPriority?: Maybe<Scalars['Int']['output']>
  specialties: Array<EhrCoachSpecialtyDef>
  startDate?: Maybe<Scalars['ISO8601Date']['output']>
  state: EhrCoachState
  stateLicenceDetails: Array<StateLicence>
  stateLicences: Array<Scalars['String']['output']>
  stateOfResidence?: Maybe<Scalars['String']['output']>
  stressBio?: Maybe<Scalars['String']['output']>
  unlimitedChatSupport: Scalars['Boolean']['output']
  updatedAt: Scalars['ISO8601Date']['output']
}

export type CoachProfileCollection = {
  __typename?: 'CoachProfileCollection'
  coachProfiles: Array<CoachProfile>
}

export enum CoachesCoachingKind {
  HealthCoaching = 'health_coaching',
  Medical = 'medical',
  Mnt = 'mnt',
  StressManagement = 'stress_management',
}

export type CoachesCoachingKindDef = {
  __typename?: 'CoachesCoachingKindDef'
  clinical: Scalars['Boolean']['output']
  coachTitle: Scalars['String']['output']
  hubTitle: Scalars['String']['output']
  insuranceReimbursable: Scalars['Boolean']['output']
  key: CoachesCoachingKind
  primary: Scalars['Boolean']['output']
  serviceTitle: Scalars['String']['output']
  shortCoachTitle: Scalars['String']['output']
  shortHubTitle: Scalars['String']['output']
}

export type CoachesConfig = {
  __typename?: 'CoachesConfig'
  coachSwitchMaxSpecialtiesSelection: Scalars['Int']['output']
}

export type CompletedScreen = {
  __typename?: 'CompletedScreen'
  footnote?: Maybe<Scalars['String']['output']>
  header: Scalars['String']['output']
  icon?: Maybe<UiIcon>
  /** @deprecated use intro_markdown */
  intro?: Maybe<Scalars['String']['output']>
  introMarkdown?: Maybe<Scalars['String']['output']>
  primaryActionText?: Maybe<Scalars['String']['output']>
  secondaryActionLink?: Maybe<Link>
  showCoachPhoto: Scalars['Boolean']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type Config = {
  __typename?: 'Config'
  filters: StatsFilters
  statistics: Array<Statistics>
}

export type ConfigUnit = {
  __typename?: 'ConfigUnit'
  precision: Scalars['Int']['output']
  ranges: Array<RangeUnit>
  units: Scalars['String']['output']
}

export type Conversation = {
  __typename?: 'Conversation'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  preview: Scalars['String']['output']
  status: Scalars['String']['output']
}

export type ConversationList = {
  __typename?: 'ConversationList'
  conversations: Array<Conversation>
}

export type ConversationMessage = {
  __typename?: 'ConversationMessage'
  direction: Scalars['String']['output']
  id: Scalars['String']['output']
  preview: Scalars['String']['output']
  subject?: Maybe<Scalars['String']['output']>
}

export type ConversationMessagesList = {
  __typename?: 'ConversationMessagesList'
  messages: Array<ConversationMessage>
}

export type CreateActionGoal = {
  goalText?: InputMaybe<Scalars['String']['input']>
  kind: ActionGoalKind
  metricKind: ActionGoalMetricKind
  metricValue?: InputMaybe<Scalars['Float']['input']>
  numberDays: Scalars['Int']['input']
}

/** Autogenerated return type of CreateAction. */
export type CreateActionPayload = {
  __typename?: 'CreateActionPayload'
  success: Scalars['Boolean']['output']
}

export type CreatedOneTimePayment = {
  __typename?: 'CreatedOneTimePayment'
  invoice: Invoice
}

export type CreatedSubscription = {
  __typename?: 'CreatedSubscription'
  clientSecret?: Maybe<Scalars['String']['output']>
  providerSubscriptionId: Scalars['String']['output']
  subscription: Subscription
}

export type CustomIngredients = {
  __typename?: 'CustomIngredients'
  macros: Array<Macro>
}

export type DailyMeasurementsSourcePriority = {
  __typename?: 'DailyMeasurementsSourcePriority'
  sources: Array<HealthDataMeasurementSource>
  type: HealthDataMeasurementType
}

export type DailyScore = {
  __typename?: 'DailyScore'
  score?: Maybe<Scalars['Int']['output']>
  scoreMean?: Maybe<Scalars['Int']['output']>
  scorePeak?: Maybe<Scalars['Int']['output']>
  scoreStdDev?: Maybe<Scalars['Int']['output']>
  scoreTimeOutsideRange?: Maybe<Scalars['Int']['output']>
}

export type DateFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>
  endHour?: InputMaybe<Scalars['Int']['input']>
  excludeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  favorite?: InputMaybe<Scalars['Boolean']['input']>
  graph?: InputMaybe<Scalars['String']['input']>
  includeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  order?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  scope?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  startHour?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<KeyValueStringArray>>
}

export type DateSlots = {
  __typename?: 'DateSlots'
  slots: Array<EhrSlot>
}

export type Dates = {
  __typename?: 'Dates'
  crossKindRecurrenceDates: Array<Scalars['ISO8601Date']['output']>
  dates: Array<Scalars['ISO8601Date']['output']>
}

export type DatesWithSlots = {
  __typename?: 'DatesWithSlots'
  dates: Array<EhrDate>
  providers: Array<EhrProviderKind>
}

export type Delimiter = {
  __typename?: 'Delimiter'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
}

export enum DexcomConnectionKind {
  Research = 'research',
  Stelo = 'stelo',
}

export enum DexcomConnectionPlatform {
  Mobile = 'mobile',
  Web = 'web',
}

export enum DexcomConnectionSensorModel {
  DexcomG6 = 'dexcom_g6',
}

export enum DexcomConnectionStatus {
  Active = 'active',
  Invalidated = 'invalidated',
}

export type DexcomConnectionType = {
  __typename?: 'DexcomConnectionType'
  accessToken: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  dexcomUserId?: Maybe<Scalars['String']['output']>
  kind: DexcomConnectionKind
  lastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  status: DexcomConnectionStatus
}

export type DirectUpload = {
  __typename?: 'DirectUpload'
  headers: Array<KeyValuePairString>
  signedId: Scalars['String']['output']
  url: Scalars['String']['output']
}

export enum DirectUploadPurpose {
  IntercomAttachment = 'intercom_attachment',
  MealPhoto = 'meal_photo',
}

export enum DirectUploadReason {
  IntercomAttachment = 'intercom_attachment',
  MealPhoto = 'meal_photo',
}

export type Doctor = {
  __typename?: 'Doctor'
  avatar?: Maybe<Scalars['String']['output']>
  bio?: Maybe<Scalars['String']['output']>
  credentials?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  getHealthieId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  kind: EhrAppointmentProviderKind
  lastName?: Maybe<Scalars['String']['output']>
  state: EhrDoctorState
}

export type DoctorAssignment = {
  __typename?: 'DoctorAssignment'
  doctor: Doctor
  id: Scalars['ID']['output']
  state: EhrDoctorAssignmentState
}

export enum DynamicFilterItemOperation {
  Blank = 'blank',
  Cont = 'cont',
  ContAll = 'cont_all',
  ContAny = 'cont_any',
  DoesNotMatch = 'does_not_match',
  DoesNotMatchAll = 'does_not_match_all',
  DoesNotMatchAny = 'does_not_match_any',
  End = 'end',
  EndAll = 'end_all',
  EndAny = 'end_any',
  Eq = 'eq',
  Gt = 'gt',
  GtAll = 'gt_all',
  GtAny = 'gt_any',
  Gteq = 'gteq',
  GteqAll = 'gteq_all',
  GteqAny = 'gteq_any',
  ICont = 'i_cont',
  IContAll = 'i_cont_all',
  IContAny = 'i_cont_any',
  In = 'in',
  IsNull = 'is_null',
  Lt = 'lt',
  LtAll = 'lt_all',
  LtAny = 'lt_any',
  Lteq = 'lteq',
  LteqAll = 'lteq_all',
  LteqAny = 'lteq_any',
  Matches = 'matches',
  MatchesAll = 'matches_all',
  MatchesAny = 'matches_any',
  NotCont = 'not_cont',
  NotContAll = 'not_cont_all',
  NotContAny = 'not_cont_any',
  NotEnd = 'not_end',
  NotEndAll = 'not_end_all',
  NotEndAny = 'not_end_any',
  NotEq = 'not_eq',
  NotEqAll = 'not_eq_all',
  NotICont = 'not_i_cont',
  NotIContAll = 'not_i_cont_all',
  NotIContAny = 'not_i_cont_any',
  NotIn = 'not_in',
  NotNull = 'not_null',
  NotStart = 'not_start',
  NotStartAll = 'not_start_all',
  NotStartAny = 'not_start_any',
  Present = 'present',
  Start = 'start',
  StartAll = 'start_all',
  StartAny = 'start_any',
}

export enum DynamicFilterOperator {
  And = 'and',
  Or = 'or',
}

export type Education = {
  __typename?: 'Education'
  collections: Array<EducationCollection>
}

export type EducationArticle = {
  __typename?: 'EducationArticle'
  author: Scalars['String']['output']
  imageUrl: Scalars['String']['output']
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type EducationCollection = {
  __typename?: 'EducationCollection'
  articles: Array<EducationArticle>
  imageUrl: Scalars['String']['output']
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type EffectiveDailyMeasurement = {
  __typename?: 'EffectiveDailyMeasurement'
  availableMeasurements: Array<Measurement>
  date: Scalars['ISO8601Date']['output']
  defaultSource?: Maybe<HealthDataMeasurementSource>
  selectedSource?: Maybe<HealthDataMeasurementSource>
  type: HealthDataMeasurementType
}

export type EhrAppointment = {
  __typename?: 'EhrAppointment'
  addToGcalLink?: Maybe<Scalars['String']['output']>
  attendances: Array<EhrAppointmentAttendance>
  category: EhrAppointmentCategory
  coachRating?: Maybe<Scalars['Int']['output']>
  coachingKind: CoachesCoachingKind
  forbidLateReschedule: Scalars['Boolean']['output']
  getHealthieId?: Maybe<Scalars['ID']['output']>
  getHealthieInstanceKind: EhrGetHealthieInstanceKind
  id: Scalars['ID']['output']
  joinUrl?: Maybe<Scalars['String']['output']>
  kind: EhrAppointmentKind
  lastState: EhrAppointmentState
  lateCancellationFeeProduct?: Maybe<BillingProduct>
  lateRescheduleFeeProduct?: Maybe<BillingProduct>
  meetingAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  noShowFeeProduct?: Maybe<BillingProduct>
  payAsYouGoProduct?: Maybe<Product>
  providerName?: Maybe<Scalars['String']['output']>
  providers: Array<EhrProvider>
  /** @deprecated Use `recurring` field instead */
  recurrent: Scalars['Boolean']['output']
  recurring: Scalars['Boolean']['output']
  startUrl?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  unauthenticatedIcsLink?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type EhrAppointmentAttendance = {
  __typename?: 'EhrAppointmentAttendance'
  agenda?: Maybe<Scalars['String']['output']>
  chargeKind: EhrAppointmentAttendanceChargeKind
  feeInvoice?: Maybe<Invoice>
  id: Scalars['ID']['output']
  imposesLateChangeFees: Scalars['Boolean']['output']
  insurancePolicy?: Maybe<InsurancePolicy>
  invoice?: Maybe<Invoice>
  state: EhrAppointmentAttendanceState
  user: User
}

export enum EhrAppointmentAttendanceChargeKind {
  BsAllowanceCovered = 'bs_allowance_covered',
  BsFree = 'bs_free',
  BsInsuranceCovered = 'bs_insurance_covered',
  BsPaid = 'bs_paid',
  BsSelfPay = 'bs_self_pay',
  NsPaid = 'ns_paid',
}

export enum EhrAppointmentAttendanceState {
  Attended = 'attended',
  Pending = 'pending',
  Unattended = 'unattended',
}

export enum EhrAppointmentCategory {
  Coaching = 'coaching',
  Dpp = 'dpp',
  GroupMnt = 'group_mnt',
  Medical = 'medical',
}

export type EhrAppointmentCollection = {
  __typename?: 'EhrAppointmentCollection'
  appointments: Array<EhrAppointment>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type EhrAppointmentCredits = {
  __typename?: 'EhrAppointmentCredits'
  count: Scalars['Int']['output']
  countBySubscriptionId: Scalars['JSON']['output']
}

export type EhrAppointmentDynamicFilter = {
  field: AppointmentDynamicEhrFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export type EhrAppointmentDynamicFilterItem = {
  items: Array<EhrAppointmentDynamicFilter>
  operator: DynamicFilterOperator
}

export enum EhrAppointmentKind {
  DpWebinarSession = 'dp_webinar_session',
  DppSession = 'dpp_session',
  Followup = 'followup',
  Followup_30 = 'followup_30',
  Followup_45 = 'followup_45',
  Followup_90 = 'followup_90',
  GlpSession = 'glp_session',
  GlpSession_10 = 'glp_session_10',
  Initial = 'initial',
  Initial_60 = 'initial_60',
  NoneCovered = 'none_covered',
  StressManagement = 'stress_management',
  StressManagementMnt = 'stress_management_mnt',
  UhcHealthCoaching = 'uhc_health_coaching',
}

export enum EhrAppointmentProviderKind {
  Coach = 'coach',
  Doctor = 'doctor',
}

export enum EhrAppointmentProviderState {
  Active = 'active',
  Inactive = 'inactive',
}

export enum EhrAppointmentReason {
  BerryStreetAutomation = 'berry_street_automation',
  BillingSideEffect = 'billing_side_effect',
  BookingKindOverride = 'booking_kind_override',
  CancellationSideEffect = 'cancellation_side_effect',
  CoachSwitch = 'coach_switch',
  CoachesBillableMissingData = 'coaches_billable_missing_data',
  Console = 'console',
  FreeCallGranted = 'free_call_granted',
  FreeCallTrialUpsert = 'free_call_trial_upsert',
  GetHealthie = 'get_healthie',
  GlpIntakeSurveyRestarted = 'glp_intake_survey_restarted',
  HealthPortal = 'health_portal',
  InsuranceDomainMigration = 'insurance_domain_migration',
  InsuranceSideEffect = 'insurance_side_effect',
  NoShowFeePaymentFailed = 'no_show_fee_payment_failed',
  OpsAccountRequest = 'ops_account_request',
  PaymentMethodMissing = 'payment_method_missing',
  PreauthorizationFailed = 'preauthorization_failed',
  RecurrenceDelete = 'recurrence_delete',
  RecurrenceForceUpsert = 'recurrence_force_upsert',
  RecurrenceUpsert = 'recurrence_upsert',
  RestoredAsFreeFromBerryStreetAutomation = 'restored_as_free_from_berry_street_automation',
  RestoredFromBerryStreetAutomation = 'restored_from_berry_street_automation',
  StaleFreePending = 'stale_free_pending',
  SubscriptionExpired = 'subscription_expired',
  UpcomingAppointmentRefresh = 'upcoming_appointment_refresh',
  User = 'user',
  UserCoachSwitch = 'user_coach_switch',
}

export type EhrAppointmentRecurrence = {
  __typename?: 'EhrAppointmentRecurrence'
  appointmentKind?: Maybe<EhrAppointmentKind>
  cadence: EhrAppointmentRecurrenceCadence
  days: Array<EhrAppointmentRecurrenceDay>
  id: Scalars['ID']['output']
  numberOfCalls: Scalars['Int']['output']
  timeSlots?: Maybe<Array<Scalars['ISO8601DateTime']['output']>>
}

export enum EhrAppointmentRecurrenceCadence {
  BiWeekly = 'bi_weekly',
  Monthly = 'monthly',
  OneTime = 'one_time',
  Weekly = 'weekly',
}

export enum EhrAppointmentRecurrenceDay {
  All = 'all',
  Friday = 'friday',
  Monday = 'monday',
  Saturday = 'saturday',
  Thursday = 'thursday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
}

export type EhrAppointmentSchedulingInfo = {
  __typename?: 'EhrAppointmentSchedulingInfo'
  /** @deprecated Use options instead */
  appointmentKind: EhrAppointmentKind
  bookingAvailable: Scalars['Boolean']['output']
  cadenceOptions: Array<SchedulingInfoCadenceOption>
  chargeKind: EhrAppointmentAttendanceChargeKind
  options: Array<EhrAppointmentSchedulingInfoOption>
  pendingAppointment?: Maybe<EhrAppointment>
  schedulingMode: EhrAppointmentSchedulingMode
  title: Scalars['String']['output']
}

export type EhrAppointmentSchedulingInfoCollection = {
  __typename?: 'EhrAppointmentSchedulingInfoCollection'
  mnt: EhrAppointmentSchedulingInfo
  stressManagement: EhrAppointmentSchedulingInfo
}

export type EhrAppointmentSchedulingInfoOption = {
  __typename?: 'EhrAppointmentSchedulingInfoOption'
  appointmentKind: EhrAppointmentKind
  duration: Scalars['Int']['output']
  payAsYouGoProduct?: Maybe<Product>
  product?: Maybe<Product>
  recurring: Scalars['Boolean']['output']
}

export enum EhrAppointmentSchedulingMode {
  InsuranceCovered = 'insurance_covered',
  None = 'none',
  SelfPay = 'self_pay',
  Undetermined = 'undetermined',
}

export enum EhrAppointmentSchedulingRule {
  BsFreeSingle = 'bs_free_single',
  BsPaidBundle = 'bs_paid_bundle',
  BsPaidDouble = 'bs_paid_double',
  BsPaidSingle = 'bs_paid_single',
  NoScheduling = 'no_scheduling',
  StressManagementSingle = 'stress_management_single',
  UhcHealthCoachingDouble = 'uhc_health_coaching_double',
  UhcHealthCoachingSingle = 'uhc_health_coaching_single',
}

export type EhrAppointmentSchedulingRuleDef = {
  __typename?: 'EhrAppointmentSchedulingRuleDef'
  additionalPaidCallsAllowed: Scalars['Boolean']['output']
  appointmentKind?: Maybe<EhrAppointmentKind>
  chargeKind?: Maybe<EhrAppointmentAttendanceChargeKind>
  count?: Maybe<Scalars['Int']['output']>
  key: EhrAppointmentSchedulingRule
}

export type EhrAppointmentSort = {
  direction: SortDirection
  field: AppointmentEhrSortField
}

export type EhrAppointmentState = {
  __typename?: 'EhrAppointmentState'
  appointmentId: Scalars['ID']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  creditUsed: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  kind: EhrAppointmentStateKind
  reason: EhrAppointmentReason
  terminal: Scalars['Boolean']['output']
}

export enum EhrAppointmentStateKind {
  Cancelled = 'cancelled',
  Deleted = 'deleted',
  InReview = 'in_review',
  LateCancellation = 'late_cancellation',
  LateReschedule = 'late_reschedule',
  NoShow = 'no_show',
  Occurred = 'occurred',
  PendingReschedule = 'pending_reschedule',
  PendingSchedule = 'pending_schedule',
  Rescheduled = 'rescheduled',
  Scheduled = 'scheduled',
}

export enum EhrChartNoteKind {
  CheckIn = 'check_in',
  CheckInAddendum = 'check_in_addendum',
  MedicalIntakeForm = 'medical_intake_form',
  RenewalIntakeForm = 'renewal_intake_form',
}

export enum EhrCoachGender {
  Female = 'female',
  Genderqueer = 'genderqueer',
  Male = 'male',
  NonBinary = 'non_binary',
  PreferNotToSay = 'prefer_not_to_say',
  PreferToSelfDescribe = 'prefer_to_self_describe',
}

export enum EhrCoachLicenceMode {
  LegacyState = 'legacy_state',
  PayerLicence = 'payer_licence',
  StateAndPayerLicence = 'state_and_payer_licence',
  StateLicence = 'state_licence',
}

export enum EhrCoachRegistrationStatus {
  Approved = 'approved',
  PendingApproval = 'pending_approval',
  PendingRegister = 'pending_register',
}

export enum EhrCoachSpecialty {
  AutoimmuneConditions = 'autoimmune_conditions',
  Bariatric = 'bariatric',
  Cancer = 'cancer',
  ChronicFatigue = 'chronic_fatigue',
  EatingDisorders = 'eating_disorders',
  Fertility = 'fertility',
  FoodAllergies = 'food_allergies',
  GutHealth = 'gut_health',
  HealthOptimization = 'health_optimization',
  HealthyAging = 'healthy_aging',
  HeartDisease = 'heart_disease',
  HormonalHealth = 'hormonal_health',
  IntegrativeFunctionalNutrition = 'integrative_functional_nutrition',
  KidneyStones = 'kidney_stones',
  MensHealth = 'mens_health',
  MetabolicHealth = 'metabolic_health',
  MindfulEating = 'mindful_eating',
  Osteoporosis = 'osteoporosis',
  PrediabetesDiabetes = 'prediabetes_diabetes',
  PrenatalNutrition = 'prenatal_nutrition',
  SportsPerformance = 'sports_performance',
  StressManagement = 'stress_management',
  ThyroidDisorders = 'thyroid_disorders',
  WeightConcerns = 'weight_concerns',
  WomensHealth = 'womens_health',
}

export type EhrCoachSpecialtyDef = {
  __typename?: 'EhrCoachSpecialtyDef'
  key: EhrCoachSpecialty
  name: Scalars['String']['output']
}

export enum EhrCoachState {
  Active = 'active',
  Inactive = 'inactive',
}

export type EhrDate = {
  __typename?: 'EhrDate'
  date: Scalars['ISO8601Date']['output']
  hasCrossKindRecurrence: Scalars['Boolean']['output']
  slots: Array<EhrSlot>
}

export enum EhrDoctorAssignmentState {
  Active = 'active',
  Inactive = 'inactive',
}

export enum EhrDoctorState {
  Active = 'active',
  Inactive = 'inactive',
}

export enum EhrGetHealthieInstanceKind {
  BerryStreet = 'berry_street',
  Nutrisense = 'nutrisense',
}

export type EhrProvider = {
  __typename?: 'EhrProvider'
  appointment: EhrAppointment
  coach?: Maybe<Coach>
  doctor?: Maybe<Doctor>
  id: Scalars['ID']['output']
  kind: EhrAppointmentProviderKind
  state: EhrAppointmentProviderState
}

export type EhrProviderKind = Coach | Doctor

export type EhrSlot = {
  __typename?: 'EhrSlot'
  providerId: Scalars['ID']['output']
  providerUserId?: Maybe<Scalars['ID']['output']>
  time: Scalars['ISO8601DateTime']['output']
}

export type EntryGlucose = {
  __typename?: 'EntryGlucose'
  /** @deprecated Removed in v4.0.2 */
  healthyRange: Array<Scalars['Float']['output']>
  /** @deprecated Removed in v4.0.2 */
  range: Array<Scalars['Float']['output']>
  values: Array<EntryGlucoseValue>
}

export type EntryGlucoseValue = {
  __typename?: 'EntryGlucoseValue'
  displayValue?: Maybe<Scalars['String']['output']>
  timestamp: Scalars['ISO8601DateTime']['output']
  value?: Maybe<Scalars['Float']['output']>
}

export type EntryStatistics = {
  __typename?: 'EntryStatistics'
  aucScore?: Maybe<Scalars['Float']['output']>
  glucose2hrDelta?: Maybe<Scalars['Float']['output']>
  glucoseDelta?: Maybe<Scalars['Float']['output']>
  glucoseMax?: Maybe<Scalars['String']['output']>
  glucoseMin?: Maybe<Scalars['String']['output']>
  glucoseScore?: Maybe<Scalars['Int']['output']>
  glucoseScore2hrDelta?: Maybe<Scalars['Int']['output']>
  glucoseScoreAuc?: Maybe<Scalars['Int']['output']>
  glucoseScoreDelta?: Maybe<Scalars['Int']['output']>
  glucoseScorePeak?: Maybe<Scalars['Int']['output']>
}

export type EstimateTaxAddress = {
  city: Scalars['String']['input']
  country?: InputMaybe<AddressCountries>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street: Scalars['String']['input']
  street2?: InputMaybe<Scalars['String']['input']>
  zipCode: Scalars['String']['input']
}

export type EstimatedPrice = {
  __typename?: 'EstimatedPrice'
  discount: Scalars['Float']['output']
  price: Scalars['Float']['output']
  total: Scalars['Float']['output']
}

export type EstimatedTax = {
  __typename?: 'EstimatedTax'
  estimatedTax: Scalars['Float']['output']
}

export type Event = Activity | JournalEntry | Meal | Measurement | Note

export type EventCollection = {
  __typename?: 'EventCollection'
  events: Array<Event>
}

export type Events = {
  __typename?: 'Events'
  filters: EventsFilters
}

export type EventsData = {
  __typename?: 'EventsData'
  events: EventCollection
}

export type EventsFilters = {
  __typename?: 'EventsFilters'
  order: Array<Scalars['String']['output']>
  orderBy: Array<Scalars['String']['output']>
  types: Array<KeyValuePairStringArray>
}

export type ExpandableModule = {
  __typename?: 'ExpandableModule'
  contentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  lessons?: Maybe<Array<Lesson>>
  position?: Maybe<Scalars['Int']['output']>
  progress?: Maybe<Progress>
}

export type ExpandableProgram = {
  __typename?: 'ExpandableProgram'
  contentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  modules?: Maybe<Array<ExpandableModule>>
  position?: Maybe<Scalars['Int']['output']>
  progress?: Maybe<Progress>
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag'
  enabled: Scalars['Boolean']['output']
  key: Scalars['String']['output']
}

export type File = {
  __typename?: 'File'
  createdAt: Scalars['ISO8601DateTime']['output']
  downloadFileUrl: Scalars['String']['output']
  fileName: Scalars['String']['output']
  fileType: Scalars['String']['output']
  fileUrl: Scalars['String']['output']
  id: Scalars['ID']['output']
  permanentUrl: Scalars['String']['output']
  tag?: Maybe<UserFileTag>
}

export type FileDynamicFilter = {
  field: FileDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum FileDynamicFilterField {
  Tag = 'tag',
}

export type FileDynamicFilterItem = {
  items: Array<FileDynamicFilter>
  operator: DynamicFilterOperator
}

export type FileMetadata = {
  byteSize: Scalars['Int']['input']
  checksum: Scalars['String']['input']
  contentType: Scalars['String']['input']
  filename: Scalars['String']['input']
}

export type FileSort = {
  direction: SortDirection
  field: FileSortField
}

export enum FileSortField {
  CreatedAt = 'created_at',
}

export enum FilterAppointmentsKind {
  /** Fetch all appointments */
  All = 'ALL',
  /** Fetch past appointments */
  Past = 'PAST',
  /** Fetch pending schedule appointments */
  PendingSchedule = 'PENDING_SCHEDULE',
  /** Fetch upcoming appointments */
  Upcoming = 'UPCOMING',
}

export type Followup = {
  __typename?: 'Followup'
  kind: SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswerFollowupKind
  parentAnswer: Answer
  parentQuestionKey: SurveysQuestionKey
  question: Question
}

export type FulfillmentConfiguration = {
  __typename?: 'FulfillmentConfiguration'
  sensorKind: UserSensorKind
  userId: Scalars['ID']['output']
}

export type GenerateAuthUrl = {
  __typename?: 'GenerateAuthUrl'
  url: Scalars['String']['output']
  userId: Scalars['String']['output']
}

export type GeneratePdf = {
  __typename?: 'GeneratePdf'
  id: Scalars['ID']['output']
  pdfUrl?: Maybe<Scalars['String']['output']>
}

export type GenerateSdkToken = {
  __typename?: 'GenerateSdkToken'
  token: Scalars['String']['output']
}

export type GlucoseDailyScore = {
  __typename?: 'GlucoseDailyScore'
  today: DailyScore
}

export type GlucoseStatistics = {
  __typename?: 'GlucoseStatistics'
  today: Stat
}

export type GlucoseThresholdPreset = {
  __typename?: 'GlucoseThresholdPreset'
  description: Scalars['String']['output']
  high: Scalars['Int']['output']
  low: Scalars['Int']['output']
  name: Scalars['String']['output']
}

export type Goal = {
  __typename?: 'Goal'
  description?: Maybe<Scalars['String']['output']>
  kind: UserGoalKind
  title: Scalars['String']['output']
}

export type GoalMetric = {
  __typename?: 'GoalMetric'
  highThresholdValue?: Maybe<Scalars['Float']['output']>
  kind: UserGoalMetricKind
  lowThresholdValue?: Maybe<Scalars['Float']['output']>
  primary: Scalars['Boolean']['output']
  section: Scalars['String']['output']
  statKey: Scalars['String']['output']
}

export type GoalMetricOption = {
  __typename?: 'GoalMetricOption'
  text: Scalars['String']['output']
  value: UserGoalMetricKind
}

export type GoalOption = {
  __typename?: 'GoalOption'
  text: Scalars['String']['output']
  value: UserGoalKind
}

export type GoogleFit = {
  __typename?: 'GoogleFit'
  ignore: Array<Scalars['String']['output']>
}

export type HealthDataConfig = {
  __typename?: 'HealthDataConfig'
  measurementSourceDefs: Array<HealthDataMeasurementSourceDef>
  measurementTypeDefs: Array<HealthDataMeasurementTypeDef>
}

export enum HealthDataLabResultSource {
  Chatbot = 'chatbot',
  Nutrisense = 'nutrisense',
  Terra = 'terra',
}

export enum HealthDataMeasurementSource {
  Dexcom = 'dexcom',
  Fitbit = 'fitbit',
  Freestylelibre = 'freestylelibre',
  Garmin = 'garmin',
  GoogleHealth = 'google_health',
  Googlefit = 'googlefit',
  HealthConnect = 'health_connect',
  Healthkit = 'healthkit',
  Ketomojo = 'ketomojo',
  LibreLinkup = 'libre_linkup',
  Lingo = 'lingo',
  Nutrisense = 'nutrisense',
  Oura = 'oura',
  Whoop = 'whoop',
}

export type HealthDataMeasurementSourceDef = {
  __typename?: 'HealthDataMeasurementSourceDef'
  iconDef?: Maybe<IconDef>
  key: HealthDataMeasurementSource
  label: Scalars['String']['output']
  providesDailyMeasurements: Scalars['Boolean']['output']
  sourceTags: Array<Scalars['String']['output']>
}

export enum HealthDataMeasurementType {
  Appetite = 'appetite',
  BloodGlucose = 'blood_glucose',
  BloodKetones = 'blood_ketones',
  BloodPressure = 'blood_pressure',
  BodyFatPercentage = 'body_fat_percentage',
  BodyTemperature = 'body_temperature',
  BreathKetones = 'breath_ketones',
  CyclingDistance = 'cycling_distance',
  Energy = 'energy',
  ExerciseTime = 'exercise_time',
  FlightsClimbed = 'flights_climbed',
  Focus = 'focus',
  Glucose = 'glucose',
  Mood = 'mood',
  RunningDistance = 'running_distance',
  StepCount = 'step_count',
  Stress = 'stress',
  SwimmingDistance = 'swimming_distance',
  Weight = 'weight',
}

export type HealthDataMeasurementTypeDef = {
  __typename?: 'HealthDataMeasurementTypeDef'
  icon?: Maybe<UiIcon>
  /** @deprecated Use icon instead */
  iconDef?: Maybe<IconDef>
  isDailyMeasurement: Scalars['Boolean']['output']
  isJournalMeasurement: Scalars['Boolean']['output']
  key: HealthDataMeasurementType
  label: Scalars['String']['output']
}

export enum HealthDataMetricBiomarker {
  AlanineTransferase = 'alanine_transferase',
  Albumin = 'albumin',
  AlkalinePhosphatase = 'alkaline_phosphatase',
  Amylase = 'amylase',
  ApolipoproteinA1 = 'apolipoprotein_a1',
  ApolipoproteinB = 'apolipoprotein_b',
  ArachidonicAcid = 'arachidonic_acid',
  ArachidonicAcidEpaRatio = 'arachidonic_acid_epa_ratio',
  AspartateTransferase = 'aspartate_transferase',
  Basophils = 'basophils',
  BloodUreaNitrogen = 'blood_urea_nitrogen',
  Bmi = 'bmi',
  BunCreatinineRatio = 'bun_creatinine_ratio',
  CPeptide = 'c_peptide',
  Calcium = 'calcium',
  CarbonDioxide = 'carbon_dioxide',
  Chloride = 'chloride',
  Creatinine = 'creatinine',
  Dha = 'dha',
  DiastolicBloodPressure = 'diastolic_blood_pressure',
  Dpa = 'dpa',
  Eosinophils = 'eosinophils',
  Epa = 'epa',
  EpaDpaDha = 'epa_dpa_dha',
  EstimatedGfr = 'estimated_gfr',
  FastedGlucose = 'fasted_glucose',
  FastedInsulin = 'fasted_insulin',
  Ferritin = 'ferritin',
  FolateRbc = 'folate_rbc',
  FreeT3 = 'free_t3',
  FreeT4 = 'free_t4',
  HbA1c = 'hb_a1c',
  HdlCholesterol = 'hdl_cholesterol',
  HdlLarge = 'hdl_large',
  Height = 'height',
  Hematocrit = 'hematocrit',
  Hemoglobin = 'hemoglobin',
  Homocysteine = 'homocysteine',
  HsCrp = 'hs_crp',
  IronPercentSaturation = 'iron_percent_saturation',
  IronTotal = 'iron_total',
  LdlCholesterol = 'ldl_cholesterol',
  LdlParticleNumber = 'ldl_particle_number',
  LdlPattern = 'ldl_pattern',
  LdlSmall = 'ldl_small',
  LinoleicAcid = 'linoleic_acid',
  Lipase = 'lipase',
  LipoproteinA = 'lipoprotein_a',
  Lymphocytes = 'lymphocytes',
  MagnesiumRbc = 'magnesium_rbc',
  Mch = 'mch',
  Mchc = 'mchc',
  MeanCorpuscularVolume = 'mean_corpuscular_volume',
  MeanPlateletVolume = 'mean_platelet_volume',
  MethylmalonicAcid = 'methylmalonic_acid',
  Monocytes = 'monocytes',
  NonHdlCholesterol = 'non_hdl_cholesterol',
  Omega_3Total = 'omega_3_total',
  Omega_6Omega_3Ratio = 'omega_6_omega_3_ratio',
  Omega_6Total = 'omega_6_total',
  PlateletCount = 'platelet_count',
  Potassium = 'potassium',
  RbcBlood = 'rbc_blood',
  Rdw = 'rdw',
  ReverseT3 = 'reverse_t3',
  Selenium = 'selenium',
  Sodium = 'sodium',
  SystolicBloodPressure = 'systolic_blood_pressure',
  Tibc = 'tibc',
  TotalCholesterol = 'total_cholesterol',
  TotalCholesterolHdlRatio = 'total_cholesterol_hdl_ratio',
  TpoAntibodies = 'tpo_antibodies',
  Triglycerides = 'triglycerides',
  Tsh = 'tsh',
  UricAcid = 'uric_acid',
  VitaminB12 = 'vitamin_b12',
  VitaminD = 'vitamin_d',
  VitaminD_25Oh = 'vitamin_d_25_oh',
  WbcBlood = 'wbc_blood',
  Weight = 'weight',
  ZincRbc = 'zinc_rbc',
}

export type HealthDataReport = {
  __typename?: 'HealthDataReport'
  conversation?: Maybe<ChatbotConversation>
  createdAt: Scalars['ISO8601DateTime']['output']
  endDate: Scalars['ISO8601Date']['output']
  focusAreas: Array<HealthDataReportFocusArea>
  id: Scalars['ID']['output']
  kind: HealthDataReportKind
  lastState: HealthDataReportState
  readAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  reportData?: Maybe<Scalars['String']['output']>
  startDate: Scalars['ISO8601Date']['output']
}

export type HealthDataReportCollection = {
  __typename?: 'HealthDataReportCollection'
  pageCount?: Maybe<Scalars['Int']['output']>
  reports: Array<HealthDataReport>
  totalCount: Scalars['Int']['output']
}

export type HealthDataReportDynamicFilter = {
  field: HealthDataReportDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum HealthDataReportDynamicFilterField {
  Kind = 'kind',
}

export type HealthDataReportDynamicFilterItem = {
  items: Array<HealthDataReportDynamicFilter>
  operator: DynamicFilterOperator
}

export enum HealthDataReportFocusArea {
  MetabolicHealth = 'metabolic_health',
  MetabolicHealthBlocks = 'metabolic_health_blocks',
  MovementAndEnergy = 'movement_and_energy',
  MovementAndEnergyBlocks = 'movement_and_energy_blocks',
  RecoveryAndStress = 'recovery_and_stress',
  RecoveryAndStressBlocks = 'recovery_and_stress_blocks',
}

export enum HealthDataReportKind {
  AiHealth = 'ai_health',
  Custom = 'custom',
  CustomBlocks = 'custom_blocks',
  DailyReview = 'daily_review',
  MonthlySummary = 'monthly_summary',
  WeeklyNutrition = 'weekly_nutrition',
  WeeklyTrend = 'weekly_trend',
}

export type HealthDataReportSort = {
  direction: SortDirection
  field: HealthDataReportSortField
}

export enum HealthDataReportSortField {
  CreatedAt = 'created_at',
}

export type HealthDataReportState = {
  __typename?: 'HealthDataReportState'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  kind: HealthDataReportStateKind
}

export enum HealthDataReportStateKind {
  BatchSubmitted = 'batch_submitted',
  Completed = 'completed',
  Created = 'created',
  DataFetched = 'data_fetched',
  Deleted = 'deleted',
  Failed = 'failed',
  PdfGenerated = 'pdf_generated',
}

export type HealthKit = {
  __typename?: 'HealthKit'
  ignore: Array<Scalars['String']['output']>
  sourceIgnore: Array<Scalars['String']['output']>
}

export type HealthKitData = {
  appleExerciseTime?: InputMaybe<Array<NumericValue>>
  bloodGlucose?: InputMaybe<Array<NumericValue>>
  bloodPressure?: InputMaybe<Array<NumericValue>>
  bodyFatPercentage?: InputMaybe<Array<NumericValue>>
  bodyTemperature?: InputMaybe<Array<NumericValue>>
  dailyDistanceCycling?: InputMaybe<Array<NumericValue>>
  dailyDistanceSwimming?: InputMaybe<Array<NumericValue>>
  dailyDistanceWalkingRunning?: InputMaybe<Array<NumericValue>>
  dailyFlightsClimbed?: InputMaybe<Array<NumericValue>>
  dailyStepCount?: InputMaybe<Array<NumericValue>>
  heartRate?: InputMaybe<Array<NumericValue>>
  respiratoryRate?: InputMaybe<Array<NumericValue>>
  sleep?: InputMaybe<Array<StringValue>>
  source?: InputMaybe<Scalars['String']['input']>
  weight?: InputMaybe<Array<NumericValue>>
  workout?: InputMaybe<Array<Workout>>
}

export type HealthMetric = {
  __typename?: 'HealthMetric'
  date: Scalars['ISO8601Date']['output']
  id: Scalars['ID']['output']
  kind: HealthDataMetricBiomarker
  label: Scalars['String']['output']
  unit?: Maybe<Scalars['String']['output']>
  value: Scalars['Float']['output']
}

export type HealthMetricCollection = {
  __typename?: 'HealthMetricCollection'
  healthMetrics: Array<HealthMetric>
  measurements: Array<Measurement>
}

export type HealthMetricData = {
  kind: HealthDataMetricBiomarker
  value: Scalars['Float']['input']
}

export type HealthMetricType = {
  __typename?: 'HealthMetricType'
  key: HealthMetricsParam
  kind: HealthMetricsKind
  label: Scalars['String']['output']
  unit?: Maybe<Scalars['String']['output']>
}

export enum HealthMetricsKind {
  Biomarker = 'biomarker',
  Measurement = 'measurement',
}

export enum HealthMetricsParam {
  AlanineTransferase = 'alanine_transferase',
  Albumin = 'albumin',
  AlkalinePhosphatase = 'alkaline_phosphatase',
  Amylase = 'amylase',
  ApolipoproteinA1 = 'apolipoprotein_a1',
  ApolipoproteinB = 'apolipoprotein_b',
  ArachidonicAcid = 'arachidonic_acid',
  ArachidonicAcidEpaRatio = 'arachidonic_acid_epa_ratio',
  AspartateTransferase = 'aspartate_transferase',
  Basophils = 'basophils',
  BloodPressure = 'blood_pressure',
  BloodUreaNitrogen = 'blood_urea_nitrogen',
  Bmi = 'bmi',
  BunCreatinineRatio = 'bun_creatinine_ratio',
  CPeptide = 'c_peptide',
  Calcium = 'calcium',
  CarbonDioxide = 'carbon_dioxide',
  Chloride = 'chloride',
  Creatinine = 'creatinine',
  Dha = 'dha',
  Dpa = 'dpa',
  Eosinophils = 'eosinophils',
  Epa = 'epa',
  EpaDpaDha = 'epa_dpa_dha',
  EstimatedGfr = 'estimated_gfr',
  FastedGlucose = 'fasted_glucose',
  FastedInsulin = 'fasted_insulin',
  Ferritin = 'ferritin',
  FolateRbc = 'folate_rbc',
  FreeT3 = 'free_t3',
  FreeT4 = 'free_t4',
  HbA1c = 'hb_a1c',
  HdlCholesterol = 'hdl_cholesterol',
  HdlLarge = 'hdl_large',
  Height = 'height',
  Hematocrit = 'hematocrit',
  Hemoglobin = 'hemoglobin',
  Homocysteine = 'homocysteine',
  HsCrp = 'hs_crp',
  IronPercentSaturation = 'iron_percent_saturation',
  IronTotal = 'iron_total',
  LdlCholesterol = 'ldl_cholesterol',
  LdlParticleNumber = 'ldl_particle_number',
  LdlPattern = 'ldl_pattern',
  LdlSmall = 'ldl_small',
  LinoleicAcid = 'linoleic_acid',
  Lipase = 'lipase',
  LipoproteinA = 'lipoprotein_a',
  Lymphocytes = 'lymphocytes',
  MagnesiumRbc = 'magnesium_rbc',
  Mch = 'mch',
  Mchc = 'mchc',
  MeanCorpuscularVolume = 'mean_corpuscular_volume',
  MeanPlateletVolume = 'mean_platelet_volume',
  MethylmalonicAcid = 'methylmalonic_acid',
  Monocytes = 'monocytes',
  NonHdlCholesterol = 'non_hdl_cholesterol',
  Omega_3Total = 'omega_3_total',
  Omega_6Omega_3Ratio = 'omega_6_omega_3_ratio',
  Omega_6Total = 'omega_6_total',
  PlateletCount = 'platelet_count',
  Potassium = 'potassium',
  RbcBlood = 'rbc_blood',
  Rdw = 'rdw',
  ReverseT3 = 'reverse_t3',
  Selenium = 'selenium',
  Sodium = 'sodium',
  Tibc = 'tibc',
  TotalCholesterol = 'total_cholesterol',
  TotalCholesterolHdlRatio = 'total_cholesterol_hdl_ratio',
  TpoAntibodies = 'tpo_antibodies',
  Triglycerides = 'triglycerides',
  Tsh = 'tsh',
  UricAcid = 'uric_acid',
  VitaminB12 = 'vitamin_b12',
  VitaminD = 'vitamin_d',
  VitaminD_25Oh = 'vitamin_d_25_oh',
  WbcBlood = 'wbc_blood',
  Weight = 'weight',
  ZincRbc = 'zinc_rbc',
}

export type HealthSettings = {
  __typename?: 'HealthSettings'
  dashboardGraphOptions: Array<StringSelect>
  fastingEnd: Scalars['Int']['output']
  fastingStart: Scalars['Int']['output']
  glucoseHighOptions: Array<NumericalSelect>
  glucoseLowOptions: Array<NumericalSelect>
  glucoseSourceOptions: Array<StringSelect>
  glucoseThresholdPresets: Array<GlucoseThresholdPreset>
  ketoneHighOptions: Array<NumericalSelect>
  ketoneLowOptions: Array<NumericalSelect>
  macroGoalSettings: MacroGoalSettings
  trackingModeOptions: Array<StringSelect>
  unitSystemOptions: Array<StringSelect>
}

export type History = {
  __typename?: 'History'
  filters: HistoryFilters
}

export type HistoryFilters = {
  __typename?: 'HistoryFilters'
  order: Array<Scalars['String']['output']>
  orderBy: Array<Scalars['String']['output']>
  types: Array<KeyValuePairStringArray>
}

export type HoursInterval = {
  __typename?: 'HoursInterval'
  glucoseCheckOptions: Array<NumericalSelect>
}

export type IconDef = {
  __typename?: 'IconDef'
  name: Scalars['String']['output']
  pack: Scalars['String']['output']
}

export type ImageDescription = {
  __typename?: 'ImageDescription'
  description: Scalars['String']['output']
}

export type Ingredient = {
  __typename?: 'Ingredient'
  calories: Scalars['Float']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  nutrition: Array<KeyValuePairFloat>
  servingAmount: Scalars['Float']['output']
  servingUnits: Scalars['String']['output']
  thirdPartyIngredientId?: Maybe<Scalars['String']['output']>
  thirdPartyIngredientSource?: Maybe<IngredientSource>
}

export type IngredientCollection = {
  __typename?: 'IngredientCollection'
  ingredients: Array<Ingredient>
}

export type IngredientData = {
  calories: Scalars['Float']['input']
  description: Scalars['String']['input']
  imageUrl?: InputMaybe<Scalars['String']['input']>
  ingredientId?: InputMaybe<Scalars['ID']['input']>
  mealId?: InputMaybe<Scalars['ID']['input']>
  nutrition: Array<KeyValueFloat>
  servingAmount: Scalars['Float']['input']
  servingUnits: Scalars['String']['input']
  thirdPartyIngredientId?: InputMaybe<Scalars['String']['input']>
  thirdPartyIngredientSource?: InputMaybe<IngredientSource>
}

export type IngredientFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>
  endHour?: InputMaybe<Scalars['Int']['input']>
  excludeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  favorite?: InputMaybe<Scalars['Boolean']['input']>
  graph?: InputMaybe<Scalars['String']['input']>
  includeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  order?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  scope?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  startHour?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<KeyValueStringArray>>
}

export enum IngredientSource {
  BiteAi = 'biteAI',
  Myfitnesspal = 'myfitnesspal',
  Nutritionix = 'nutritionix',
}

export type InlineAlert = {
  __typename?: 'InlineAlert'
  message: Scalars['String']['output']
  type: UiInlineAlert
}

export type InsuranceCardSubmission = {
  __typename?: 'InsuranceCardSubmission'
  id: Scalars['ID']['output']
  insurancePolicyStateId: Scalars['ID']['output']
  submittedAt: Scalars['ISO8601DateTime']['output']
}

export type InsuranceKind = {
  __typename?: 'InsuranceKind'
  insuranceSurveyAnswer: Scalars['String']['output']
  key: UserInsurancePolicyKind
  title: Scalars['String']['output']
}

export type InsuranceKinds = {
  __typename?: 'InsuranceKinds'
  kindDefs: Array<UserInsurancePolicyKindDef>
}

export type InsurancePolicy = {
  __typename?: 'InsurancePolicy'
  declined: Scalars['Boolean']['output']
  eligible: Scalars['Boolean']['output']
  hasUnitsLeft: Scalars['Boolean']['output']
  hasUnlimitedCalls: Scalars['Boolean']['output']
  hasUnusedCalls: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  inReview: Scalars['Boolean']['output']
  initialAppointmentKind?: Maybe<ClientConfigEhrAppointmentKind>
  last: Scalars['Boolean']['output']
  lastState?: Maybe<InsurancePolicyState>
  states?: Maybe<Array<InsurancePolicyState>>
  unitsAuthorized?: Maybe<Scalars['Int']['output']>
  unitsLeft?: Maybe<Scalars['Int']['output']>
  unitsOccurred?: Maybe<Scalars['Int']['output']>
  unitsUsed?: Maybe<Scalars['Int']['output']>
}

export type InsurancePolicyCollection = {
  __typename?: 'InsurancePolicyCollection'
  canCreateNewPolicy: Scalars['Boolean']['output']
  insurancePolicies: Array<InsurancePolicy>
}

export type InsurancePolicyState = {
  __typename?: 'InsurancePolicyState'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  kind: UserInsurancePolicyStateKind
  reason?: Maybe<Scalars['String']['output']>
}

export type IntegrationUser = {
  __typename?: 'IntegrationUser'
  accessToken: Scalars['String']['output']
  accessTokenExpirationDate: Scalars['ISO8601DateTime']['output']
  idToken: Scalars['String']['output']
  refreshToken: Scalars['String']['output']
}

export type IntegrationUserSetting = {
  accessToken: Scalars['String']['input']
  accessTokenExpirationDate: Scalars['ISO8601DateTime']['input']
  idToken?: InputMaybe<Scalars['String']['input']>
  refreshToken: Scalars['String']['input']
}

export type IntegrationsSync = {
  __typename?: 'IntegrationsSync'
  dexcomUser?: Maybe<IntegrationUser>
  ketoMojoUser?: Maybe<IntegrationUser>
  lastSyncedDexcom?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastSyncedHealth?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastSyncedKetoMojo?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type IntegrationsSyncSettings = {
  dexcomUser?: InputMaybe<IntegrationUserSetting>
  ketoMojoUser?: InputMaybe<IntegrationUserSetting>
  lastSyncedDexcom?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  lastSyncedHealth?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  lastSyncedKetoMojo?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type Interval = {
  __typename?: 'Interval'
  description: Scalars['String']['output']
  key: BillingProductInterval
  monthsInOneBillingCycle?: Maybe<Scalars['Int']['output']>
  prefix: Scalars['String']['output']
  suffix: Scalars['String']['output']
}

export type IntroScreen = {
  __typename?: 'IntroScreen'
  backgroundImageUrl?: Maybe<Scalars['String']['output']>
  footnote?: Maybe<Scalars['String']['output']>
  header: Scalars['String']['output']
  icon?: Maybe<UiIcon>
  imageUrl?: Maybe<Scalars['String']['output']>
  inlineAlert?: Maybe<InlineAlert>
  /** @deprecated use intro_markdown */
  intro?: Maybe<Scalars['String']['output']>
  introMarkdown?: Maybe<Scalars['String']['output']>
}

export type Invoice = {
  __typename?: 'Invoice'
  created: Scalars['ISO8601DateTime']['output']
  downloadUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  latestCharge?: Maybe<Charge>
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  periodStart: Scalars['ISO8601DateTime']['output']
  /** @deprecated not used anymore */
  primaryInvoiceLine?: Maybe<InvoiceLine>
  primaryProduct: ProductMin
  receiptNumber?: Maybe<Scalars['String']['output']>
  status: InvoiceStatus
  stripeId: Scalars['String']['output']
  /** @deprecated use status enum field */
  stripeStatus: Scalars['String']['output']
  subscription?: Maybe<Subscription>
  total?: Maybe<Scalars['Float']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  user: User
}

export type InvoiceLine = {
  __typename?: 'InvoiceLine'
  id: Scalars['ID']['output']
  plan?: Maybe<Plan>
}

export enum InvoiceStatus {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  Uncollectible = 'uncollectible',
  Void = 'void',
}

export type JournalConfig = {
  __typename?: 'JournalConfig'
  measurementTypes: Array<MeasurementType>
  range: JournalRange
}

export type JournalEntry = {
  __typename?: 'JournalEntry'
  body: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy: Scalars['String']['output']
  creatorId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  kind: NoteKind
  measurements?: Maybe<Array<Measurement>>
  occurredAt: Scalars['ISO8601DateTime']['output']
  score?: Maybe<Scalars['Float']['output']>
  title: Scalars['String']['output']
}

export type JournalMeasurementsData = {
  id?: InputMaybe<Scalars['ID']['input']>
  type: Scalars['String']['input']
  value: Scalars['Int']['input']
}

export type JournalRange = {
  __typename?: 'JournalRange'
  max: Scalars['Int']['output']
  min: Scalars['Int']['output']
}

export type KetoMojoData = {
  readingId: Scalars['String']['input']
  readingTimestamp: Scalars['ISO8601DateTime']['input']
  readingType: Scalars['String']['input']
  readingUnit?: InputMaybe<Scalars['String']['input']>
  readingValue?: InputMaybe<Scalars['Float']['input']>
}

export type KeyValueFloat = {
  key: Scalars['String']['input']
  value: Scalars['Float']['input']
}

export type KeyValuePairFloat = {
  __typename?: 'KeyValuePairFloat'
  key: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type KeyValuePairString = {
  __typename?: 'KeyValuePairString'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type KeyValuePairStringArray = {
  __typename?: 'KeyValuePairStringArray'
  key: Scalars['String']['output']
  value: Array<Scalars['String']['output']>
}

export type KeyValueString = {
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type KeyValueStringArray = {
  key: Scalars['String']['input']
  value: Array<Scalars['String']['input']>
}

export type LabResult = {
  __typename?: 'LabResult'
  createdAt: Scalars['ISO8601DateTime']['output']
  date: Scalars['ISO8601Date']['output']
  healthMetrics: Array<HealthMetric>
  id: Scalars['ID']['output']
  /** @deprecated Use healthMetrics field instead */
  measurements: Array<Measurement>
  source: HealthDataLabResultSource
}

export type LabResultCollection = {
  __typename?: 'LabResultCollection'
  labResults: Array<LabResult>
  labResultsProcessing: Array<LabResultProcessing>
}

export type LabResultProcessing = {
  __typename?: 'LabResultProcessing'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  source: HealthDataLabResultSource
}

export type LabResultsConfig = {
  __typename?: 'LabResultsConfig'
  fileUploadLimitMb: Scalars['Int']['output']
}

export type LegalPolicy = {
  __typename?: 'LegalPolicy'
  kind: LegalPolicyConsentKind
  markdown?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type LegalPolicyConsent = {
  __typename?: 'LegalPolicyConsent'
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  kind: LegalPolicyConsentKind
  state: LegalPolicyConsentState
}

export enum LegalPolicyConsentKind {
  AiProcessing = 'ai_processing',
  CompoundedSemaglutide = 'compounded_semaglutide',
  ConsumerHealthDataPrivacyPolicy = 'consumer_health_data_privacy_policy',
  DexcomDataSharing = 'dexcom_data_sharing',
  FloridaDigitalBillOfRights = 'florida_digital_bill_of_rights',
  FuturePayments = 'future_payments',
  HipaaAuthorization = 'hipaa_authorization',
  MedicalDisclaimer = 'medical_disclaimer',
  NorthwesternPhiConsent = 'northwestern_phi_consent',
  OngoingCareNonRefundable = 'ongoing_care_non_refundable',
  PhoneNumber = 'phone_number',
  PhoneNumberMarketing = 'phone_number_marketing',
  PrescriptionRefill = 'prescription_refill',
  PrivacyPolicy = 'privacy_policy',
  RecurringSubscription = 'recurring_subscription',
  Telehealth = 'telehealth',
  TermsOfUse = 'terms_of_use',
}

export enum LegalPolicyConsentState {
  Accepted = 'accepted',
  Invalidated = 'invalidated',
}

export type LegalPolicyConsentStatus = {
  __typename?: 'LegalPolicyConsentStatus'
  kind: LegalPolicyConsentKind
  lastPolicyConsent?: Maybe<LegalPolicyConsent>
  policy: LegalPolicy
  required: Scalars['Boolean']['output']
}

export type LegalPolicyConsentStatuses = {
  __typename?: 'LegalPolicyConsentStatuses'
  statuses: Array<LegalPolicyConsentStatus>
}

export type Lesson = {
  __typename?: 'Lesson'
  contentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  position?: Maybe<Scalars['Int']['output']>
  progress?: Maybe<Progress>
}

export type Link = {
  __typename?: 'Link'
  deepLink?: Maybe<Scalars['String']['output']>
  text: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type ListFiles = {
  __typename?: 'ListFiles'
  files: Array<File>
  pageCount?: Maybe<Scalars['Int']['output']>
  totalCount: Scalars['Int']['output']
}

export type ListFilters = {
  __typename?: 'ListFilters'
  order: Array<Scalars['String']['output']>
  orderBy: Array<Scalars['String']['output']>
  types: Array<Scalars['String']['output']>
}

/** Autogenerated return type of ListPlansAction. */
export type ListPlansActionPayload = {
  __typename?: 'ListPlansActionPayload'
  insurancePlans: Array<InsuranceKind>
}

export type ListProviders = {
  __typename?: 'ListProviders'
  providers: Array<Provider>
}

export type LiveNotification = {
  __typename?: 'LiveNotification'
  actionButtonLabel: Scalars['String']['output']
  actionKind: NotificationEngineNotificationActionKind
  content: Scalars['String']['output']
  dismissButtonLabel: Scalars['String']['output']
  dismissible: Scalars['Boolean']['output']
  icon?: Maybe<UiIcon>
  id: Scalars['ID']['output']
  imageUrl?: Maybe<Scalars['String']['output']>
  liveSurfaceKind: NotificationEngineNotificationLiveSurfaceKind
  notification?: Maybe<Notification>
  payload: Scalars['JSON']['output']
  priority: Scalars['Int']['output']
  screen: NotificationEngineScreen
  templateKind: NotificationEngineNotificationTemplateKind
  title?: Maybe<Scalars['String']['output']>
}

export type LiveNotificationCollection = {
  __typename?: 'LiveNotificationCollection'
  notifications: Array<LiveNotification>
}

export type LiveNotificationMin = {
  __typename?: 'LiveNotificationMin'
  id: Scalars['ID']['output']
  notification?: Maybe<Notification>
}

export type Macro = {
  __typename?: 'Macro'
  indent: Scalars['Int']['output']
  name: Scalars['String']['output']
}

export type MacroGoalSettings = {
  __typename?: 'MacroGoalSettings'
  caloriesMax: Scalars['Int']['output']
  carbsMax: Scalars['Int']['output']
  fatMax: Scalars['Int']['output']
  proteinMax: Scalars['Int']['output']
}

export type MacroGoals = {
  __typename?: 'MacroGoals'
  calories: Scalars['Int']['output']
  carbs: Scalars['Int']['output']
  fat: Scalars['Int']['output']
  netCarbs?: Maybe<Scalars['Int']['output']>
  protein: Scalars['Int']['output']
}

export type MacroGoalsDaily = {
  calories?: InputMaybe<Scalars['Int']['input']>
  carbs?: InputMaybe<Scalars['Int']['input']>
  fat?: InputMaybe<Scalars['Int']['input']>
  netCarbs?: InputMaybe<Scalars['Int']['input']>
  protein?: InputMaybe<Scalars['Int']['input']>
}

export type MarketingInfo = {
  utm?: InputMaybe<Scalars['JSON']['input']>
}

export type Meal = {
  __typename?: 'Meal'
  avatar?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy: User
  description: Scalars['String']['output']
  favorite: Scalars['Boolean']['output']
  generatedOccurredAt?: Maybe<Scalars['Boolean']['output']>
  glucose: EntryGlucose
  id: Scalars['ID']['output']
  ingredients: Array<Ingredient>
  kind: MealKind
  nutrition: Array<KeyValuePairFloat>
  occurredAt: Scalars['ISO8601DateTime']['output']
  source: MealSource
  statistics: EntryStatistics
  /** @deprecated use kind enum field */
  time?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  /** @deprecated use kind enum field */
  type: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type MealCollection = {
  __typename?: 'MealCollection'
  meals: Array<Meal>
}

export type MealFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>
  endHour?: InputMaybe<Scalars['Int']['input']>
  excludeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  favorite?: InputMaybe<Scalars['Boolean']['input']>
  graph?: InputMaybe<Scalars['String']['input']>
  includeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  order?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  scope?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  startHour?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<KeyValueStringArray>>
}

export enum MealKind {
  Breakfast = 'breakfast',
  Dessert = 'dessert',
  Dinner = 'dinner',
  Drink = 'drink',
  Lunch = 'lunch',
  Snack = 'snack',
  Supplement = 'supplement',
  Unknown = 'unknown',
  UnknownDeprecated = 'unknown_deprecated',
}

export enum MealSource {
  Dexcom = 'dexcom',
  HealthPortal = 'health_portal',
  MobileApp = 'mobile_app',
  MyFitnessPal = 'my_fitness_pal',
}

export type Meals = {
  __typename?: 'Meals'
  filters: ListFilters
}

export type Measurement = {
  __typename?: 'Measurement'
  createdAt: Scalars['ISO8601DateTime']['output']
  cumulative: Scalars['Boolean']['output']
  description: Scalars['String']['output']
  displayValue?: Maybe<Scalars['String']['output']>
  externalSource?: Maybe<Scalars['String']['output']>
  healthDataType: HealthDataMeasurementType
  id: Scalars['ID']['output']
  interpolated: Scalars['Boolean']['output']
  occurredAt: Scalars['ISO8601DateTime']['output']
  scan?: Maybe<Scan>
  timestamp: Scalars['ISO8601DateTime']['output']
  title: Scalars['String']['output']
  type: Scalars['String']['output']
  units: Scalars['String']['output']
  value?: Maybe<Scalars['Float']['output']>
  values?: Maybe<MeasurementMultiValue>
}

export type MeasurementCollection = {
  __typename?: 'MeasurementCollection'
  measurements: Array<Measurement>
}

export type MeasurementConfig = {
  __typename?: 'MeasurementConfig'
  imperial: MeasurementConfigUnit
  metric: MeasurementConfigUnit
  name: Scalars['String']['output']
}

export type MeasurementConfigUnit = {
  __typename?: 'MeasurementConfigUnit'
  maxThreshold?: Maybe<Scalars['Float']['output']>
  minThreshold?: Maybe<Scalars['Float']['output']>
  precision: Scalars['Int']['output']
  units: Scalars['String']['output']
}

export type MeasurementData = {
  id?: InputMaybe<Scalars['ID']['input']>
  time?: InputMaybe<Scalars['String']['input']>
  type: Scalars['String']['input']
  value?: InputMaybe<Scalars['Float']['input']>
  values?: InputMaybe<MultiValue>
}

export type MeasurementFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>
  endHour?: InputMaybe<Scalars['Int']['input']>
  excludeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  favorite?: InputMaybe<Scalars['Boolean']['input']>
  graph?: InputMaybe<Scalars['String']['input']>
  includeTypes?: InputMaybe<Array<Scalars['String']['input']>>
  order?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  scope?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  startHour?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<KeyValueStringArray>>
}

export type MeasurementMultiValue = BloodPressureMeasurement | SingleValueMeasurement

export type MeasurementType = {
  __typename?: 'MeasurementType'
  reverse?: Maybe<Scalars['Boolean']['output']>
  type: Scalars['String']['output']
}

export type MetricOption = {
  __typename?: 'MetricOption'
  description: Scalars['String']['output']
  imperial?: Maybe<UnitOption>
  infoText?: Maybe<Scalars['String']['output']>
  kind: ActionGoalMetricKind
  metric?: Maybe<UnitOption>
  statKey?: Maybe<Scalars['String']['output']>
  supportsMetricValue: Scalars['Boolean']['output']
  trendSection?: Maybe<Scalars['String']['output']>
  valuePrefix?: Maybe<Scalars['String']['output']>
}

export type MfpCreditGlobalPool = {
  __typename?: 'MfpCreditGlobalPool'
  available: Scalars['Boolean']['output']
}

export enum MobileAppFeature {
  AccountDetailsEditName = 'account_details_edit_name',
  ActivateOwnSensor = 'activate_own_sensor',
  AdminAccess = 'admin_access',
  AdminImpersonate = 'admin_impersonate',
  BiosensorAccess = 'biosensor_access',
  DailyGlucoseScore = 'daily_glucose_score',
  DexcomG6ApiIntegration = 'dexcom_g6_api_integration',
  DexcomG7ApiIntegration = 'dexcom_g7_api_integration',
  DexcomSteloApiIntegration = 'dexcom_stelo_api_integration',
  GlucoseInsights = 'glucose_insights',
  GlucoseLastReadingList = 'glucose_last_reading_list',
  GlucosePatternsNotifications = 'glucose_patterns_notifications',
  HealthCoachingVideoCalls = 'health_coaching_video_calls',
  HomeInitialScreen = 'home_initial_screen',
  InsuranceCoveredVideoCalls = 'insurance_covered_video_calls',
  ViewGlucoseCharts = 'view_glucose_charts',
}

export type MobileUserProperty = {
  __typename?: 'MobileUserProperty'
  id: Scalars['Int']['output']
  kind: UserPropertyKind
  userId: Scalars['ID']['output']
  value: Scalars['String']['output']
}

export type Module = {
  __typename?: 'Module'
  contentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  position?: Maybe<Scalars['Int']['output']>
  progress?: Maybe<Progress>
}

export type MultiValue = {
  diastolic?: InputMaybe<Scalars['Float']['input']>
  systolic?: InputMaybe<Scalars['Float']['input']>
  value?: InputMaybe<Scalars['Float']['input']>
}

export type MutationType = {
  __typename?: 'MutationType'
  acceptLegalPolicy: LegalPolicyConsent
  answerReferredToPurchase: Success
  applyFreeEhrAppointment?: Maybe<EhrAppointment>
  bulkMarkNotificationsRead: Success
  cancelEhrAppointment: EhrAppointment
  cancelSubscription: Subscription
  checkoutOneTimePayment: WorkflowRun
  claimFreeEhrAppointment: EhrAppointment
  completeLiveNotification: LiveNotificationMin
  completeNotification: Notification
  completeSurvey: SurveyLink
  completeUnifiedOnboarding: Success
  confirmLibreIndirectSync: Success
  confirmUser: Success
  createActionGoal: ActionGoal
  createActivity: Activity
  createAndLinkUhcUser: UserAuth
  createAppleAdsAttribution: CreateActionPayload
  createChatConversationNote: ChatConversationNote
  createChatToken: Token
  createChatbotDelimiter: Delimiter
  createChatbotQuickPrompt: ChatbotQuickPrompt
  /** @deprecated user createChatToken instead */
  createChatbotToken: Token
  createCustomIngredient: Ingredient
  createDirectUpload: DirectUpload
  createEhrChartNote: Success
  createFileFromSignedId: File
  createHealthMetric: HealthMetric
  createInsurancePolicy?: Maybe<InsurancePolicy>
  createJournalEntry: JournalEntry
  createLabResultFromUpload: LabResultProcessing
  createMeal: Meal
  createMeasurement: Measurement
  createNoraRealtimeClientSecret: NoraRealtimeClientSecret
  /** @deprecated Use :upsert_note */
  createNote: Note
  createOneTimePayment: CreatedOneTimePayment
  createProviderSetupIntent: ProviderSetupIntent
  createReminder: Reminder
  createSubscription: CreatedSubscription
  createSubscriptionBonus: Success
  createThirdPartyUser: UserAuth
  createUser: UserAuth
  deauthTerraProvider: ListProviders
  deleteActionGoal: ActionGoal
  deleteActivity: Activity
  deleteChatbotConversation: ChatbotConversation
  deleteChatbotQuickPrompt: ChatbotQuickPrompt
  deleteCustomIngredient: Ingredient
  deleteDexcomConnection?: Maybe<DexcomConnectionType>
  deleteEhrAppointmentRecurrence: Success
  deleteFile: File
  deleteHealthMetric: Success
  deleteJournalEntry: JournalEntry
  deleteLabResult: Success
  deleteMeal: Meal
  deleteMeasurement: Measurement
  deleteNote: Note
  deleteReminder: Reminder
  dismissLiveNotification: LiveNotificationMin
  dismissNotification: Notification
  ehrBookAppointment: EhrAppointment
  generateHealthDataReport: HealthDataReport
  generateHealthDataReportPdf: GeneratePdf
  markAllNotificationsRead: Success
  markNotificationRead: Notification
  openChatbotReportConversation: ChatbotConversation
  pauseSubscription: Subscription
  previewUserConversationMessage: UserConversationMessagePreview
  rateCoach: Success
  recordLessonProgress: RecordedProgress
  registerNotificationToken: RegisterNotificationTokenActionPayload
  replaceActionGoal: ReplaceActionGoal
  reportChatbotMessage: ChatbotMessageReport
  rescheduleEhrAppointment: EhrAppointment
  resetPassword: Success
  runInsuranceBenefitsCheck: BenefitsCheck
  saveSurveyResponse: SurveyResponse
  saveSurveyResponses: SurveyResponses
  scheduleReminder: Reminder
  scheduleSubscriptionChange: Subscription
  sendChatConversationMessage: Success
  sendMfaSmsCode: SendMfaSmsCode
  sendVideoCallReferral: Success
  setPrimaryGoalMetrics: Array<GoalMetric>
  setSubscriptionBillingCycle: Subscription
  signInAndLinkUhcUser: UserAuth
  signInPasswordlessUser: UserAuth
  signInThirdPartyUser: UserAuth
  signInUhcMember: UserAuth
  signOutUser: Success
  signinUser?: Maybe<UserAuth>
  startSurvey: SurveyLink
  startUnifiedOnboarding: Success
  submitHealthMetrics: Success
  submitInsuranceCard: InsuranceCardSubmission
  submitInsuranceInformation: SubmitInsuranceInformation
  switchCoach: Success
  synthesizeSpeech: SpeechAudio
  toggleProviderDataType: ListProviders
  transcribeUtterance: UtteranceTranscription
  uncancelSubscription: Subscription
  updateAddress: Address
  updateChatbotConversation: ChatbotConversation
  updateChatbotConversationTunnelDraft: ChatbotConversation
  updateChatbotQuickPrompt: ChatbotQuickPrompt
  updateChatbotSettings: ChatbotSettings
  updateDailyMeasurementsSourcePriority: DailyMeasurementsSourcePriority
  updateEffectiveDailyMeasurement: EffectiveDailyMeasurement
  updateEhrAppointmentKind: EhrAppointment
  updateGoalMetric: GoalMetric
  updateHealthData: Success
  updateHealthDataReportReadAt: HealthDataReport
  updateHealthMetric: HealthMetric
  updateJournalEntry: JournalEntry
  updateKetoMojoData: Success
  updateReminder: Reminder
  updateSensorSettings: Sensor
  updateSensorStatus: Sensor
  updateSettings: UserSettings
  updateSubscriptionProduct: Subscription
  updateUser: User
  upgradeSubscriptionProduct: UpgradedSubscription
  upgradeSubscriptionTrial: UpgradedSubscription
  upsertDexcomConnection: DexcomConnectionType
  upsertEhrAppointmentRecurrence: EhrAppointmentRecurrence
  upsertNote: Note
  upsertPrimaryGoal: Goal
  upsertUiState: UiState
  upsertUserProperty: MobileUserProperty
  verifyMfaSmsCode: VerifyMfaSmsCodeActionPayload
}

export type MutationTypeAcceptLegalPolicyArgs = {
  kind: LegalPolicyConsentKind
}

export type MutationTypeAnswerReferredToPurchaseArgs = {
  referred: Scalars['Boolean']['input']
}

export type MutationTypeApplyFreeEhrAppointmentArgs = {
  insuranceProvider?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeBulkMarkNotificationsReadArgs = {
  notificationIds: Array<Scalars['ID']['input']>
}

export type MutationTypeCancelEhrAppointmentArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeCancelSubscriptionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeCheckoutOneTimePaymentArgs = {
  address?: InputMaybe<OneTimePaymentAddress>
  email?: InputMaybe<Scalars['String']['input']>
  fullName?: InputMaybe<Scalars['String']['input']>
  metadata?: InputMaybe<Array<KeyValueString>>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  providerPaymentMethodId?: InputMaybe<Scalars['String']['input']>
  providerPromotionCodeId?: InputMaybe<Scalars['String']['input']>
  purchasableItems?: InputMaybe<Array<PurchasableItem>>
}

export type MutationTypeCompleteLiveNotificationArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeCompleteNotificationArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeCompleteSurveyArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeConfirmUserArgs = {
  confirmationToken?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeCreateActionGoalArgs = {
  goalText?: InputMaybe<Scalars['String']['input']>
  kind?: InputMaybe<ActionGoalKind>
  metricKind?: InputMaybe<ActionGoalMetricKind>
  metricValue?: InputMaybe<Scalars['Float']['input']>
  numberDays?: InputMaybe<Scalars['Int']['input']>
}

export type MutationTypeCreateActivityArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  endTime?: InputMaybe<Scalars['String']['input']>
  favorite?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  startTime?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeCreateAndLinkUhcUserArgs = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  policyConsentKinds?: InputMaybe<Array<LegalPolicyConsentKind>>
  source?: InputMaybe<UserSignUpSource>
}

export type MutationTypeCreateAppleAdsAttributionArgs = {
  anonymousId?: InputMaybe<Scalars['String']['input']>
  token?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeCreateChatConversationNoteArgs = {
  body?: InputMaybe<Scalars['String']['input']>
  conversationId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeCreateChatbotDelimiterArgs = {
  providerConversationId: Scalars['ID']['input']
}

export type MutationTypeCreateChatbotQuickPromptArgs = {
  text?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeCreateCustomIngredientArgs = {
  calories?: InputMaybe<Scalars['Float']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  ingredientId?: InputMaybe<Scalars['ID']['input']>
  mealId?: InputMaybe<Scalars['ID']['input']>
  nutrition?: InputMaybe<Array<KeyValueFloat>>
  servingAmount?: InputMaybe<Scalars['Float']['input']>
  servingUnits?: InputMaybe<Scalars['String']['input']>
  thirdPartyIngredientId?: InputMaybe<Scalars['String']['input']>
  thirdPartyIngredientSource?: InputMaybe<IngredientSource>
}

export type MutationTypeCreateDirectUploadArgs = {
  file?: InputMaybe<FileMetadata>
  purpose?: InputMaybe<DirectUploadPurpose>
  reason?: InputMaybe<DirectUploadReason>
}

export type MutationTypeCreateEhrChartNoteArgs = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>
  data?: InputMaybe<Scalars['JSON']['input']>
  getHealthieInstanceKind?: InputMaybe<EhrGetHealthieInstanceKind>
  kind?: InputMaybe<EhrChartNoteKind>
  legacyAppointmentId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeCreateFileFromSignedIdArgs = {
  fileTag?: InputMaybe<Scalars['String']['input']>
  signedId?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeCreateHealthMetricArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>
  kind?: InputMaybe<HealthDataMetricBiomarker>
  value?: InputMaybe<Scalars['Float']['input']>
}

export type MutationTypeCreateInsurancePolicyArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>
  holderDateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>
  holderFirstName?: InputMaybe<Scalars['String']['input']>
  holderLastName?: InputMaybe<Scalars['String']['input']>
  holderRelationship?: InputMaybe<UserInsurancePolicyHolderRelationship>
  kind?: InputMaybe<UserInsurancePolicyKind>
  memberId?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeCreateJournalEntryArgs = {
  body?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  measurements?: InputMaybe<Array<JournalMeasurementsData>>
  time?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeCreateLabResultFromUploadArgs = {
  fileId: Scalars['ID']['input']
}

export type MutationTypeCreateMealArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  favorite?: InputMaybe<Scalars['Boolean']['input']>
  favoriteId?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  ingredients?: InputMaybe<Array<IngredientData>>
  kind?: InputMaybe<MealKind>
  photo?: InputMaybe<Scalars['Upload']['input']>
  photoSignedId?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  time?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeCreateMeasurementArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  time?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['Float']['input']>
  values?: InputMaybe<MultiValue>
}

export type MutationTypeCreateNoteArgs = {
  body?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  pinned?: InputMaybe<Scalars['Boolean']['input']>
  time?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeCreateOneTimePaymentArgs = {
  address?: InputMaybe<OneTimePaymentAddress>
  email?: InputMaybe<Scalars['String']['input']>
  fullName?: InputMaybe<Scalars['String']['input']>
  metadata?: InputMaybe<Array<KeyValueString>>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  providerPaymentMethodId?: InputMaybe<Scalars['String']['input']>
  providerPromotionCodeId?: InputMaybe<Scalars['String']['input']>
  purchasableItems?: InputMaybe<Array<PurchasableItem>>
}

export type MutationTypeCreateProviderSetupIntentArgs = {
  email?: InputMaybe<Scalars['String']['input']>
  fullName?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<UserReferralPartner>
}

export type MutationTypeCreateReminderArgs = {
  dayOfWeek?: InputMaybe<NotificationEngineReminderDayOfWeek>
  frequency?: InputMaybe<NotificationEngineReminderFrequency>
  hoursInterval?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<NotificationEngineReminderKind>
  sendOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  timeOfDay?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeCreateSubscriptionArgs = {
  address?: InputMaybe<SubscriptionAddress>
  bonusKinds?: InputMaybe<Array<SubscriptionBonusKind>>
  checkoutOptionKinds?: InputMaybe<Array<SubscriptionCheckoutOptionKind>>
  email?: InputMaybe<Scalars['String']['input']>
  fullName?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  policyConsentKinds?: InputMaybe<Array<LegalPolicyConsentKind>>
  product?: InputMaybe<BillingProduct>
  providerPaymentMethodId?: InputMaybe<Scalars['String']['input']>
  providerPromotionCodeId?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeCreateSubscriptionBonusArgs = {
  bonusKind?: InputMaybe<Scalars['String']['input']>
  providerSubscriptionId?: InputMaybe<Scalars['ID']['input']>
  testGroup?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeCreateThirdPartyUserArgs = {
  authorization?: InputMaybe<ThirdPartySignIn>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  policyConsentKinds?: InputMaybe<Array<LegalPolicyConsentKind>>
}

export type MutationTypeCreateUserArgs = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<SignIn>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  marketingInfo?: InputMaybe<MarketingInfo>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  photo?: InputMaybe<Scalars['Upload']['input']>
  policyConsentKinds?: InputMaybe<Array<LegalPolicyConsentKind>>
  primaryGoal?: InputMaybe<UserGoalKind>
  referralPartner?: InputMaybe<UserReferralPartner>
  sendResetPasswordEmail?: InputMaybe<Scalars['Boolean']['input']>
  sendSignInLinkEmail?: InputMaybe<Scalars['Boolean']['input']>
  sex?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<UserSignUpSource>
  userProperties?: InputMaybe<Array<UserPropertySubmission>>
}

export type MutationTypeDeauthTerraProviderArgs = {
  provider: Scalars['String']['input']
}

export type MutationTypeDeleteActionGoalArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeDeleteActivityArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeDeleteChatbotConversationArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeDeleteChatbotQuickPromptArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeDeleteCustomIngredientArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeDeleteDexcomConnectionArgs = {
  dexcomConnectionKind?: InputMaybe<DexcomConnectionKind>
}

export type MutationTypeDeleteEhrAppointmentRecurrenceArgs = {
  baseStartDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type MutationTypeDeleteFileArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeDeleteHealthMetricArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeDeleteJournalEntryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeDeleteLabResultArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeDeleteMealArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeDeleteMeasurementArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeDeleteNoteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeDeleteReminderArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeDismissLiveNotificationArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeDismissNotificationArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeEhrBookAppointmentArgs = {
  appointmentKind?: InputMaybe<EhrAppointmentKind>
  attendanceAgenda?: InputMaybe<Scalars['String']['input']>
  attendanceChargeKind?: InputMaybe<EhrAppointmentAttendanceChargeKind>
  cadence?: InputMaybe<EhrAppointmentRecurrenceCadence>
  coachId?: InputMaybe<Scalars['ID']['input']>
  coachUserId?: InputMaybe<Scalars['ID']['input']>
  date?: InputMaybe<Scalars['String']['input']>
  doctorId?: InputMaybe<Scalars['ID']['input']>
  insuranceKind?: InputMaybe<UserInsurancePolicyKind>
  isGroup?: InputMaybe<Scalars['Boolean']['input']>
  pendingAppointmentId?: InputMaybe<Scalars['ID']['input']>
  referringCoachUserId?: InputMaybe<Scalars['ID']['input']>
  referringUserId?: InputMaybe<Scalars['ID']['input']>
  skipSlotValidation?: InputMaybe<Scalars['Boolean']['input']>
  state?: InputMaybe<AddressState>
  timeZone?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeGenerateHealthDataReportArgs = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  focusAreas?: InputMaybe<Array<HealthDataReportFocusArea>>
  kind?: InputMaybe<HealthDataReportKind>
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type MutationTypeGenerateHealthDataReportPdfArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeMarkNotificationReadArgs = {
  id: Scalars['ID']['input']
}

export type MutationTypeOpenChatbotReportConversationArgs = {
  reportId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypePauseSubscriptionArgs = {
  cycleCount?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypePreviewUserConversationMessageArgs = {
  kind: ChatConversationMessageTemplateKind
}

export type MutationTypeRateCoachArgs = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>
  coachUserId?: InputMaybe<Scalars['ID']['input']>
  rating?: InputMaybe<Scalars['Int']['input']>
}

export type MutationTypeRecordLessonProgressArgs = {
  complete?: InputMaybe<Scalars['Boolean']['input']>
  lessonId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeRegisterNotificationTokenArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  token?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeReplaceActionGoalArgs = {
  actionGoal?: InputMaybe<CreateActionGoal>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeReportChatbotMessageArgs = {
  botMessageId?: InputMaybe<Scalars['ID']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  reason?: InputMaybe<ChatbotMessageReportReason>
}

export type MutationTypeRescheduleEhrAppointmentArgs = {
  date?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeResetPasswordArgs = {
  password?: InputMaybe<Scalars['String']['input']>
  passwordToken?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeRunInsuranceBenefitsCheckArgs = {
  addressState?: InputMaybe<AddressState>
  insurancePolicyKind?: InputMaybe<UserInsurancePolicyKind>
  insuranceVideoCallGoal?: InputMaybe<Scalars['String']['input']>
  insuranceVideoCallGoalOther?: InputMaybe<Scalars['String']['input']>
  memberId?: InputMaybe<Scalars['String']['input']>
  useInsuranceData?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationTypeSaveSurveyResponseArgs = {
  answer: Scalars['JSON']['input']
  questionKey: Scalars['String']['input']
  surveyLinkId: Scalars['ID']['input']
  warnBeforeStopping?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationTypeSaveSurveyResponsesArgs = {
  responses?: InputMaybe<Array<SurveyResponseItem>>
  surveyLinkId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeScheduleReminderArgs = {
  kind: NotificationEngineReminderKind
  sendOn: Scalars['ISO8601Date']['input']
}

export type MutationTypeScheduleSubscriptionChangeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  product?: InputMaybe<BillingProduct>
}

export type MutationTypeSendChatConversationMessageArgs = {
  body?: InputMaybe<Scalars['String']['input']>
  conversationId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeSendVideoCallReferralArgs = {
  coachAssignmentId?: InputMaybe<Scalars['ID']['input']>
  email?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeSetPrimaryGoalMetricsArgs = {
  kinds?: InputMaybe<Array<UserGoalMetricKind>>
}

export type MutationTypeSetSubscriptionBillingCycleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  newBillingCycleAnchor?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type MutationTypeSignInAndLinkUhcUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeSignInPasswordlessUserArgs = {
  signInToken?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeSignInThirdPartyUserArgs = {
  provider?: InputMaybe<ThirdPartySignInProvider>
  providerToken?: InputMaybe<Scalars['String']['input']>
  providerUserId?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeSignInUhcMemberArgs = {
  token: Scalars['String']['input']
}

export type MutationTypeSigninUserArgs = {
  email: SignIn
}

export type MutationTypeStartSurveyArgs = {
  kind: Scalars['String']['input']
}

export type MutationTypeSubmitHealthMetricsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>
  healthMetricsData?: InputMaybe<Array<HealthMetricData>>
  measurementsData?: InputMaybe<Array<MeasurementData>>
}

export type MutationTypeSubmitInsuranceCardArgs = {
  backPhoto?: InputMaybe<Scalars['Upload']['input']>
  backPhotoFileId?: InputMaybe<Scalars['ID']['input']>
  frontPhoto?: InputMaybe<Scalars['Upload']['input']>
  frontPhotoFileId?: InputMaybe<Scalars['ID']['input']>
  insurancePolicyStateId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeSubmitInsuranceInformationArgs = {
  groupNumber?: InputMaybe<Scalars['String']['input']>
  insurancePlan?: InputMaybe<Scalars['String']['input']>
  memberId?: InputMaybe<Scalars['String']['input']>
  policyHolder?: InputMaybe<Scalars['String']['input']>
  policyHolderDateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>
  policyHolderFirstName?: InputMaybe<Scalars['String']['input']>
  policyHolderLastName?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeSwitchCoachArgs = {
  appointmentIdsToCancel?: InputMaybe<Array<Scalars['ID']['input']>>
  appointmentIdsToReschedule?: InputMaybe<Array<Scalars['ID']['input']>>
  appointmentKind?: InputMaybe<EhrAppointmentKind>
  coachIdToSwitchTo?: InputMaybe<Scalars['ID']['input']>
  recurring?: InputMaybe<Scalars['Boolean']['input']>
  selectedSlot?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeSynthesizeSpeechArgs = {
  chunkId?: InputMaybe<Scalars['ID']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeToggleProviderDataTypeArgs = {
  dataType: Scalars['String']['input']
  provider: Scalars['String']['input']
}

export type MutationTypeTranscribeUtteranceArgs = {
  audio?: InputMaybe<Scalars['Upload']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeUncancelSubscriptionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeUpdateAddressArgs = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<AddressCountries>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  street2?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeUpdateChatbotConversationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  pinned?: InputMaybe<Scalars['Boolean']['input']>
  providerId?: InputMaybe<Scalars['ID']['input']>
  read?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationTypeUpdateChatbotConversationTunnelDraftArgs = {
  draft?: InputMaybe<Scalars['JSON']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  providerId?: InputMaybe<Scalars['ID']['input']>
  streamChatMessageId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeUpdateChatbotQuickPromptArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeUpdateChatbotSettingsArgs = {
  appNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  communicationStyle?: InputMaybe<ChatbotSettingsCommunicationStyle>
  dataSharingEnabled?: InputMaybe<Scalars['Boolean']['input']>
  emailNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  proactiveUpdatesEnabled?: InputMaybe<Scalars['Boolean']['input']>
  speechVoice?: InputMaybe<ChatbotSpeechVoice>
}

export type MutationTypeUpdateDailyMeasurementsSourcePriorityArgs = {
  sources: Array<HealthDataMeasurementSource>
  type: HealthDataMeasurementType
}

export type MutationTypeUpdateEffectiveDailyMeasurementArgs = {
  date: Scalars['String']['input']
  selectedSource?: InputMaybe<HealthDataMeasurementSource>
  type: HealthDataMeasurementType
}

export type MutationTypeUpdateEhrAppointmentKindArgs = {
  appointmentKind?: InputMaybe<EhrAppointmentKind>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeUpdateGoalMetricArgs = {
  highThresholdValue?: InputMaybe<Scalars['Float']['input']>
  kind?: InputMaybe<UserGoalMetricKind>
  lowThresholdValue?: InputMaybe<Scalars['Float']['input']>
}

export type MutationTypeUpdateHealthDataArgs = {
  healthData?: InputMaybe<HealthKitData>
}

export type MutationTypeUpdateHealthDataReportReadAtArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationTypeUpdateHealthMetricArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  value?: InputMaybe<Scalars['Float']['input']>
}

export type MutationTypeUpdateJournalEntryArgs = {
  body?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  measurements?: InputMaybe<Array<JournalMeasurementsData>>
  time?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeUpdateKetoMojoDataArgs = {
  data?: InputMaybe<Array<KetoMojoData>>
}

export type MutationTypeUpdateReminderArgs = {
  dayOfWeek?: InputMaybe<NotificationEngineReminderDayOfWeek>
  frequency?: InputMaybe<NotificationEngineReminderFrequency>
  hoursInterval?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<NotificationEngineReminderKind>
  sendOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  timeOfDay?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeUpdateSensorSettingsArgs = {
  baselineAdjustment?: InputMaybe<Scalars['Int']['input']>
}

export type MutationTypeUpdateSensorStatusArgs = {
  serialNumber?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<SensorStatus>
}

export type MutationTypeUpdateSettingsArgs = {
  appVersionReminder?: InputMaybe<Scalars['Boolean']['input']>
  dashboardGraph?: InputMaybe<Scalars['String']['input']>
  dexcomSync?: InputMaybe<Scalars['Boolean']['input']>
  displayActivityScore?: InputMaybe<Scalars['Boolean']['input']>
  displayDailyScore?: InputMaybe<Scalars['Boolean']['input']>
  displayMealScore?: InputMaybe<Scalars['Boolean']['input']>
  fastingEnd?: InputMaybe<Scalars['Int']['input']>
  fastingStart?: InputMaybe<Scalars['Int']['input']>
  glucoseHighThreshold?: InputMaybe<Scalars['Int']['input']>
  glucoseLowThreshold?: InputMaybe<Scalars['Int']['input']>
  glucoseSource?: InputMaybe<Scalars['String']['input']>
  googleFitSync?: InputMaybe<Scalars['Boolean']['input']>
  healthKitSync?: InputMaybe<Scalars['Boolean']['input']>
  integrationsSyncSettings?: InputMaybe<IntegrationsSyncSettings>
  ketoMojoSync?: InputMaybe<Scalars['Boolean']['input']>
  ketoneHighThreshold?: InputMaybe<Scalars['Float']['input']>
  ketoneLowThreshold?: InputMaybe<Scalars['Float']['input']>
  macroGoalsDaily?: InputMaybe<MacroGoalsDaily>
  patternsNotifications?: InputMaybe<Scalars['Boolean']['input']>
  reminders?: InputMaybe<Scalars['Boolean']['input']>
  showNetCarbs?: InputMaybe<Scalars['Boolean']['input']>
  statsSettings?: InputMaybe<Array<StatsSettingsOrder>>
  syncMacroGoalsDailyToActionGoals?: InputMaybe<Scalars['Boolean']['input']>
  trackingMode?: InputMaybe<TrackingMode>
  unitSystem?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeUpdateSubscriptionProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  nextProduct?: InputMaybe<BillingProduct>
}

export type MutationTypeUpdateUserArgs = {
  currentPassword?: InputMaybe<Scalars['String']['input']>
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  photo?: InputMaybe<Scalars['Upload']['input']>
  sex?: InputMaybe<Scalars['String']['input']>
  timeZone?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeUpgradeSubscriptionProductArgs = {
  checkoutOptionKinds?: InputMaybe<Array<SubscriptionCheckoutOptionKind>>
  id?: InputMaybe<Scalars['ID']['input']>
  nextProduct?: InputMaybe<BillingProduct>
  providerPaymentMethodId?: InputMaybe<Scalars['String']['input']>
  providerPromotionCodeId?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeUpgradeSubscriptionTrialArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  providerPaymentMethodId?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeUpsertDexcomConnectionArgs = {
  authorizationCode?: InputMaybe<Scalars['String']['input']>
  dexcomConnectionKind?: InputMaybe<DexcomConnectionKind>
  platform?: InputMaybe<DexcomConnectionPlatform>
  sensorModel?: InputMaybe<DexcomConnectionSensorModel>
}

export type MutationTypeUpsertEhrAppointmentRecurrenceArgs = {
  appointmentKind?: InputMaybe<EhrAppointmentKind>
  cadence?: InputMaybe<EhrAppointmentRecurrenceCadence>
  days?: InputMaybe<Array<EhrAppointmentRecurrenceDay>>
  numberOfCalls?: InputMaybe<Scalars['Int']['input']>
  timeSlots?: InputMaybe<Array<Scalars['ISO8601DateTime']['input']>>
}

export type MutationTypeUpsertNoteArgs = {
  body?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  pinned?: InputMaybe<Scalars['Boolean']['input']>
  time?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeUpsertPrimaryGoalArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  kind?: InputMaybe<UserGoalKind>
}

export type MutationTypeUpsertUiStateArgs = {
  name?: InputMaybe<UiStateNames>
  value?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationTypeUpsertUserPropertyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<UserPropertyKind>
  value?: InputMaybe<Scalars['String']['input']>
}

export type MutationTypeVerifyMfaSmsCodeArgs = {
  mfaSmsCode?: InputMaybe<Scalars['String']['input']>
}

export type NextRecurringAppointmentSlot = {
  __typename?: 'NextRecurringAppointmentSlot'
  appointmentKind: EhrAppointmentKind
  coachName: Scalars['String']['output']
  meetingAt: Scalars['ISO8601DateTime']['output']
}

export type NoraRealtimeClientSecret = {
  __typename?: 'NoraRealtimeClientSecret'
  noraSpeech: Secret
  userTranscription: Secret
}

export type Note = {
  __typename?: 'Note'
  body: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy: Scalars['String']['output']
  creator: User
  /** @deprecated Use creator instead */
  creatorId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  kind: NoteKind
  occurredAt: Scalars['ISO8601DateTime']['output']
  pinnedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  title: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type NoteCollection = {
  __typename?: 'NoteCollection'
  notes: Array<Note>
}

export type NoteDynamicFilter = {
  field: NoteDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export enum NoteDynamicFilterField {
  Kind = 'kind',
}

export type NoteDynamicFilterItem = {
  items: Array<NoteDynamicFilter>
  operator: DynamicFilterOperator
}

export enum NoteKind {
  DietitianNote = 'dietitian_note',
  DietitianUpNext = 'dietitian_up_next',
  GlucoseChart = 'glucose_chart',
  MemberNote = 'member_note',
  OpsAccountRequest = 'ops_account_request',
}

export type NoteSort = {
  direction: SortDirection
  field: NoteSortField
}

export enum NoteSortField {
  OccurredAt = 'occurred_at',
}

export type Notification = {
  __typename?: 'Notification'
  actionButtonLabel: Scalars['String']['output']
  actionKind: NotificationEngineNotificationActionKind
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  content: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  dismissButtonLabel: Scalars['String']['output']
  dismissedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  icon?: Maybe<UiIcon>
  id: Scalars['ID']['output']
  imageUrl?: Maybe<Scalars['String']['output']>
  inboxVisible: Scalars['Boolean']['output']
  kind: NotificationEngineNotificationKind
  /** @deprecated use liveSurfaceKind on LiveNotification instead */
  liveSurfaceKind: NotificationEngineNotificationLiveSurfaceKind
  payload: Scalars['JSON']['output']
  priority: Scalars['Int']['output']
  readAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  screen: NotificationEngineScreen
  sticky: Scalars['Boolean']['output']
  style: NotificationEngineNotificationStyle
  templateKind: NotificationEngineNotificationTemplateKind
  title?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type NotificationCollection = {
  __typename?: 'NotificationCollection'
  notifications: Array<Notification>
}

export enum NotificationEngineNotificationActionKind {
  DeepLink = 'deep_link',
  EditExperimentScreen = 'edit_experiment_screen',
  EditJournalScreen = 'edit_journal_screen',
  ExternalLink = 'external_link',
  InsightsGlucoseScreen = 'insights_glucose_screen',
  InsightsMealScreen = 'insights_meal_screen',
  MealScreen = 'meal_screen',
  NewActivityScreen = 'new_activity_screen',
  NewJournalScreen = 'new_journal_screen',
  NewMealScreen = 'new_meal_screen',
  None = 'none',
  NoraPrompt = 'nora_prompt',
}

export enum NotificationEngineNotificationKind {
  ActivityReminder = 'activity_reminder',
  AddedToCohort = 'added_to_cohort',
  ByosVideoCallsUpsellChatlikeNotification = 'byos_video_calls_upsell_chatlike_notification',
  ByosVideoCallsUpsellFreeConsultationActionItem = 'byos_video_calls_upsell_free_consultation_action_item',
  ByosVideoCallsUpsellFreeConsultationChatlikeNotification = 'byos_video_calls_upsell_free_consultation_chatlike_notification',
  CgmReviewVideoCallUpsell = 'cgm_review_video_call_upsell',
  ChatNewMessage = 'chat_new_message',
  CoachingCallAllowanceExhausted = 'coaching_call_allowance_exhausted',
  CohortSessionAttendanceRsvp = 'cohort_session_attendance_rsvp',
  CohortSessionMakeUpMissed = 'cohort_session_make_up_missed',
  CohortSessionMissed = 'cohort_session_missed',
  CohortSessionReminder = 'cohort_session_reminder',
  CohortSessionRsvpMissing = 'cohort_session_rsvp_missing',
  CohortSessionScheduleChanged = 'cohort_session_schedule_changed',
  CohortSessionWeightLogReminder = 'cohort_session_weight_log_reminder',
  DailyActionCompleted = 'daily_action_completed',
  DailyActionReminder = 'daily_action_reminder',
  EngagedUserReferralUpsell = 'engaged_user_referral_upsell',
  FullscriptLabResultsAvailable = 'fullscript_lab_results_available',
  FullscriptLabsRenewalReminder = 'fullscript_labs_renewal_reminder',
  GlucoseCheckReminder = 'glucose_check_reminder',
  HealthDataReportPdfReady = 'health_data_report_pdf_ready',
  HealthDataReportReady = 'health_data_report_ready',
  InsuranceOptionAvailable = 'insurance_option_available',
  InsurancePolicyIneligible = 'insurance_policy_ineligible',
  InsurancePolicyPatientResponsibilityRequired = 'insurance_policy_patient_responsibility_required',
  InsurancePolicyUnitsExhausted = 'insurance_policy_units_exhausted',
  JournalReminder = 'journal_reminder',
  LabPanelDiscountAllowanceExhausted = 'lab_panel_discount_allowance_exhausted',
  LabPanelsUpsell = 'lab_panels_upsell',
  LabResultAnalysisComplete = 'lab_result_analysis_complete',
  LabResultAnalysisFailed = 'lab_result_analysis_failed',
  LastSteloSensorAboutToExpire = 'last_stelo_sensor_about_to_expire',
  LastSteloSensorAboutToExpireForDexcomUser = 'last_stelo_sensor_about_to_expire_for_dexcom_user',
  LoseWeightRecurrentVideoCallUpsell = 'lose_weight_recurrent_video_call_upsell',
  LowDailyScoreVideoCallUpsell = 'low_daily_score_video_call_upsell',
  MealReminder = 'meal_reminder',
  MealScoreSpike = 'meal_score_spike',
  MeasurementReminder = 'measurement_reminder',
  MedicalConsultReminder = 'medical_consult_reminder',
  MedicalConsultStartingSoonReminder = 'medical_consult_starting_soon_reminder',
  MfpCreditExpiringSoonReminder = 'mfp_credit_expiring_soon_reminder',
  MfpIntegrationPromotion = 'mfp_integration_promotion',
  NewCoachExperiment = 'new_coach_experiment',
  NewCoachNote = 'new_coach_note',
  NewCourseAvailable = 'new_course_available',
  NewEnrollableCohort = 'new_enrollable_cohort',
  NutritionistSwitchVideoCall = 'nutritionist_switch_video_call',
  OnboardingExperienceReminderPostCall = 'onboarding_experience_reminder_post_call',
  OnboardingExperienceReminderPreCall = 'onboarding_experience_reminder_pre_call',
  PatternsGlucoseAverage = 'patterns_glucose_average',
  PatternsGlucoseMax = 'patterns_glucose_max',
  PatternsGlucoseMin = 'patterns_glucose_min',
  PatternsGlucoseMorningAverage = 'patterns_glucose_morning_average',
  PatternsGlucoseScore = 'patterns_glucose_score',
  PatternsGlucoseSleepAverage = 'patterns_glucose_sleep_average',
  PatternsGlucoseSpikeWithExercise = 'patterns_glucose_spike_with_exercise',
  PatternsGlucoseSpikeWithMeal = 'patterns_glucose_spike_with_meal',
  PatternsGlucoseTimeInRange = 'patterns_glucose_time_in_range',
  PatternsGlucoseVariability = 'patterns_glucose_variability',
  PatternsMealScore = 'patterns_meal_score',
  PatternsUnannotatedGlucoseSpike = 'patterns_unannotated_glucose_spike',
  ProactiveExtendedGlucoseElevation = 'proactive_extended_glucose_elevation',
  ProactiveLowGlucose = 'proactive_low_glucose',
  ProactiveMealLoggingDropOff = 'proactive_meal_logging_drop_off',
  ProactivePostActivityWin = 'proactive_post_activity_win',
  ProactivePostMealSpike = 'proactive_post_meal_spike',
  ProactiveRecurringSpikePattern = 'proactive_recurring_spike_pattern',
  ProactiveSleepGlucoseCorrelation = 'proactive_sleep_glucose_correlation',
  ProactiveUpsell = 'proactive_upsell',
  ReferAFriend = 'refer_a_friend',
  ReferralAccepted = 'referral_accepted',
  ScanReminder = 'scan_reminder',
  StressManagement = 'stress_management',
  SubmitLabResultsCustomDate = 'submit_lab_results_custom_date',
  SubmitLabResultsPeriodical = 'submit_lab_results_periodical',
  SubscriptionAboutToExpire = 'subscription_about_to_expire',
  SurveyReminder = 'survey_reminder',
  UpcomingCallPreauthorizationFailed = 'upcoming_call_preauthorization_failed',
  UpcomingCallRequiresPaymentMethod = 'upcoming_call_requires_payment_method',
  VideoCallBookNow = 'video_call_book_now',
  VideoCallCheckInReminder = 'video_call_check_in_reminder',
  VideoCallClaimFreeCall = 'video_call_claim_free_call',
  VideoCallEarlierSlotAvailable = 'video_call_earlier_slot_available',
  VideoCallNoShowFeeChargeFailed = 'video_call_no_show_fee_charge_failed',
  VideoCallNoShowFeeCharged = 'video_call_no_show_fee_charged',
  VideoCallRecurrenceAppointmentBooked = 'video_call_recurrence_appointment_booked',
  VideoCallRecurrenceBookingCompleted = 'video_call_recurrence_booking_completed',
  VideoCallReminder = 'video_call_reminder',
  VideoCallStartingSoonReminder = 'video_call_starting_soon_reminder',
  VideoCallSteloUpsell = 'video_call_stelo_upsell',
  VideoCallSteloUpsellPersistent = 'video_call_stelo_upsell_persistent',
  VideoCallUpsell = 'video_call_upsell',
  VideoCallUpsellFollowup = 'video_call_upsell_followup',
}

export enum NotificationEngineNotificationLiveSurfaceKind {
  Banner = 'banner',
  Inbox = 'inbox',
  None = 'none',
}

export enum NotificationEngineNotificationStyle {
  Chatlike = 'chatlike',
  Expiration = 'expiration',
  IntegrationPromotion = 'integration_promotion',
  Standard = 'standard',
}

export enum NotificationEngineNotificationTemplateKind {
  Alert = 'alert',
  Coach = 'coach',
  Nora = 'nora',
  Passive = 'passive',
  Promotion = 'promotion',
  Standard = 'standard',
}

export enum NotificationEngineReminderDayOfWeek {
  Friday = 'friday',
  Monday = 'monday',
  Saturday = 'saturday',
  Sunday = 'sunday',
  Thursday = 'thursday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
}

export enum NotificationEngineReminderFrequency {
  Bimonthly = 'bimonthly',
  Daily = 'daily',
  HoursInterval = 'hours_interval',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Weekly = 'weekly',
}

export enum NotificationEngineReminderKind {
  Breakfast = 'breakfast',
  Dinner = 'dinner',
  Exercise = 'exercise',
  Fasting = 'fasting',
  GlucoseCheck = 'glucose_check',
  Journal = 'journal',
  LogDailyAction = 'log_daily_action',
  Lunch = 'lunch',
  Meditation = 'meditation',
  OtherMeal = 'other_meal',
  Sleep = 'sleep',
  SubmitLabResults = 'submit_lab_results',
  Weight = 'weight',
}

export enum NotificationEngineScreen {
  Home = 'home',
  Inbox = 'inbox',
  Insights = 'insights',
  None = 'none',
  NutritionistHub = 'nutritionist_hub',
  Plan = 'plan',
}

export type NotificationInbox = {
  __typename?: 'NotificationInbox'
  nextCursor?: Maybe<Scalars['String']['output']>
  notifications: Array<Notification>
  unreadCount: Scalars['Int']['output']
}

export enum NotificationInboxStateFilter {
  All = 'all',
  Completed = 'completed',
  Dismissed = 'dismissed',
  Read = 'read',
  Unread = 'unread',
}

export type NumericPair = {
  __typename?: 'NumericPair'
  x: Scalars['Float']['output']
  y?: Maybe<Scalars['Numeric']['output']>
}

export type NumericValue = {
  endDate: Scalars['ISO8601DateTime']['input']
  id?: InputMaybe<Scalars['String']['input']>
  metadata?: InputMaybe<Scalars['JSON']['input']>
  sourceId?: InputMaybe<Scalars['String']['input']>
  sourceName?: InputMaybe<Scalars['String']['input']>
  startDate: Scalars['ISO8601DateTime']['input']
  value?: InputMaybe<Scalars['Float']['input']>
}

export type NumericalSelect = {
  __typename?: 'NumericalSelect'
  text: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type NutritionCard = {
  __typename?: 'NutritionCard'
  nutrition: NutritionStatistics
  score: GlucoseDailyScore
  statistics: GlucoseStatistics
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type NutritionStatistics = {
  __typename?: 'NutritionStatistics'
  today: Array<KeyValuePairFloat>
}

export type Onboarding = {
  __typename?: 'Onboarding'
  tutorials: Array<Tutorials>
}

export type OnboardingExperience = {
  __typename?: 'OnboardingExperience'
  baselineWeight?: Maybe<Scalars['Int']['output']>
  dateToReachDesiredWeight?: Maybe<Scalars['String']['output']>
  desiredWeight?: Maybe<Scalars['Int']['output']>
  desiredWeightLossAmount?: Maybe<Scalars['Int']['output']>
  fourWeekWeight?: Maybe<Scalars['Int']['output']>
  kind: UserPropertyOnboardingExperienceKind
  participating: Scalars['Boolean']['output']
  realisticWeightLoss?: Maybe<Scalars['Boolean']['output']>
  weightLossPace?: Maybe<Scalars['Int']['output']>
}

export type OneTimePaymentAddress = {
  city: Scalars['String']['input']
  country?: InputMaybe<AddressCountries>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street: Scalars['String']['input']
  street2?: InputMaybe<Scalars['String']['input']>
  zipCode: Scalars['String']['input']
}

export type OneTimePaymentCheckout = {
  __typename?: 'OneTimePaymentCheckout'
  id: Scalars['ID']['output']
  invoice?: Maybe<Invoice>
  state: BillingOneTimePaymentsCheckoutState
}

export type Organization = {
  __typename?: 'Organization'
  id: Scalars['Int']['output']
  isNutrisense: Scalars['Boolean']['output']
  name: Scalars['String']['output']
}

export type Outcome = {
  __typename?: 'Outcome'
  id: Scalars['ID']['output']
  key: Scalars['String']['output']
  reason: Reason
}

export type Pagination = {
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod'
  cardType: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  expirationDate: Scalars['ISO8601Date']['output']
  last4: Scalars['String']['output']
  stripeId: Scalars['String']['output']
}

export enum Period {
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Week = 'week',
}

export type Pill = {
  __typename?: 'Pill'
  fill?: Maybe<UiPillFill>
  size?: Maybe<UiPillSize>
  text: Scalars['String']['output']
  type?: Maybe<UiPillType>
}

export type Plan = {
  __typename?: 'Plan'
  amount: Scalars['Float']['output']
  id: Scalars['ID']['output']
  nickname: Scalars['String']['output']
  product: ProductMin
  stripeId: Scalars['String']['output']
}

export type PotentiallyRecurringSlots = {
  __typename?: 'PotentiallyRecurringSlots'
  biWeekly: Array<Scalars['ISO8601DateTime']['output']>
  monthly: Array<Scalars['ISO8601DateTime']['output']>
  weekly: Array<Scalars['ISO8601DateTime']['output']>
}

export type Product = {
  __typename?: 'Product'
  addon: Scalars['Boolean']['output']
  appliedPromo?: Maybe<PromotionCode>
  billingDateChangeable: Scalars['Boolean']['output']
  bundledPaidCalls: Scalars['Boolean']['output']
  callout?: Maybe<Scalars['String']['output']>
  cgm: Scalars['Boolean']['output']
  commitmentMonths?: Maybe<Scalars['Int']['output']>
  core: Scalars['Boolean']['output']
  description?: Maybe<Scalars['String']['output']>
  details?: Maybe<Array<Scalars['String']['output']>>
  dietitian: Scalars['Boolean']['output']
  dietitianMenu: Scalars['Boolean']['output']
  /** @deprecated Field removed from product */
  dietitianTrialDays?: Maybe<Scalars['Int']['output']>
  ehrSchedulingRule: EhrAppointmentSchedulingRuleDef
  eligibilityListItems: Array<Scalars['String']['output']>
  eligibleUpgradeProducts: Array<ProductMin>
  free: Scalars['Boolean']['output']
  icon?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  includedGoods: Array<ProductMin>
  includedOptions?: Maybe<Array<Scalars['String']['output']>>
  includesCgm: Scalars['Boolean']['output']
  incompatibleAddons: Array<ProductMin>
  insuranceCoverage: Scalars['Boolean']['output']
  interval: Interval
  key: Scalars['String']['output']
  metadata: Scalars['JSON']['output']
  order: Scalars['Int']['output']
  ownSensor: Scalars['Boolean']['output']
  patch: Scalars['Boolean']['output']
  pill?: Maybe<Pill>
  /** @deprecated Use price instead */
  plan: ProductPlan
  preselected: Scalars['Boolean']['output']
  price: Scalars['Float']['output']
  productGroup?: Maybe<ProductGroup>
  programsName?: Maybe<Scalars['String']['output']>
  recurring: Scalars['Boolean']['output']
  requiresShipping: Scalars['Boolean']['output']
  shippingRule: ShippingRule
  shortDescription?: Maybe<Scalars['String']['output']>
  showUnitPrice: Scalars['Boolean']['output']
  softwareOnly: Scalars['Boolean']['output']
  title: Scalars['String']['output']
  trialDays?: Maybe<Scalars['Int']['output']>
  uhc: Scalars['Boolean']['output']
  uncancelable: Scalars['Boolean']['output']
  units?: Maybe<Scalars['Int']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type ProductCollection = {
  __typename?: 'ProductCollection'
  products: Array<Product>
}

export type ProductGroup = {
  __typename?: 'ProductGroup'
  description: Scalars['String']['output']
  details: Array<Scalars['String']['output']>
  id: Scalars['ID']['output']
  interval: Interval
  key: Scalars['String']['output']
  kind?: Maybe<BillingProductGroupKind>
  order: Scalars['Int']['output']
  shortDescription: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type ProductMin = {
  __typename?: 'ProductMin'
  billingDateChangeable: Scalars['Boolean']['output']
  bundledPaidCalls: Scalars['Boolean']['output']
  cgm: Scalars['Boolean']['output']
  core: Scalars['Boolean']['output']
  details?: Maybe<Array<Scalars['String']['output']>>
  ehrSchedulingRule: EhrAppointmentSchedulingRuleDef
  eligibleUpgradeProducts: Array<ProductMin>
  free: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  includedGoods: Array<ProductMin>
  includesCgm: Scalars['Boolean']['output']
  incompatibleAddons: Array<ProductMin>
  interval: Interval
  key: Scalars['String']['output']
  ownSensor: Scalars['Boolean']['output']
  patch: Scalars['Boolean']['output']
  recurring: Scalars['Boolean']['output']
  requiresShipping: Scalars['Boolean']['output']
  softwareOnly: Scalars['Boolean']['output']
  title: Scalars['String']['output']
  uhc: Scalars['Boolean']['output']
  uncancelable: Scalars['Boolean']['output']
}

export type ProductPlan = {
  __typename?: 'ProductPlan'
  amount: Scalars['Int']['output']
  id: Scalars['ID']['output']
  stripeId: Scalars['String']['output']
}

export type Program = {
  __typename?: 'Program'
  contentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  position?: Maybe<Scalars['Int']['output']>
  progress?: Maybe<Progress>
}

export type ProgramCollection = {
  __typename?: 'ProgramCollection'
  programs: Array<ExpandableProgram>
}

export type Progress = {
  __typename?: 'Progress'
  complete: Scalars['Boolean']['output']
}

export type PromotionCode = {
  __typename?: 'PromotionCode'
  amountOff?: Maybe<Scalars['Float']['output']>
  applicable: Scalars['Boolean']['output']
  code: Scalars['String']['output']
  durationInMonths?: Maybe<Scalars['Int']['output']>
  name: Scalars['String']['output']
  percentOff?: Maybe<Scalars['Float']['output']>
  providerId: Scalars['String']['output']
}

export type Provider = {
  __typename?: 'Provider'
  active: Scalars['Boolean']['output']
  availableTypes?: Maybe<Array<Scalars['String']['output']>>
  connectionId?: Maybe<Scalars['Int']['output']>
  disabledTypes?: Maybe<Array<Scalars['String']['output']>>
  errorReason?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  provider: Scalars['String']['output']
  providerKind: TerraProviderKind
  status?: Maybe<Scalars['String']['output']>
}

export type ProviderSetupIntent = {
  __typename?: 'ProviderSetupIntent'
  clientSecret: Scalars['String']['output']
}

export type PurchasableItem = {
  product: BillingProduct
  quantity: Scalars['Int']['input']
}

export type QueryType = {
  __typename?: 'QueryType'
  actionGoalSummaries: ActionGoalSummaryCollection
  activeNotifications: NotificationCollection
  allActivities: ActivityCollection
  allCharts: Charts
  allChatConversationMessages: ChatConversationMessageCollection
  allChatbotConversations: ChatbotConversationCollection
  allChatbotQuickPrompts: ChatbotQuickPromptCollection
  allCoachProfiles: CoachProfileCollection
  allCourses: ProgramCollection
  allCustomIngredients: IngredientCollection
  allEvents: EventsData
  allFiles: ListFiles
  allHealthDataReports: HealthDataReportCollection
  allMeals: MealCollection
  allMeasurements: MeasurementCollection
  allNotes: NoteCollection
  allNutrition: NutritionCard
  allProducts: ProductCollection
  allStats: Stats
  allSubscriptionSchedules: ScheduleCollection
  allSurveyLinks: SurveyLinkCollection
  allTerraProviders: ListProviders
  allUsersAutocomplete: UserCollection
  billingAllowances: BillingAllowanceCollection
  calendar: UserCalendar
  chartsData: ChartsData
  chatbotConversation: ChatbotConversation
  chatbotSettings: ChatbotSettings
  checklistItems: ChecklistItemCollection
  clientConfig: ClientConfig
  coachAssignments: CoachAssignmentCollection
  coachProfile: CoachProfile
  coachSwitchingSummary: Summary
  currentUser?: Maybe<User>
  dailyMeasurementsSourcePriority: DailyMeasurementsSourcePriority
  dataExport: Success
  effectiveDailyMeasurement?: Maybe<EffectiveDailyMeasurement>
  ehrAllAvailabilities: Array<Availability>
  ehrAppointment: EhrAppointment
  ehrAppointmentCredits: EhrAppointmentCredits
  ehrAppointmentRecurrence?: Maybe<EhrAppointmentRecurrence>
  ehrAppointmentRecurrences: Array<EhrAppointmentRecurrence>
  ehrAppointmentSchedulingInfo?: Maybe<EhrAppointmentSchedulingInfoCollection>
  ehrAppointments: EhrAppointmentCollection
  ehrAvailableDateSlots: DateSlots
  ehrAvailableDates: Dates
  ehrAvailableDatesWithSlots: DatesWithSlots
  ehrEarlierAvailableSlots: Slots
  ehrPotentiallyRecurringSlots: PotentiallyRecurringSlots
  ehrSuggestedAvailability?: Maybe<Suggested>
  estimateOneTimePayment: EstimatedPrice
  estimateTax: EstimatedTax
  file?: Maybe<File>
  generateTerraAuthUrl: GenerateAuthUrl
  generateTerraSdkToken: GenerateSdkToken
  healthDataReport: HealthDataReport
  healthMetrics: HealthMetricCollection
  insuranceCardSubmission?: Maybe<InsuranceCardSubmission>
  insurancePlans: ListPlansActionPayload
  insurancePolicies: InsurancePolicyCollection
  insurancePolicy?: Maybe<InsurancePolicy>
  invoice: Invoice
  kustomerArticleVersionPreview?: Maybe<ArticleVersion>
  kustomerArticleVersions?: Maybe<ArticleVersionList>
  kustomerArticles?: Maybe<ArticleList>
  kustomerConversationMessages: ConversationMessagesList
  kustomerConversations?: Maybe<ConversationList>
  kustomerCreateConversation: Success
  labResult: LabResult
  labResults: LabResultCollection
  latestCharge?: Maybe<Charge>
  latestSurveyLinkByKind?: Maybe<SurveyLink>
  latestUserEhrAppointment?: Maybe<EhrAppointment>
  legalPolicyConsentStatuses: LegalPolicyConsentStatuses
  liveNotifications: LiveNotificationCollection
  meal: Meal
  mealImageDescription: ImageDescription
  mfpCreditGlobalPool: MfpCreditGlobalPool
  nextRecurringAppointmentSlot?: Maybe<NextRecurringAppointmentSlot>
  notificationInbox: NotificationInbox
  oneTimePaymentCheckout: OneTimePaymentCheckout
  product: Product
  promotionCode: PromotionCode
  referralPartner?: Maybe<UserReferralPartnerDef>
  reminders: ReminderCollection
  resetPasswordRequest: Success
  sendUserInvite: Success
  uhcMember: UhcMember
  uhcStoreSubscriptions: UhcStoreSubscriptionCollection
  uiFlags: UiFlags
  unifiedOnboardingUpsellOffers: UnifiedOnboardingUpsellOffers
  usStates: Array<State>
  workflowRun: WorkflowRun
}

export type QueryTypeActionGoalSummariesArgs = {
  startDate: Scalars['ISO8601Date']['input']
}

export type QueryTypeAllActivitiesArgs = {
  filter?: InputMaybe<ActivityFilter>
  pagination?: InputMaybe<Pagination>
}

export type QueryTypeAllChartsArgs = {
  filter?: InputMaybe<DateFilter>
}

export type QueryTypeAllChatConversationMessagesArgs = {
  kind?: InputMaybe<ChatConversationKind>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<WebMembersChatConversationMessageSort>>
}

export type QueryTypeAllChatbotConversationsArgs = {
  dynamicFilters?: InputMaybe<Array<ChatbotConversationDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  sorts?: InputMaybe<Array<ChatbotConversationSort>>
}

export type QueryTypeAllCoachProfilesArgs = {
  appointmentKind?: InputMaybe<EhrAppointmentKind>
  excludedCoachIds?: InputMaybe<Array<Scalars['ID']['input']>>
  insurancePlan?: InputMaybe<UserInsurancePolicyKind>
  licensedState?: InputMaybe<AddressState>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  recommended?: InputMaybe<Scalars['Boolean']['input']>
  specialties?: InputMaybe<Array<EhrCoachSpecialty>>
}

export type QueryTypeAllCustomIngredientsArgs = {
  filter?: InputMaybe<IngredientFilter>
  pagination?: InputMaybe<Pagination>
}

export type QueryTypeAllEventsArgs = {
  filter?: InputMaybe<DateFilter>
  pagination?: InputMaybe<Pagination>
}

export type QueryTypeAllFilesArgs = {
  dynamicFilters?: InputMaybe<Array<FileDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<FileSort>>
}

export type QueryTypeAllHealthDataReportsArgs = {
  dynamicFilters?: InputMaybe<Array<HealthDataReportDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<HealthDataReportSort>>
}

export type QueryTypeAllMealsArgs = {
  filter?: InputMaybe<MealFilter>
  pagination?: InputMaybe<Pagination>
}

export type QueryTypeAllMeasurementsArgs = {
  filter?: InputMaybe<MeasurementFilter>
  pagination?: InputMaybe<Pagination>
}

export type QueryTypeAllNotesArgs = {
  dynamicFilters?: InputMaybe<Array<NoteDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<NoteSort>>
}

export type QueryTypeAllNutritionArgs = {
  filter?: InputMaybe<DateFilter>
}

export type QueryTypeAllProductsArgs = {
  category?: InputMaybe<BillingProductCategory>
}

export type QueryTypeAllStatsArgs = {
  filter?: InputMaybe<DateFilter>
}

export type QueryTypeAllUsersAutocompleteArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['String']['input']
}

export type QueryTypeBillingAllowancesArgs = {
  kinds?: InputMaybe<Array<BillingAllowanceKind>>
}

export type QueryTypeCalendarArgs = {
  filter?: InputMaybe<DateFilter>
}

export type QueryTypeChartsDataArgs = {
  filter: ChartFilter
}

export type QueryTypeChatbotConversationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  providerId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryTypeChecklistItemsArgs = {
  kind: UserChecklistItemsKind
}

export type QueryTypeCoachAssignmentsArgs = {
  dynamicFilters?: InputMaybe<Array<CoachAssignmentDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<CoachAssignmentSort>>
}

export type QueryTypeCoachProfileArgs = {
  coachId: Scalars['ID']['input']
}

export type QueryTypeCoachSwitchingSummaryArgs = {
  coachId?: InputMaybe<Scalars['ID']['input']>
  coachingKind?: InputMaybe<CoachesCoachingKind>
  recurring?: InputMaybe<Scalars['Boolean']['input']>
  selectedSlot?: InputMaybe<Scalars['String']['input']>
}

export type QueryTypeDailyMeasurementsSourcePriorityArgs = {
  type: HealthDataMeasurementType
}

export type QueryTypeEffectiveDailyMeasurementArgs = {
  date: Scalars['String']['input']
  type: HealthDataMeasurementType
}

export type QueryTypeEhrAppointmentArgs = {
  id: Scalars['ID']['input']
}

export type QueryTypeEhrAppointmentSchedulingInfoArgs = {
  meetingAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type QueryTypeEhrAppointmentsArgs = {
  category?: InputMaybe<EhrAppointmentCategory>
  dynamicFilters?: InputMaybe<Array<EhrAppointmentDynamicFilterItem>>
  filterKind?: InputMaybe<FilterAppointmentsKind>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<EhrAppointmentSort>>
}

export type QueryTypeEhrAvailableDateSlotsArgs = {
  appointmentKind?: InputMaybe<EhrAppointmentKind>
  cadence?: InputMaybe<EhrAppointmentRecurrenceCadence>
  date?: InputMaybe<Scalars['String']['input']>
  providerId?: InputMaybe<Scalars['ID']['input']>
  providerKind?: InputMaybe<EhrAppointmentProviderKind>
  timeZone?: InputMaybe<Scalars['String']['input']>
  userState?: InputMaybe<AddressState>
}

export type QueryTypeEhrAvailableDatesArgs = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>
  appointmentKind?: InputMaybe<EhrAppointmentKind>
  cadence?: InputMaybe<EhrAppointmentRecurrenceCadence>
  endDate?: InputMaybe<Scalars['String']['input']>
  providerId?: InputMaybe<Scalars['ID']['input']>
  providerKind?: InputMaybe<EhrAppointmentProviderKind>
  startDate?: InputMaybe<Scalars['String']['input']>
  switchingCoach?: InputMaybe<Scalars['Boolean']['input']>
  timeZone?: InputMaybe<Scalars['String']['input']>
  userState?: InputMaybe<AddressState>
}

export type QueryTypeEhrAvailableDatesWithSlotsArgs = {
  appointmentKind?: InputMaybe<EhrAppointmentKind>
  cadence?: InputMaybe<EhrAppointmentRecurrenceCadence>
  coachSex?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  excludedProvidersHealthieIds?: InputMaybe<Array<Scalars['ID']['input']>>
  getHealthieInstanceKind?: InputMaybe<EhrGetHealthieInstanceKind>
  insurancePlan?: InputMaybe<UserInsurancePolicyKind>
  providerId?: InputMaybe<Scalars['ID']['input']>
  providerKind?: InputMaybe<EhrAppointmentProviderKind>
  referralPartner?: InputMaybe<UserReferralPartner>
  rescheduleAppointmentId?: InputMaybe<Scalars['ID']['input']>
  specialties?: InputMaybe<Array<EhrCoachSpecialty>>
  startDate?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<AddressState>
  timeZone?: InputMaybe<Scalars['String']['input']>
  uniqueSlots?: InputMaybe<Scalars['Boolean']['input']>
  useCache?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryTypeEhrEarlierAvailableSlotsArgs = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryTypeEhrPotentiallyRecurringSlotsArgs = {
  appointmentKind?: InputMaybe<EhrAppointmentKind>
  providerId?: InputMaybe<Scalars['ID']['input']>
  providerKind?: InputMaybe<EhrAppointmentProviderKind>
  timeZone?: InputMaybe<Scalars['String']['input']>
}

export type QueryTypeEhrSuggestedAvailabilityArgs = {
  appointmentKind?: InputMaybe<EhrAppointmentKind>
  excludedProvidersHealthieIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryTypeEstimateOneTimePaymentArgs = {
  purchasableItems: Array<PurchasableItem>
}

export type QueryTypeEstimateTaxArgs = {
  address?: InputMaybe<EstimateTaxAddress>
  country?: InputMaybe<AddressCountry>
  product?: InputMaybe<BillingProduct>
  providerPromotionCodeId?: InputMaybe<Scalars['String']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type QueryTypeFileArgs = {
  id: Scalars['ID']['input']
}

export type QueryTypeGenerateTerraAuthUrlArgs = {
  authRedirectUrl?: InputMaybe<Scalars['String']['input']>
  provider: Scalars['String']['input']
}

export type QueryTypeHealthDataReportArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryTypeInsuranceCardSubmissionArgs = {
  insurancePolicyStateId: Scalars['ID']['input']
}

export type QueryTypeInvoiceArgs = {
  id: Scalars['ID']['input']
}

export type QueryTypeKustomerArticleVersionPreviewArgs = {
  versionId: Scalars['String']['input']
}

export type QueryTypeKustomerArticleVersionsArgs = {
  query: Scalars['String']['input']
}

export type QueryTypeKustomerConversationMessagesArgs = {
  conversationId: Scalars['String']['input']
}

export type QueryTypeKustomerCreateConversationArgs = {
  email?: InputMaybe<Scalars['String']['input']>
  fullName?: InputMaybe<Scalars['String']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  subject?: InputMaybe<Scalars['String']['input']>
}

export type QueryTypeLabResultArgs = {
  id: Scalars['ID']['input']
}

export type QueryTypeLatestChargeArgs = {
  providerSubscriptionId: Scalars['ID']['input']
}

export type QueryTypeLatestSurveyLinkByKindArgs = {
  kind: SurveysConfigKind
}

export type QueryTypeLatestUserEhrAppointmentArgs = {
  category?: InputMaybe<EhrAppointmentCategory>
}

export type QueryTypeMealArgs = {
  id: Scalars['ID']['input']
}

export type QueryTypeMealImageDescriptionArgs = {
  image?: InputMaybe<Scalars['Upload']['input']>
  imageSignedId?: InputMaybe<Scalars['String']['input']>
}

export type QueryTypeNotificationInboxArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  stateFilter?: InputMaybe<NotificationInboxStateFilter>
}

export type QueryTypeOneTimePaymentCheckoutArgs = {
  id: Scalars['ID']['input']
}

export type QueryTypeProductArgs = {
  product: BillingProduct
}

export type QueryTypePromotionCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>
  product?: InputMaybe<BillingProduct>
}

export type QueryTypeReferralPartnerArgs = {
  partner: UserReferralPartner
}

export type QueryTypeResetPasswordRequestArgs = {
  email?: InputMaybe<Scalars['String']['input']>
}

export type QueryTypeSendUserInviteArgs = {
  email?: InputMaybe<Scalars['String']['input']>
}

export type QueryTypeUhcStoreSubscriptionsArgs = {
  dynamicFilters?: InputMaybe<Array<UhcStoreSubscriptionDynamicFilterItem>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sorts?: InputMaybe<Array<UhcStoreSubscriptionSort>>
}

export type QueryTypeWorkflowRunArgs = {
  runId: Scalars['String']['input']
}

export type Question = {
  __typename?: 'Question'
  actionButtonText?: Maybe<Scalars['String']['output']>
  coachBubbleLabel?: Maybe<Scalars['String']['output']>
  imageUrl?: Maybe<Scalars['String']['output']>
  key: SurveysQuestionKey
  label?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  required: Scalars['Boolean']['output']
  response: Response
}

export type QuestionsGroup = {
  __typename?: 'QuestionsGroup'
  banner?: Maybe<Scalars['String']['output']>
  introScreen?: Maybe<IntroScreen>
  questions: Array<Question>
}

export type Range = {
  __typename?: 'Range'
  max: Scalars['Float']['output']
  min: Scalars['Float']['output']
}

export type RangePair = {
  __typename?: 'RangePair'
  x: Range
  y: Scalars['Numeric']['output']
}

export type RangeUnit = {
  __typename?: 'RangeUnit'
  from?: Maybe<Scalars['Float']['output']>
  rating: Scalars['String']['output']
  to?: Maybe<Scalars['Float']['output']>
  type: Scalars['String']['output']
}

export type Reason = {
  __typename?: 'Reason'
  headline: Scalars['String']['output']
  inlineAlert?: Maybe<InlineAlert>
  message: ReasonMessage
  notes: Array<Scalars['String']['output']>
}

export type ReasonMessage = {
  __typename?: 'ReasonMessage'
  content: Scalars['String']['output']
  links?: Maybe<Array<ReasonMessageLink>>
}

export type ReasonMessageLink = {
  __typename?: 'ReasonMessageLink'
  placeholder: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type RecordedProgress = {
  __typename?: 'RecordedProgress'
  lesson: Lesson
  module: Module
  program: Program
}

export type Referral = {
  __typename?: 'Referral'
  credits: Scalars['Int']['output']
  description: Scalars['String']['output']
  discount: Scalars['Int']['output']
  discountPercentage?: Maybe<Scalars['Float']['output']>
  kind: ReferralCouponKind
  message: Scalars['String']['output']
  title: Scalars['String']['output']
}

export enum ReferralCouponKind {
  AmazonGiftCard = 'amazon_gift_card',
  Credits = 'credits',
}

/** Autogenerated return type of RegisterNotificationTokenAction. */
export type RegisterNotificationTokenActionPayload = {
  __typename?: 'RegisterNotificationTokenActionPayload'
  success: Scalars['Boolean']['output']
}

export type Reminder = {
  __typename?: 'Reminder'
  dayOfWeek?: Maybe<NotificationEngineReminderDayOfWeek>
  frequency: NotificationEngineReminderFrequency
  hoursInterval?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  kind: NotificationEngineReminderKind
  sendOn?: Maybe<Scalars['ISO8601Date']['output']>
  timeOfDay?: Maybe<Scalars['String']['output']>
}

export type ReminderCollection = {
  __typename?: 'ReminderCollection'
  reminders: Array<Reminder>
}

export type ReminderFrequency = {
  __typename?: 'ReminderFrequency'
  key: NotificationEngineReminderFrequency
}

export type ReminderKind = {
  __typename?: 'ReminderKind'
  allowedFrequencies: Array<ReminderFrequency>
  icon: Scalars['String']['output']
  key: NotificationEngineReminderKind
  title: Scalars['String']['output']
}

export type RemindersSettings = {
  __typename?: 'RemindersSettings'
  hoursInterval: HoursInterval
}

export type ReplaceActionGoal = {
  __typename?: 'ReplaceActionGoal'
  deletedActionGoal: ActionGoal
  newActionGoal: ActionGoal
}

export type ResearchFaqs = {
  __typename?: 'ResearchFaqs'
  dataProtectionUrl: Scalars['String']['output']
  eligibilityUrl: Scalars['String']['output']
  gettingStartedUrl: Scalars['String']['output']
  rootUrl: Scalars['String']['output']
}

export type Response = {
  __typename?: 'Response'
  answersGroups?: Maybe<Array<AnswersGroup>>
  kind: SurveysConfigObjectQuestionsGroupQuestionResponseKind
  kindMetadata?: Maybe<Scalars['JSON']['output']>
}

export type Scan = {
  __typename?: 'Scan'
  /** @deprecated deprecated in 4.6.1 */
  createdAt: Scalars['ISO8601DateTime']['output']
  /** @deprecated deprecated in 4.6.1 */
  id: Scalars['ID']['output']
  measurements: Array<Measurement>
  sensor?: Maybe<Sensor>
}

export type Schedule = {
  __typename?: 'Schedule'
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  currentPhaseEndAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  currentPhaseStartAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  phases: Array<SchedulePhase>
  releasedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  status: SubscriptionScheduleStatus
  stripeId: Scalars['String']['output']
  subscription?: Maybe<Subscription>
  updatedAt: Scalars['ISO8601DateTime']['output']
  user: User
}

export type ScheduleCollection = {
  __typename?: 'ScheduleCollection'
  schedules: Array<Schedule>
}

export type SchedulePhase = {
  __typename?: 'SchedulePhase'
  billingCycleAnchorChange?: Maybe<SubscriptionSchedulePhaseBillingCycleAnchorChange>
  createdAt: Scalars['ISO8601DateTime']['output']
  description?: Maybe<Scalars['String']['output']>
  endAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  price: Scalars['Float']['output']
  primaryProduct?: Maybe<ProductMin>
  startAt: Scalars['ISO8601DateTime']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type SchedulingInfoCadenceOption = {
  __typename?: 'SchedulingInfoCadenceOption'
  key: EhrAppointmentRecurrenceCadence
  label: Scalars['String']['output']
}

export type Score = {
  __typename?: 'Score'
  danger: Scalars['Int']['output']
  max: Scalars['Int']['output']
  warning: Scalars['Int']['output']
}

export type Secret = {
  __typename?: 'Secret'
  expiresAt: Scalars['ISO8601DateTime']['output']
  value: Scalars['String']['output']
}

export type SendMfaSmsCode = {
  __typename?: 'SendMfaSmsCode'
  success: Scalars['Boolean']['output']
  userEmail: Scalars['String']['output']
  userMaskedPhoneNumber?: Maybe<Scalars['String']['output']>
}

export type Sensor = {
  __typename?: 'Sensor'
  activationDate: Scalars['ISO8601Date']['output']
  activationTime: Scalars['ISO8601DateTime']['output']
  baselineAdjustment: Scalars['Int']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  daysRemaining: Scalars['Int']['output']
  description: Scalars['String']['output']
  expirationDate: Scalars['ISO8601Date']['output']
  expirationTime: Scalars['ISO8601DateTime']['output']
  expired: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  lastStatusChange?: Maybe<SensorStatusChange>
  /** @deprecated removed in v5.48.0 */
  model: Scalars['String']['output']
  modelEnum?: Maybe<SensorModel>
  serialNumber: Scalars['String']['output']
  status?: Maybe<Scalars['String']['output']>
}

export type SensorMode = {
  __typename?: 'SensorMode'
  kind: UserExperienceSensorModeKind
  syncDescription: Scalars['String']['output']
}

export enum SensorModel {
  DexcomG6 = 'dexcom_g6',
  DexcomG7 = 'dexcom_g7',
  DexcomG7_15Day = 'dexcom_g7_15_day',
  DexcomOnePlus = 'dexcom_one_plus',
  DexcomStelo = 'dexcom_stelo',
  Libre1 = 'libre1',
  Libre2 = 'libre2',
  Libre2Eu = 'libre2_eu',
  Libre3 = 'libre3',
  LibrePro = 'libre_pro',
  LibreUs = 'libre_us',
  Lingo = 'lingo',
  Unknown = 'unknown',
}

export type SensorSettings = {
  __typename?: 'SensorSettings'
  baselineAdjustmentOptions: Array<NumericalSelect>
}

export enum SensorStatus {
  Active = 'active',
  Error = 'error',
  Expired = 'expired',
  Failure = 'failure',
  InsertionDetection = 'insertion_detection',
  InsertionFailed = 'insertion_failed',
  Paired = 'paired',
  Ready = 'ready',
  Shutdown = 'shutdown',
  Starting = 'starting',
  Unknown = 'unknown',
}

export type SensorStatusChange = {
  __typename?: 'SensorStatusChange'
  createdAt: Scalars['ISO8601Date']['output']
  failure: Scalars['Boolean']['output']
  status: SensorStatus
}

export type Settings = {
  __typename?: 'Settings'
  cancellationPolicy: Scalars['String']['output']
  consumerHealthDataPrivacyPolicy: Scalars['String']['output']
  courtesyReminder: Scalars['String']['output']
  hipaaAuthorization: Scalars['String']['output']
  medicalDisclaimer: Scalars['String']['output']
  privacyPolicy: Scalars['String']['output']
  supportForm: Scalars['String']['output']
  telehealth: Scalars['String']['output']
  termsOfUse: Scalars['String']['output']
}

export enum ShippingOrderProductType {
  Cgm = 'cgm',
  FreeReplacement = 'free_replacement',
  NoShipping = 'no_shipping',
  PaidReplacement = 'paid_replacement',
  Patch = 'patch',
  Semaglutide = 'semaglutide',
  WelcomeKit = 'welcome_kit',
}

export type ShippingRule = {
  __typename?: 'ShippingRule'
  recurring: Scalars['Boolean']['output']
  recurringInvoiceInterval: Scalars['Int']['output']
  shippingType: ShippingOrderProductType
}

export type ShowAlertOnCloseBehavior = {
  __typename?: 'ShowAlertOnCloseBehavior'
  body: Scalars['String']['output']
  cancelTitle: Scalars['String']['output']
  confirmTitle: Scalars['String']['output']
  icon?: Maybe<UiIcon>
  title: Scalars['String']['output']
}

export type SignIn = {
  email: Scalars['String']['input']
  impersonate?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
}

export type Signup = {
  __typename?: 'Signup'
  learnMore: Scalars['String']['output']
}

export type SingleValueMeasurement = {
  __typename?: 'SingleValueMeasurement'
  value: Scalars['Float']['output']
}

export type Slots = {
  __typename?: 'Slots'
  slots: Array<EhrSlot>
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export type SpeechAudio = {
  __typename?: 'SpeechAudio'
  audioBase64: Scalars['String']['output']
  chunkId: Scalars['ID']['output']
  contentType: Scalars['String']['output']
}

export type Stat = {
  __typename?: 'Stat'
  mean: Scalars['Float']['output']
}

export type StatMeta = {
  __typename?: 'StatMeta'
  key: Scalars['String']['output']
  section: Scalars['String']['output']
}

export type StatRange = {
  __typename?: 'StatRange'
  danger?: Maybe<Scalars['Float']['output']>
  max?: Maybe<Scalars['Float']['output']>
  min?: Maybe<Scalars['Float']['output']>
  reverse?: Maybe<Scalars['Boolean']['output']>
  warning?: Maybe<Scalars['Float']['output']>
}

export type State = {
  __typename?: 'State'
  abbreviation: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type StateLicence = {
  __typename?: 'StateLicence'
  document?: Maybe<Scalars['String']['output']>
  expirationDate: Scalars['ISO8601Date']['output']
  expirationReminderEnabled: Scalars['Boolean']['output']
  state: AddressState
}

export type Statistic = {
  __typename?: 'Statistic'
  change: Scalars['Int']['output']
  description: Scalars['String']['output']
  displayValue?: Maybe<Scalars['String']['output']>
  meta: StatMeta
  range: StatRange
  title: Scalars['String']['output']
  type: Scalars['String']['output']
  units: Scalars['String']['output']
  value: Scalars['Float']['output']
  valuePrev: Scalars['Float']['output']
}

export type Statistics = {
  __typename?: 'Statistics'
  imperial: ConfigUnit
  metric: ConfigUnit
  name: Scalars['String']['output']
}

export type Stats = {
  __typename?: 'Stats'
  statistics: Array<Statistic>
}

export type StatsConfig = {
  __typename?: 'StatsConfig'
  filters: StatsFilters
}

export type StatsFilters = {
  __typename?: 'StatsFilters'
  types: Array<KeyValuePairStringArray>
}

export type StatsSettings = {
  __typename?: 'StatsSettings'
  key: Scalars['String']['output']
  order: Scalars['Int']['output']
  section: Scalars['String']['output']
  visible: Scalars['Boolean']['output']
}

export type StatsSettingsOrder = {
  key: Scalars['String']['input']
  order: Scalars['Int']['input']
  section: Scalars['String']['input']
  visible: Scalars['Boolean']['input']
}

export type StringPair = {
  __typename?: 'StringPair'
  displayValue?: Maybe<Scalars['String']['output']>
  /** @deprecated Removed in v3.9.1 */
  name?: Maybe<Scalars['String']['output']>
  x: Scalars['String']['output']
  y?: Maybe<Scalars['Numeric']['output']>
}

export type StringSelect = {
  __typename?: 'StringSelect'
  text: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type StringValue = {
  endDate: Scalars['ISO8601DateTime']['input']
  id?: InputMaybe<Scalars['String']['input']>
  metadata?: InputMaybe<Scalars['JSON']['input']>
  sourceId?: InputMaybe<Scalars['String']['input']>
  sourceName?: InputMaybe<Scalars['String']['input']>
  startDate: Scalars['ISO8601DateTime']['input']
  value: Scalars['String']['input']
}

export type SubmitInsuranceInformation = {
  __typename?: 'SubmitInsuranceInformation'
  completionDeepLink?: Maybe<Scalars['String']['output']>
}

export type Subscription = {
  __typename?: 'Subscription'
  allowedPauseCycles: Scalars['Int']['output']
  attachedSchedule?: Maybe<Schedule>
  cancelAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  checkoutOptions: Array<CheckoutOption>
  commitmentEndAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  currentPeriodEndAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  currentPeriodStartAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  dietitianAddOn: Scalars['Boolean']['output']
  discountedPrice: Scalars['Float']['output']
  effectivelyActive: Scalars['Boolean']['output']
  endAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  latestInvoice?: Maybe<Invoice>
  paidMonthsCount: Scalars['Int']['output']
  paused: Scalars['Boolean']['output']
  pausedMonthsCount: Scalars['Int']['output']
  /** @deprecated Removed usage in v2.7.0 */
  plans: Array<Plan>
  price: Scalars['Float']['output']
  /** @deprecated Use price and primary_product */
  primaryPlan: Plan
  primaryProduct: ProductMin
  resetBillingCycleAnchorAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  resumesAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  startAt: Scalars['ISO8601DateTime']['output']
  status: SubscriptionStatus
  stripeId: Scalars['String']['output']
  /** @deprecated Use status enum field */
  stripeStatus: Scalars['String']['output']
  subscribedAt: Scalars['ISO8601DateTime']['output']
  trialEndAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  uhcStoreSubscription?: Maybe<UhcStoreSubscription>
  updatedAt: Scalars['ISO8601DateTime']['output']
  user: User
}

export type SubscriptionAddress = {
  city: Scalars['String']['input']
  country?: InputMaybe<AddressCountries>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street: Scalars['String']['input']
  street2?: InputMaybe<Scalars['String']['input']>
  zipCode: Scalars['String']['input']
}

export enum SubscriptionBonusKind {
  ComplimentarySupportFullSub_1mo = 'complimentary_support_full_sub_1mo',
  ComplimentarySupportFullSub_3mo = 'complimentary_support_full_sub_3mo',
  ComplimentarySupportFullSub_6mo = 'complimentary_support_full_sub_6mo',
  ComplimentarySupportFullSub_12mo = 'complimentary_support_full_sub_12mo',
  Free_2MonthDietitianFor_6And_12MonthsCommitment = 'free_2_month_dietitian_for_6_and_12_months_commitment',
  Free_2MonthsDietitianFor_3_6_12MonthsCommitment = 'free_2_months_dietitian_for_3_6_12_months_commitment',
  Free_3MonthsDietitianFor_3MonthsCommitment = 'free_3_months_dietitian_for_3_months_commitment',
  FreeDietitianFor_4thMonthOnRenewal = 'free_dietitian_for_4th_month_on_renewal',
  FreeDietitianFor_6MonthsCommitment = 'free_dietitian_for_6_months_commitment',
  FreeDietitianFor_7thMonthOnRenewal = 'free_dietitian_for_7th_month_on_renewal',
  FreeDietitianFor_12MonthsCommitment = 'free_dietitian_for_12_months_commitment',
  FreeDietitianFor_13thMonthOnRenewal = 'free_dietitian_for_13th_month_on_renewal',
  MedicalConsultAddon = 'medical_consult_addon',
  PaidDietitianSupport = 'paid_dietitian_support',
}

export enum SubscriptionCheckoutOptionKind {
  Prescription = 'prescription',
  Research = 'research',
  Stelo = 'stelo',
}

export enum SubscriptionSchedulePhaseBillingCycleAnchorChange {
  Automatic = 'automatic',
  PhaseStart = 'phase_start',
}

export enum SubscriptionScheduleStatus {
  Active = 'active',
  Canceled = 'canceled',
  Completed = 'completed',
  NotStarted = 'not_started',
  Released = 'released',
}

export enum SubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unpaid = 'unpaid',
}

export type Success = {
  __typename?: 'Success'
  success: Scalars['Boolean']['output']
}

export type Suggested = {
  __typename?: 'Suggested'
  appointmentKind: EhrAppointmentKind
  meetingAt: Scalars['ISO8601DateTime']['output']
  providerId: Scalars['ID']['output']
  providerName?: Maybe<Scalars['String']['output']>
  providerProfile?: Maybe<CoachProfile>
  title?: Maybe<Scalars['String']['output']>
}

export type Summary = {
  __typename?: 'Summary'
  nonReschedulableAppointments: Array<EhrAppointment>
  recurringSlots: Array<Scalars['String']['output']>
  reschedulableAppointments: Array<EhrAppointment>
}

export type Survey = {
  __typename?: 'Survey'
  /** @deprecated use survey_link.early_exit_deep_link instead */
  allowEarlyExitBehavior?: Maybe<AllowEarlyExitBehavior>
  behavior: Behavior
  completedScreen?: Maybe<CompletedScreen>
  completionFlashMessage?: Maybe<Scalars['String']['output']>
  followups: Array<Followup>
  header?: Maybe<Scalars['String']['output']>
  kind: SurveysConfigKind
  questionsGroups: Array<QuestionsGroup>
  /** @deprecated Removed in v5.23.0 */
  research: Scalars['Boolean']['output']
  showAlertOnCloseBehavior?: Maybe<ShowAlertOnCloseBehavior>
  version: Scalars['String']['output']
}

export enum SurveyConfigItem {
  CompletedScreen = 'completed_screen',
  IntroScreen = 'intro_screen',
  Question = 'question',
}

export type SurveyLink = {
  __typename?: 'SurveyLink'
  completionDeepLink?: Maybe<Scalars['String']['output']>
  config: SurveyLinkConfig
  earlyExitDeepLink?: Maybe<Scalars['String']['output']>
  finished: Scalars['Boolean']['output']
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  inProgress: Scalars['Boolean']['output']
  outcome?: Maybe<Outcome>
  responses: Array<SurveyResponse>
  startedAt: Scalars['ISO8601DateTime']['output']
  state: SurveysUserLinkState
  survey: Survey
  user?: Maybe<User>
}

export type SurveyLinkCollection = {
  __typename?: 'SurveyLinkCollection'
  surveyLinks: Array<SurveyLink>
}

export type SurveyLinkConfig = {
  __typename?: 'SurveyLinkConfig'
  currentItemIndex: Scalars['Int']['output']
  items: Array<SurveyLinkConfigItem>
  questionsCount: Scalars['Int']['output']
  sectionsCount: Scalars['Int']['output']
}

export type SurveyLinkConfigCompletedItem = {
  __typename?: 'SurveyLinkConfigCompletedItem'
  footnote?: Maybe<Scalars['String']['output']>
  header: Scalars['String']['output']
  icon?: Maybe<UiIcon>
  iconColor?: Maybe<UiColor>
  introMarkdown?: Maybe<Scalars['String']['output']>
  primaryActionText?: Maybe<Scalars['String']['output']>
  secondaryActionLink?: Maybe<Link>
  showCoachPhoto: Scalars['Boolean']['output']
  title?: Maybe<Scalars['String']['output']>
  type: SurveyConfigItem
}

export type SurveyLinkConfigIntroItem = {
  __typename?: 'SurveyLinkConfigIntroItem'
  footnote?: Maybe<Scalars['String']['output']>
  header: Scalars['String']['output']
  icon?: Maybe<UiIcon>
  imageUrl?: Maybe<Scalars['String']['output']>
  inlineAlert?: Maybe<InlineAlert>
  introMarkdown?: Maybe<Scalars['String']['output']>
  type: SurveyConfigItem
}

export type SurveyLinkConfigItem =
  | SurveyLinkConfigCompletedItem
  | SurveyLinkConfigIntroItem
  | SurveyLinkConfigQuestionItem

export type SurveyLinkConfigQuestionItem = {
  __typename?: 'SurveyLinkConfigQuestionItem'
  actionButtonText?: Maybe<Scalars['String']['output']>
  coachBubbleLabel?: Maybe<Scalars['String']['output']>
  imageUrl?: Maybe<Scalars['String']['output']>
  key: SurveysQuestionKey
  label?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  primaryActionLink?: Maybe<Link>
  required: Scalars['Boolean']['output']
  response: Response
  secondaryActionLink?: Maybe<Link>
  type: SurveyConfigItem
}

export type SurveyResponse = {
  __typename?: 'SurveyResponse'
  answer: Scalars['JSON']['output']
  id: Scalars['ID']['output']
  questionKey: SurveysQuestionKey
  surveyLink: SurveyLink
}

export type SurveyResponseItem = {
  answer: Scalars['JSON']['input']
  questionKey: Scalars['String']['input']
}

export type SurveyResponses = {
  __typename?: 'SurveyResponses'
  responses: Array<SurveyResponse>
}

export enum SurveysConfigKind {
  AccountInterest = 'account_interest',
  BiosensorRequirements = 'biosensor_requirements',
  Cancellation = 'cancellation',
  CareEligibility = 'care_eligibility',
  CareIntake = 'care_intake',
  CareLabWorkResults = 'care_lab_work_results',
  CareRenewal = 'care_renewal',
  CgmMedicalDisclaimer = 'cgm_medical_disclaimer',
  CgmPrerequisite = 'cgm_prerequisite',
  ChurnFeedback = 'churn_feedback',
  CoachingGoalsAndPreferences = 'coaching_goals_and_preferences',
  ConstructiveFeedback = 'constructive_feedback',
  Demographics = 'demographics',
  DexcomResearchConsent = 'dexcom_research_consent',
  DietaryHabits = 'dietary_habits',
  DppEligibility = 'dpp_eligibility',
  DppEnrollment = 'dpp_enrollment',
  DppEvidence = 'dpp_evidence',
  DppScheduling = 'dpp_scheduling',
  ExerciseHabits = 'exercise_habits',
  Goals = 'goals',
  GovernmentId = 'government_id',
  GroupVideoCallsEligibility = 'group_video_calls_eligibility',
  GroupVideoCallsInsuranceIneligible = 'group_video_calls_insurance_ineligible',
  Health = 'health',
  HealthCoachingPostCallFeedback = 'health_coaching_post_call_feedback',
  HealthCoachingPostCallFeedbackLowRating = 'health_coaching_post_call_feedback_low_rating',
  HealthUpdate = 'health_update',
  Insurance = 'insurance',
  InsuranceCallHesitation = 'insurance_call_hesitation',
  InsuranceEarlyExit = 'insurance_early_exit',
  InsuranceFallback = 'insurance_fallback',
  MedicalDisclaimer = 'medical_disclaimer',
  MedicalHistory = 'medical_history',
  MentalHealthServicesInterest = 'mental_health_services_interest',
  MidpointPulse = 'midpoint_pulse',
  NetPromoterScore = 'net_promoter_score',
  NutritionistReferral = 'nutritionist_referral',
  OnboardingExperienceBasicInformation = 'onboarding_experience_basic_information',
  OnboardingExperienceGoals = 'onboarding_experience_goals',
  OnboardingExperiencePace = 'onboarding_experience_pace',
  OneMonthActiveFeedback = 'one_month_active_feedback',
  OwnSensor = 'own_sensor',
  OwnSensorGoal = 'own_sensor_goal',
  PostCallFeedback = 'post_call_feedback',
  PostCallFeedbackLowRating = 'post_call_feedback_low_rating',
  PostCoachSwitch = 'post_coach_switch',
  ProductMarketFit = 'product_market_fit',
  RecurringSubscriptionConsent = 'recurring_subscription_consent',
  SatisfactionRating = 'satisfaction_rating',
  SleepHabits = 'sleep_habits',
  SteloEligibility = 'stelo_eligibility',
  VideoCallFeedback = 'video_call_feedback',
  VideoCallsSteloUpsellReferral = 'video_calls_stelo_upsell_referral',
  WeightLossExperienceDesiredWeight = 'weight_loss_experience_desired_weight',
  WeightLossExperienceGoalsAndHabits = 'weight_loss_experience_goals_and_habits',
  WeightLossExperiencePace = 'weight_loss_experience_pace',
}

export enum SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswerFollowupKind {
  Inline = 'inline',
  Standalone = 'standalone',
}

export enum SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswersOrder {
  Random = 'random',
  Serial = 'serial',
}

export enum SurveysConfigObjectQuestionsGroupQuestionResponseKind {
  Address = 'address',
  CheckboxMulti = 'checkbox_multi',
  Consent = 'consent',
  DateInput = 'date_input',
  FileUpload = 'file_upload',
  HeightImperial = 'height_imperial',
  LikertScale = 'likert_scale',
  PhoneNumber = 'phone_number',
  Radio = 'radio',
  Ruler = 'ruler',
  SelectSingle = 'select_single',
  Slider = 'slider',
  SliderWithSkip = 'slider_with_skip',
  TabsTextInput = 'tabs_text_input',
  TextArea = 'text_area',
  TextAreaWithSkip = 'text_area_with_skip',
  TextInput = 'text_input',
}

export enum SurveysQuestionKey {
  Address = 'address',
  AdhesiveAllergy = 'adhesive_allergy',
  AetnaInsurancePlanType = 'aetna_insurance_plan_type',
  AgeRange = 'age_range',
  AlcoholicBeveragesFrequency = 'alcoholic_beverages_frequency',
  AnnualIncomeRange = 'annual_income_range',
  AnthemInsurancePlanType = 'anthem_insurance_plan_type',
  AnythingElse = 'anything_else',
  AppetiteChange = 'appetite_change',
  AppetiteLevel = 'appetite_level',
  AvoidingDiabetesPriority = 'avoiding_diabetes_priority',
  BedtimeRoutine = 'bedtime_routine',
  BedtimeRoutineOther = 'bedtime_routine_other',
  BetterStatementAboutOwnHealth = 'better_statement_about_own_health',
  BiologicalSex = 'biological_sex',
  BirthDate = 'birth_date',
  BloodPressureRisk = 'blood_pressure_risk',
  BloodTestRisk = 'blood_test_risk',
  BlueCrossBlueShieldInsurancePlanType = 'blue_cross_blue_shield_insurance_plan_type',
  Bmi = 'bmi',
  BmiRange = 'bmi_range',
  BodyFat = 'body_fat',
  BodyPhoto = 'body_photo',
  BreakfastFrequency = 'breakfast_frequency',
  CancellationReason = 'cancellation_reason',
  CancellationReasonOther = 'cancellation_reason_other',
  CancerTreatment = 'cancer_treatment',
  CgmDevice = 'cgm_device',
  CgmDeviceOther = 'cgm_device_other',
  ChurnFeedbackCustomerSupportReason = 'churn_feedback_customer_support_reason',
  ChurnFeedbackCustomerSupportReasonOther = 'churn_feedback_customer_support_reason_other',
  ChurnFeedbackInsuranceManagementReason = 'churn_feedback_insurance_management_reason',
  ChurnFeedbackInsuranceManagementReasonOther = 'churn_feedback_insurance_management_reason_other',
  ChurnFeedbackMainAreaNotMetExpectations = 'churn_feedback_main_area_not_met_expectations',
  ChurnFeedbackMainAreaNotMetExpectationsOther = 'churn_feedback_main_area_not_met_expectations_other',
  ChurnFeedbackNutritionistServiceReason = 'churn_feedback_nutritionist_service_reason',
  ChurnFeedbackNutritionistServiceReasonOther = 'churn_feedback_nutritionist_service_reason_other',
  ChurnFeedbackTimingConstraintsReason = 'churn_feedback_timing_constraints_reason',
  ChurnFeedbackTimingConstraintsReasonOther = 'churn_feedback_timing_constraints_reason_other',
  CignaInsurancePlanType = 'cigna_insurance_plan_type',
  CoachBetterSupport = 'coach_better_support',
  CoachFocus = 'coach_focus',
  CoachGoalsOpenToPhysicalActivityChanges = 'coach_goals_open_to_physical_activity_changes',
  CoachSwitchReason = 'coach_switch_reason',
  CoachSwitchReasonOther = 'coach_switch_reason_other',
  CoachValueSoFar = 'coach_value_so_far',
  CoachingExperienceIssuesDetails = 'coaching_experience_issues_details',
  CoachingExperienceIssuesDetailsOther = 'coaching_experience_issues_details_other',
  CoachingGoalsAdditionalGoals = 'coaching_goals_additional_goals',
  CoachingGoalsAdditionalGoalsOther = 'coaching_goals_additional_goals_other',
  CoachingGoalsBiggestChallenges = 'coaching_goals_biggest_challenges',
  CoachingGoalsBiggestChallengesOther = 'coaching_goals_biggest_challenges_other',
  CoachingGoalsCurrentDiet = 'coaching_goals_current_diet',
  CoachingGoalsMotivationToChangeEatingHabits = 'coaching_goals_motivation_to_change_eating_habits',
  CoachingGoalsPhysicalActivity = 'coaching_goals_physical_activity',
  CoachingGoalsStyle = 'coaching_goals_style',
  CoachingStyle = 'coaching_style',
  CommunicationFrequency = 'communication_frequency',
  ComplimentarySupportDecision = 'complimentary_support_decision',
  CompoundedSemaglutideConsent = 'compounded_semaglutide_consent',
  ConfidentInterpretGlucoseData = 'confident_interpret_glucose_data',
  ConfirmReject = 'confirm_reject',
  CurrentHba1cLevel = 'current_hba1c_level',
  DairyProductsFrequency = 'dairy_products_frequency',
  DefineProgress = 'define_progress',
  DescribesYou = 'describes_you',
  DescribesYouOther = 'describes_you_other',
  DexcomAppCompatibility = 'dexcom_app_compatibility',
  DexcomResearchConsent = 'dexcom_research_consent',
  Diabetes = 'diabetes',
  DiabetesDiagnosis = 'diabetes_diagnosis',
  DiabetesMedication = 'diabetes_medication',
  DiagnosedConditions = 'diagnosed_conditions',
  DiagnosedConditions2 = 'diagnosed_conditions2',
  DiagnosedConditionsOther = 'diagnosed_conditions_other',
  Diet = 'diet',
  DietOther = 'diet_other',
  DietaryGuidelinesRestrictions = 'dietary_guidelines_restrictions',
  DietaryGuidelinesRestrictionsOther = 'dietary_guidelines_restrictions_other',
  DietaryHabitsChanges = 'dietary_habits_changes',
  DietaryHabitsChangesDetails = 'dietary_habits_changes_details',
  DietaryHabitsChangesDetailsOther = 'dietary_habits_changes_details_other',
  DinnerFrequency = 'dinner_frequency',
  Disabilities = 'disabilities',
  DiscoverNs = 'discover_ns',
  DiscoverNsBlog = 'discover_ns_blog',
  DiscoverNsDoctor = 'discover_ns_doctor',
  DiscoverNsFacebook = 'discover_ns_facebook',
  DiscoverNsFamily = 'discover_ns_family',
  DiscoverNsFriend = 'discover_ns_friend',
  DiscoverNsInfluencer = 'discover_ns_influencer',
  DiscoverNsInstagram = 'discover_ns_instagram',
  DiscoverNsLinkedin = 'discover_ns_linkedin',
  DiscoverNsMagazine = 'discover_ns_magazine',
  DiscoverNsMedia = 'discover_ns_media',
  DiscoverNsNewsletter = 'discover_ns_newsletter',
  DiscoverNsOther = 'discover_ns_other',
  DiscoverNsPinterest = 'discover_ns_pinterest',
  DiscoverNsPodcast = 'discover_ns_podcast',
  DiscoverNsRadio = 'discover_ns_radio',
  DiscoverNsReddit = 'discover_ns_reddit',
  DiscoverNsSearchEngine = 'discover_ns_search_engine',
  DiscoverNsTikTok = 'discover_ns_tik_tok',
  DiscoverNsTwitter = 'discover_ns_twitter',
  DiscoverNsYoutube = 'discover_ns_youtube',
  DppCommercialInsurancePlan = 'dpp_commercial_insurance_plan',
  DppCommercialInsurancePlanOther = 'dpp_commercial_insurance_plan_other',
  DppHbA1cEvidence = 'dpp_hb_a1c_evidence',
  DppHealthcareProfessionalRecommendation = 'dpp_healthcare_professional_recommendation',
  DppInsurancePlan = 'dpp_insurance_plan',
  DppPreferredCallDays = 'dpp_preferred_call_days',
  DppPreferredCallTimes = 'dpp_preferred_call_times',
  DppProgramMotivation = 'dpp_program_motivation',
  EarliestWakeUpTime = 'earliest_wake_up_time',
  EatOutFrequency = 'eat_out_frequency',
  EatingDisorder = 'eating_disorder',
  EatingDisorderType = 'eating_disorder_type',
  EducationLevel = 'education_level',
  EducationLevelOther = 'education_level_other',
  ElectronicDevicesBeforeBedtime = 'electronic_devices_before_bedtime',
  EmploymentStatus = 'employment_status',
  EmploymentStatusOther = 'employment_status_other',
  EnergyLevelsChanges = 'energy_levels_changes',
  Ethnicity = 'ethnicity',
  EthnicityOther = 'ethnicity_other',
  ExerciseDuration = 'exercise_duration',
  ExerciseHabitsChanges = 'exercise_habits_changes',
  ExerciseHabitsChangesDetails = 'exercise_habits_changes_details',
  ExerciseHabitsChangesDetailsOther = 'exercise_habits_changes_details_other',
  ExerciseLocation = 'exercise_location',
  ExerciseLocationOther = 'exercise_location_other',
  ExerciseMotivation = 'exercise_motivation',
  ExerciseMotivationOther = 'exercise_motivation_other',
  ExerciseTypes = 'exercise_types',
  ExerciseTypesOther = 'exercise_types_other',
  FallAsleepTime = 'fall_asleep_time',
  FamiliarPrediabeticsConfirmation = 'familiar_prediabetics_confirmation',
  FamilyDiabetes = 'family_diabetes',
  FamilyMedicalConditions = 'family_medical_conditions',
  FastingGlucoseToleranceBloodTest = 'fasting_glucose_tolerance_blood_test',
  FishSeafoodFrequency = 'fish_seafood_frequency',
  FoodAllergies = 'food_allergies',
  FoodAllergiesIntolerances = 'food_allergies_intolerances',
  FoodAllergiesIntolerancesOther = 'food_allergies_intolerances_other',
  FoodAllergiesOther = 'food_allergies_other',
  FoodCravings = 'food_cravings',
  FoodCravingsChange = 'food_cravings_change',
  FoodCravingsDescription = 'food_cravings_description',
  FoodSymptoms = 'food_symptoms',
  FoodSymptomsOther = 'food_symptoms_other',
  FruitsVegetablesFrequency = 'fruits_vegetables_frequency',
  Gender = 'gender',
  GestationalDiabetesDiagnosis = 'gestational_diabetes_diagnosis',
  GlpActivePrescription = 'glp_active_prescription',
  GlpAdditionalHealthConditions = 'glp_additional_health_conditions',
  GlpCommonSideEffects = 'glp_common_side_effects',
  GlpConditions = 'glp_conditions',
  GlpConsiderPregnant = 'glp_consider_pregnant',
  GlpCurrentDose = 'glp_current_dose',
  GlpDosePreference = 'glp_dose_preference',
  GlpDoseScheduleAdherence = 'glp_dose_schedule_adherence',
  GlpDoseScheduleAdherenceDescription = 'glp_dose_schedule_adherence_description',
  GlpElevatedTriglycerides = 'glp_elevated_triglycerides',
  GlpElevatedTriglyceridesValue = 'glp_elevated_triglycerides_value',
  GlpFutureMonthsMedication = 'glp_future_months_medication',
  GlpGallbladderDisease = 'glp_gallbladder_disease',
  GlpGallbladderRemoved = 'glp_gallbladder_removed',
  GlpGastricBypassSurgery = 'glp_gastric_bypass_surgery',
  GlpGastricBypassSurgeryDate = 'glp_gastric_bypass_surgery_date',
  GlpGastricBypassSurgeryType = 'glp_gastric_bypass_surgery_type',
  GlpGoal = 'glp_goal',
  GlpGoalOther = 'glp_goal_other',
  GlpHeaviestWeightInPounds = 'glp_heaviest_weight_in_pounds',
  GlpHistoryBipolarDepression = 'glp_history_bipolar_depression',
  GlpIncreasePhysicalActivity = 'glp_increase_physical_activity',
  GlpIndianAsianDescent = 'glp_indian_asian_descent',
  GlpKidneyDisease = 'glp_kidney_disease',
  GlpKidneyDiseaseGfr = 'glp_kidney_disease_gfr',
  GlpLabWorkResults = 'glp_lab_work_results',
  GlpLastInPersonMedicalEvaluationDate = 'glp_last_in_person_medical_evaluation_date',
  GlpMedicationChallenges = 'glp_medication_challenges',
  GlpMedicationChallengesDescription = 'glp_medication_challenges_description',
  GlpMedicationQualityOfLife = 'glp_medication_quality_of_life',
  GlpOtherDose = 'glp_other_dose',
  GlpOtherSideEffects = 'glp_other_side_effects',
  GlpPhysicianQuestions = 'glp_physician_questions',
  GlpPrescriptionMedications = 'glp_prescription_medications',
  GlpPrescriptionMedicationsList = 'glp_prescription_medications_list',
  GlpProgressRate = 'glp_progress_rate',
  GlpProviderQuestions = 'glp_provider_questions',
  GlpPsychiatricFacility = 'glp_psychiatric_facility',
  GlpReduceCaloricIntake = 'glp_reduce_caloric_intake',
  GlpRestrictedConditions = 'glp_restricted_conditions',
  GlpSevereSideEffects = 'glp_severe_side_effects',
  GlpTakingWeightMedication = 'glp_taking_weight_medication',
  GlpTriedWeightManagement = 'glp_tried_weight_management',
  GlpTriedWeightManagementOther = 'glp_tried_weight_management_other',
  GlpWeightGoalInPounds = 'glp_weight_goal_in_pounds',
  GlucoseManagementKnowledge = 'glucose_management_knowledge',
  GoalsPrevention = 'goals_prevention',
  GoalsPreventionOther = 'goals_prevention_other',
  GotWhatNeededDetails = 'got_what_needed_details',
  GotWhatNeededMostHelpful = 'got_what_needed_most_helpful',
  GovernmentIdCard = 'government_id_card',
  GroupCoachingParticipation = 'group_coaching_participation',
  HadIssuesWithExperienceDetails = 'had_issues_with_experience_details',
  HavingOwnHealthUpsAndDownsConfirmation = 'having_own_health_ups_and_downs_confirmation',
  Hba1cBloodTest = 'hba1c_blood_test',
  Hba1cBloodTestRange = 'hba1c_blood_test_range',
  Hba1cBloodTestResult = 'hba1c_blood_test_result',
  Hba1cMeasurementTime = 'hba1c_measurement_time',
  HealthConditions = 'health_conditions',
  HealthConditionsImpactExercise = 'health_conditions_impact_exercise',
  HealthConditionsOther = 'health_conditions_other',
  HealthGoal = 'health_goal',
  HealthInsuranceCard = 'health_insurance_card',
  Height = 'height',
  HeightInInches = 'height_in_inches',
  HighmarkInsurancePlanType = 'highmark_insurance_plan_type',
  HipCircumferenceInInches = 'hip_circumference_in_inches',
  HorizonInsurancePlanType = 'horizon_insurance_plan_type',
  HowCanWeImprove = 'how_can_we_improve',
  InjuriesImpactExercise = 'injuries_impact_exercise',
  Insulin = 'insulin',
  InsulinOrCancerTreatment = 'insulin_or_cancer_treatment',
  InsuranceCallHesitationReason = 'insurance_call_hesitation_reason',
  InsuranceCallHesitationReasonOther = 'insurance_call_hesitation_reason_other',
  InsuranceEarlyExitReason = 'insurance_early_exit_reason',
  InsuranceEarlyExitReasonOther = 'insurance_early_exit_reason_other',
  InsuranceEarlyExitSecondReason = 'insurance_early_exit_second_reason',
  InsuranceEarlyExitSecondReasonOther = 'insurance_early_exit_second_reason_other',
  InsuranceEarlyExitWantToSpeakToOurMd = 'insurance_early_exit_want_to_speak_to_our_md',
  InsuranceGroupNumber = 'insurance_group_number',
  InsuranceMemberId = 'insurance_member_id',
  InsurancePlan = 'insurance_plan',
  InsurancePlanOther = 'insurance_plan_other',
  InsurancePolicyHolder = 'insurance_policy_holder',
  InsurancePolicyHolderDateOfBirth = 'insurance_policy_holder_date_of_birth',
  InsurancePolicyHolderFirstName = 'insurance_policy_holder_first_name',
  InsurancePolicyHolderLastName = 'insurance_policy_holder_last_name',
  InsurancePolicyHolderOther = 'insurance_policy_holder_other',
  InsuranceReimbursementPossibility = 'insurance_reimbursement_possibility',
  InsuranceVideoCallGoal = 'insurance_video_call_goal',
  InsuranceVideoCallGoalOther = 'insurance_video_call_goal_other',
  LabWork = 'lab_work',
  LabWorkResults = 'lab_work_results',
  LearnSpecificFoodsAffectDiabetes = 'learn_specific_foods_affect_diabetes',
  LifestyleChanges = 'lifestyle_changes',
  LifestyleConfidence = 'lifestyle_confidence',
  LikelihoodFollowWorkoutPlan = 'likelihood_follow_workout_plan',
  LikelihoodToChangeSleepHabits = 'likelihood_to_change_sleep_habits',
  LongTermWeightGoalEffort = 'long_term_weight_goal_effort',
  LunchFrequency = 'lunch_frequency',
  MedicalDisclaimerConsent = 'medical_disclaimer_consent',
  MedicalHistoryChanges = 'medical_history_changes',
  MedicalHistoryChangesDescription = 'medical_history_changes_description',
  MedicationChanges = 'medication_changes',
  Medications = 'medications',
  MentalHealthTherapistInterest = 'mental_health_therapist_interest',
  MetabolismDisorder = 'metabolism_disorder',
  MobileAppMedicalDisclaimer = 'mobile_app_medical_disclaimer',
  MorningRestfulness = 'morning_restfulness',
  NetPromoterScoreChangeSuggestion = 'net_promoter_score_change_suggestion',
  NetPromoterScoreLoveMost = 'net_promoter_score_love_most',
  NetPromoterScoreMissingOrFrustrating = 'net_promoter_score_missing_or_frustrating',
  NetPromoterScoreRecommendationLevel = 'net_promoter_score_recommendation_level',
  NfcSupported = 'nfc_supported',
  NotUnderstandingOwnHealthConfirmation = 'not_understanding_own_health_confirmation',
  NsValueInPastTwoWeeks = 'ns_value_in_past_two_weeks',
  NutritionKnowledge = 'nutrition_knowledge',
  NutritionistContinueReachGoals = 'nutritionist_continue_reach_goals',
  NutritionistReferral = 'nutritionist_referral',
  NutritionistReferralCoachId = 'nutritionist_referral_coach_id',
  NutritionistReferralProductKey = 'nutritionist_referral_product_key',
  NutritionistStartStopReachGoals = 'nutritionist_start_stop_reach_goals',
  Occupation = 'occupation',
  OnboardingExperienceBiggestChallenges = 'onboarding_experience_biggest_challenges',
  OnboardingExperienceBiggestChallengesOther = 'onboarding_experience_biggest_challenges_other',
  OnboardingExperienceChallenges = 'onboarding_experience_challenges',
  OnboardingExperienceComfortablePace = 'onboarding_experience_comfortable_pace',
  OnboardingExperienceCurrentDiet = 'onboarding_experience_current_diet',
  OnboardingExperienceDesiredWeight = 'onboarding_experience_desired_weight',
  OnboardingExperienceMainGoals = 'onboarding_experience_main_goals',
  OnboardingExperienceMotivationToChangeEatingHabits = 'onboarding_experience_motivation_to_change_eating_habits',
  OnboardingExperienceOpenToPhysicalActivityChanges = 'onboarding_experience_open_to_physical_activity_changes',
  OnboardingExperiencePhysicalActivity = 'onboarding_experience_physical_activity',
  OnboardingExperiencePrimaryMotivation = 'onboarding_experience_primary_motivation',
  OnboardingExperiencePrimaryMotivationOther = 'onboarding_experience_primary_motivation_other',
  OnboardingExperienceProgress = 'onboarding_experience_progress',
  OnboardingExperienceTriedChanges = 'onboarding_experience_tried_changes',
  OnboardingExperienceTriedLoseWeight = 'onboarding_experience_tried_lose_weight',
  OneMonthActiveFeedbackDietitian = 'one_month_active_feedback_dietitian',
  OtherAllergies = 'other_allergies',
  OtherAllergiesList = 'other_allergies_list',
  OtherInsurancePlanType = 'other_insurance_plan_type',
  OwnGlucometer = 'own_glucometer',
  OwnSensorGoal = 'own_sensor_goal',
  OwnSensorGoalOther = 'own_sensor_goal_other',
  PainOrDiscomfortDuringSleep = 'pain_or_discomfort_during_sleep',
  PastHealthConditions = 'past_health_conditions',
  PharmacyServicesConsent = 'pharmacy_services_consent',
  PhoneNumber = 'phone_number',
  PhysicalActivity = 'physical_activity',
  PhysicalActivityFrequency = 'physical_activity_frequency',
  PostCallFeedbackContinuation = 'post_call_feedback_continuation',
  PostCallFeedbackDoneBetter = 'post_call_feedback_done_better',
  PostCallFeedbackMostValuable = 'post_call_feedback_most_valuable',
  PostCallFeedbackMostValuableOther = 'post_call_feedback_most_valuable_other',
  PoultryFrequency = 'poultry_frequency',
  PreExistingMedicalConditions = 'pre_existing_medical_conditions',
  PreExistingMedicalConditionsList = 'pre_existing_medical_conditions_list',
  Pregnancy = 'pregnancy',
  PregnancyTerms = 'pregnancy_terms',
  PrescriptionMedications = 'prescription_medications',
  PrescriptionMedicationsList = 'prescription_medications_list',
  PrimaryJoiningGoal = 'primary_joining_goal',
  PrimaryJoiningGoalOther = 'primary_joining_goal_other',
  ProcessedFoodFrequency = 'processed_food_frequency',
  ProductMarketFitBenefit = 'product_market_fit_benefit',
  ProductMarketFitFeeling = 'product_market_fit_feeling',
  ProductMarketFitImprovement = 'product_market_fit_improvement',
  ProductMarketFitTypeOfPerson = 'product_market_fit_type_of_person',
  RecurringSubscriptionConsent = 'recurring_subscription_consent',
  RedMeatFrequency = 'red_meat_frequency',
  ReversedConditions = 'reversed_conditions',
  ReversedConditionsOther = 'reversed_conditions_other',
  SanaBenefitsInsurancePlanType = 'sana_benefits_insurance_plan_type',
  SatisfactionRating = 'satisfaction_rating',
  SatisfactionRatingDescription = 'satisfaction_rating_description',
  SensorIssuesDetails = 'sensor_issues_details',
  SensorIssuesDetailsOther = 'sensor_issues_details_other',
  ServiceNotValuableDetails = 'service_not_valuable_details',
  Sex = 'sex',
  ShareWithCoach = 'share_with_coach',
  SittingHours = 'sitting_hours',
  SleepChanges = 'sleep_changes',
  SleepChangesDetails = 'sleep_changes_details',
  SleepChangesDetailsOther = 'sleep_changes_details_other',
  SleepDisorderDiagnosis = 'sleep_disorder_diagnosis',
  SleepHours = 'sleep_hours',
  SnackFrequency = 'snack_frequency',
  SteloDeviceEligibility = 'stelo_device_eligibility',
  SteloMedicalEligibility = 'stelo_medical_eligibility',
  StepsPerDay = 'steps_per_day',
  Stress = 'stress',
  SubstancesBeforeBedtime = 'substances_before_bedtime',
  SuccessLookLike = 'success_look_like',
  SugaryDrinksFrequency = 'sugary_drinks_frequency',
  Supplements = 'supplements',
  SurgeriesHospitalizations = 'surgeries_hospitalizations',
  TechAppIssuesDetails = 'tech_app_issues_details',
  TechAppIssuesDetailsOther = 'tech_app_issues_details_other',
  TelehealthConsent = 'telehealth_consent',
  TooExpensiveDetails = 'too_expensive_details',
  TooExpensiveDetailsOther = 'too_expensive_details_other',
  Type_2DiabetesComplications = 'type_2_diabetes_complications',
  Type_2DiabetesDate = 'type_2_diabetes_date',
  Type_2DiabetesManagement = 'type_2_diabetes_management',
  UnfamiliarPrediabeticsConfirmation = 'unfamiliar_prediabetics_confirmation',
  UnitedHealthcareInsurancePlanType = 'united_healthcare_insurance_plan_type',
  VideoCallFeedbackConfidence = 'video_call_feedback_confidence',
  VideoCallFeedbackContinuation = 'video_call_feedback_continuation',
  VideoCallFeedbackImprovements = 'video_call_feedback_improvements',
  VideoCallFeedbackMostValuable = 'video_call_feedback_most_valuable',
  VideoCallFeedbackUsefulness = 'video_call_feedback_usefulness',
  VideoCallFeedbackWhy = 'video_call_feedback_why',
  VideoCallsSteloUpsellReferral = 'video_calls_stelo_upsell_referral',
  VideoCallsSteloUpsellReferralCoachId = 'video_calls_stelo_upsell_referral_coach_id',
  WaistCircumferenceInInches = 'waist_circumference_in_inches',
  WakeUpFrequency = 'wake_up_frequency',
  Weight = 'weight',
  WeightChange = 'weight_change',
  WeightGainedInPounds = 'weight_gained_in_pounds',
  WeightGoalEffortWorksForYou = 'weight_goal_effort_works_for_you',
  WeightInPounds = 'weight_in_pounds',
  WeightLossExperienceBiggestChallenges = 'weight_loss_experience_biggest_challenges',
  WeightLossExperienceBiggestChallengesOther = 'weight_loss_experience_biggest_challenges_other',
  WeightLossExperienceComfortablePace = 'weight_loss_experience_comfortable_pace',
  WeightLossExperienceCurrentDiet = 'weight_loss_experience_current_diet',
  WeightLossExperienceDesiredWeight = 'weight_loss_experience_desired_weight',
  WeightLossExperienceMotivationToChangeEatingHabits = 'weight_loss_experience_motivation_to_change_eating_habits',
  WeightLossExperienceOpenToPhysicalActivityChanges = 'weight_loss_experience_open_to_physical_activity_changes',
  WeightLossExperiencePhysicalActivity = 'weight_loss_experience_physical_activity',
  WeightLossExperiencePrimaryMotivation = 'weight_loss_experience_primary_motivation',
  WeightLossExperiencePrimaryMotivationOther = 'weight_loss_experience_primary_motivation_other',
  WeightLossExperienceTriedLoseWeight = 'weight_loss_experience_tried_lose_weight',
  WeightLostInPounds = 'weight_lost_in_pounds',
  WillingToPay = 'willing_to_pay',
  WillingToPayComments = 'willing_to_pay_comments',
  WillingToPayMaximum = 'willing_to_pay_maximum',
  WillingToPayMaximumOther = 'willing_to_pay_maximum_other',
  WorkedWithTrainer = 'worked_with_trainer',
}

export enum SurveysUserLinkState {
  Completed = 'completed',
  Processed = 'processed',
  Restarted = 'restarted',
  Started = 'started',
  Stopped = 'stopped',
}

export enum TerraProviderKind {
  AppleHealth = 'apple_health',
  Fitbit = 'fitbit',
  FreeStyleLibre = 'free_style_libre',
  Garmin = 'garmin',
  GoogleFit = 'google_fit',
  GoogleHealth = 'google_health',
  HealthConnect = 'health_connect',
  KetoMojoUs = 'keto_mojo_us',
  MyFitnessPal = 'my_fitness_pal',
  Oura = 'oura',
}

export type ThirdPartySignIn = {
  provider: ThirdPartySignInProvider
  providerToken: Scalars['String']['input']
  providerUserId?: InputMaybe<Scalars['String']['input']>
}

export enum ThirdPartySignInProvider {
  Apple = 'apple',
  Google = 'google',
}

export enum TicketKind {
  Subscription = 'subscription',
  Troubleshooting = 'troubleshooting',
}

export enum TicketReason {
  Accounts = 'accounts',
  Addons = 'addons',
  AppLogin = 'app_login',
  AppMealLogging = 'app_meal_logging',
  AppQuestionnaires = 'app_questionnaires',
  Billing = 'billing',
  Cancellation = 'cancellation',
  GeneralInquiries = 'general_inquiries',
  GeneralNutritionSupport = 'general_nutrition_support',
  HealthPortal = 'health_portal',
  InformationUpdate = 'information_update',
  Insurance = 'insurance',
  InsuranceInquiries = 'insurance_inquiries',
  IntegrationHealth = 'integration_health',
  IntegrationsDexcom = 'integrations_dexcom',
  IntegrationsOther = 'integrations_other',
  Other = 'other',
  Patches = 'patches',
  Pauses = 'pauses',
  Payments = 'payments',
  SensorActivation = 'sensor_activation',
  SensorCalibration = 'sensor_calibration',
  SensorFellOff = 'sensor_fell_off',
  SensorOther = 'sensor_other',
  SensorPainSkinIrritation = 'sensor_pain_skin_irritation',
  SensorScanning = 'sensor_scanning',
  Shipments = 'shipments',
  SubscriptionPurchase = 'subscription_purchase',
  SubscriptionUpdate = 'subscription_update',
  VideoCalls = 'video_calls',
}

export type TicketReasonDef = {
  __typename?: 'TicketReasonDef'
  key: TicketReason
  kind: TicketKind
  title: Scalars['String']['output']
}

export type Tickets = {
  __typename?: 'Tickets'
  reasonDefs: Array<TicketReasonDef>
}

export type TimePair = {
  __typename?: 'TimePair'
  displayValue?: Maybe<Scalars['String']['output']>
  interpolated: Scalars['Boolean']['output']
  x: Scalars['ISO8601DateTime']['output']
  y: Scalars['Numeric']['output']
}

export type Token = {
  __typename?: 'Token'
  value: Scalars['String']['output']
}

export enum TrackingMode {
  Cgm = 'cgm',
  Logging = 'logging',
}

export type TutorialStep = {
  __typename?: 'TutorialStep'
  description?: Maybe<Scalars['String']['output']>
  moreUrl?: Maybe<Scalars['String']['output']>
  photoUrlDark?: Maybe<Scalars['String']['output']>
  photoUrlLight?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  videoUrl?: Maybe<Scalars['String']['output']>
}

export type Tutorials = {
  __typename?: 'Tutorials'
  key: Scalars['String']['output']
  value: Array<TutorialStep>
}

export enum UiColor {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
}

export type UiFlags = {
  __typename?: 'UIFlags'
  chatbotReportsEligible: Scalars['Boolean']['output']
  insuranceInformationSubmitted: Scalars['Boolean']['output']
  rateAppEligible: Scalars['Boolean']['output']
  showAddInsuranceUpsells: Scalars['Boolean']['output']
  showChurnFeedbackModal: Scalars['Boolean']['output']
  showDownloadAppBanner: Scalars['Boolean']['output']
  showFreeCallTrialUpsellBanner: Scalars['Boolean']['output']
  showFreeCallTrialUpsellPopup: Scalars['Boolean']['output']
  showFullscriptLabsBanner: Scalars['Boolean']['output']
  showFullscriptLabsUpsellModal: Scalars['Boolean']['output']
  showLabResultAnalysisCompleteBanner: Scalars['Boolean']['output']
  showLabResultAnalysisFailedBanner: Scalars['Boolean']['output']
  showLibreIndirectSyncConfirmation: Scalars['Boolean']['output']
  /** @deprecated Remove when min version is 5.47.0+ */
  showLibreIndirectSyncPopupFlag: Scalars['Boolean']['output']
  /** @deprecated Remove when min version is 5.47.0+ */
  showLibreIndirectSyncScreenFlag: Scalars['Boolean']['output']
  showNetPromoterScoreSurvey: Scalars['Boolean']['output']
  showNoraHomeTutorial: Scalars['Boolean']['output']
  showNutritionistSwitchModal: Scalars['Boolean']['output']
  showOnboardingInsuranceSurvey: Scalars['Boolean']['output']
  showPostCoachSwitchSurvey: Scalars['Boolean']['output']
  showProductMarketFitSurvey: Scalars['Boolean']['output']
  showReferralBanner: Scalars['Boolean']['output']
  showReferralPopup: Scalars['Boolean']['output']
  showReferredToPurchaseModal: Scalars['Boolean']['output']
  showStressManagementBanner: Scalars['Boolean']['output']
  showThirtyMinuteVideoCallScheduling: Scalars['Boolean']['output']
  showUnifiedOnboarding: Scalars['Boolean']['output']
  showVideoCallSteloUpsellModal: Scalars['Boolean']['output']
  showVideoCallSteloUpsellPersistentBanner: Scalars['Boolean']['output']
  showWeightLossRecurringCallsBanner: Scalars['Boolean']['output']
}

export enum UiIcon {
  Avocado = 'avocado',
  Barbell = 'barbell',
  Bed = 'bed',
  BellRinging = 'bell_ringing',
  Bluetooth = 'bluetooth',
  BookOpenText = 'book_open_text',
  BookmarkSimple = 'bookmark_simple',
  CalendarBlank = 'calendar_blank',
  Carrot = 'carrot',
  ChartLine = 'chart_line',
  Coaching = 'coaching',
  Confetti = 'confetti',
  Cookie = 'cookie',
  Done = 'done',
  Drop = 'drop',
  Fish = 'fish',
  Flag = 'flag',
  FlowerLotus = 'flower_lotus',
  Food = 'food',
  Footprints = 'footprints',
  ForkKnife = 'fork_knife',
  Gift = 'gift',
  Glucose = 'glucose',
  Goals = 'goals',
  Hamburger = 'hamburger',
  HandHeart = 'hand_heart',
  Health = 'health',
  Lifebuoy = 'lifebuoy',
  Lifecycle = 'lifecycle',
  MoonStars = 'moon_stars',
  Percent = 'percent',
  PersonSimpleBike = 'person_simple_bike',
  PersonSimpleRun = 'person_simple_run',
  PersonSimpleSwim = 'person_simple_swim',
  PersonSimpleWalk = 'person_simple_walk',
  Plant = 'plant',
  Scales = 'scales',
  SealCheck = 'seal_check',
  Sleep = 'sleep',
  Smiley = 'smiley',
  Sparkle = 'sparkle',
  Steps = 'steps',
  Tag = 'tag',
  Thermometer = 'thermometer',
  Timer = 'timer',
  Users = 'users',
  Warning = 'warning',
  Waves = 'waves',
}

export enum UiInlineAlert {
  Danger = 'danger',
  Info = 'info',
  Neutral = 'neutral',
  Success = 'success',
  Warning = 'warning',
}

export enum UiPillFill {
  Brick = 'brick',
  Citron = 'citron',
  Moonstone = 'moonstone',
  Tea = 'tea',
  White = 'white',
}

export enum UiPillSize {
  M = 'm',
  S = 's',
}

export enum UiPillType {
  Alert = 'alert',
  Info = 'info',
  Neutral = 'neutral',
  Success = 'success',
  Warning = 'warning',
}

export type UiState = {
  __typename?: 'UIState'
  createdAt: Scalars['ISO8601DateTime']['output']
  name: UiStateNames
  value: Scalars['Boolean']['output']
}

export enum UiStateNames {
  CheckoutCompleted = 'checkout_completed',
  ChurnFeedbackModal = 'churn_feedback_modal',
  CoachRatingModalDismissed = 'coach_rating_modal_dismissed',
  DailyActionCompleted = 'daily_action_completed',
  DailyActionStreakCompleted = 'daily_action_streak_completed',
  DexcomSensorPrompt = 'dexcom_sensor_prompt',
  DownloadAppBannerInteracted = 'download_app_banner_interacted',
  EligibleForNetPromoterScoreSurvey = 'eligible_for_net_promoter_score_survey',
  EligibleForProductMarketFitSurvey = 'eligible_for_product_market_fit_survey',
  FirstCallReadinessBannerClicked = 'first_call_readiness_banner_clicked',
  FreeCallTrialUpsellBannerDismissed = 'free_call_trial_upsell_banner_dismissed',
  FreeCallTrialUpsellPopupShown = 'free_call_trial_upsell_popup_shown',
  FreestyleLibreTerraGlucoseDetected = 'freestyle_libre_terra_glucose_detected',
  FullscriptLabsBannerClicked = 'fullscript_labs_banner_clicked',
  FullscriptLabsUpsellModalShown = 'fullscript_labs_upsell_modal_shown',
  InsuranceInformationSubmitted = 'insurance_information_submitted',
  NetPromoterScoreSurveyReminderSent = 'net_promoter_score_survey_reminder_sent',
  NetPromoterScoreSurveyVisited = 'net_promoter_score_survey_visited',
  NoraHomeTutorialSeen = 'nora_home_tutorial_seen',
  NutritionistSwitchModal = 'nutritionist_switch_modal',
  OnboardingChecklistReminderVisited = 'onboarding_checklist_reminder_visited',
  OpenedMobileApp = 'opened_mobile_app',
  OwnSensorGlucoseDetected = 'own_sensor_glucose_detected',
  OwnSensorOnboardingCompleted = 'own_sensor_onboarding_completed',
  OwnSensorTutorialCompleted = 'own_sensor_tutorial_completed',
  PostCoachSwitchSurvey = 'post_coach_switch_survey',
  PrescriptionDexcomG7Allowed = 'prescription_dexcom_g7_allowed',
  ProductMarketFitSurveyReminderSent = 'product_market_fit_survey_reminder_sent',
  ProductMarketFitSurveyVisited = 'product_market_fit_survey_visited',
  ReferralBannerDismissed = 'referral_banner_dismissed',
  ReferralPopupDismissed = 'referral_popup_dismissed',
  ReferredToPurchaseByNutritionistModal = 'referred_to_purchase_by_nutritionist_modal',
  ShowLabResultAnalysisCompleteBanner = 'show_lab_result_analysis_complete_banner',
  ShowLabResultAnalysisFailedBanner = 'show_lab_result_analysis_failed_banner',
  ShowLibre3ToLinkupScreen = 'show_libre3_to_linkup_screen',
  ShowLibreIndirectSyncPopup = 'show_libre_indirect_sync_popup',
  ShowLibreIndirectSyncScreen = 'show_libre_indirect_sync_screen',
  SteloRealtimeApiUpgradeBanner = 'stelo_realtime_api_upgrade_banner',
  SteloShowMigrationBanner = 'stelo_show_migration_banner',
  SteloShowUpgradedBanner = 'stelo_show_upgraded_banner',
  StressManagementBannerDismissed = 'stress_management_banner_dismissed',
  SyncedFreestyleLibreTerra = 'synced_freestyle_libre_terra',
  SyncedLinkup = 'synced_linkup',
  SyncedSteloRealtime = 'synced_stelo_realtime',
  UnifiedOnboardingCompleted = 'unified_onboarding_completed',
  UnifiedOnboardingStarted = 'unified_onboarding_started',
  UnifiedOnboardingUpsellOffersCompleted = 'unified_onboarding_upsell_offers_completed',
  VideoCallSteloUpsellReferralModal = 'video_call_stelo_upsell_referral_modal',
  ViewedTrends = 'viewed_trends',
  WeightLossRecurringBannerClicked = 'weight_loss_recurring_banner_clicked',
}

export type UhcDeepLinks = {
  __typename?: 'UhcDeepLinks'
  storeUrl: Scalars['String']['output']
}

export type UhcMember = {
  __typename?: 'UhcMember'
  appAccessBlocked: Scalars['Boolean']['output']
  dateOfBirth?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastName?: Maybe<Scalars['String']['output']>
  uhcId: Scalars['String']['output']
}

export enum UhcStoreProduct {
  FitnessMonthly = 'fitness_monthly',
  FitnessOneTime = 'fitness_one_time',
  HealthCoachingMonthly = 'health_coaching_monthly',
  HealthCoachingOneTime = 'health_coaching_one_time',
}

export type UhcStoreSubscription = {
  __typename?: 'UhcStoreSubscription'
  id: Scalars['ID']['output']
  lastState: UhcStoreSubscriptionState
  product: UhcStoreProduct
  uhcId: Scalars['String']['output']
}

export type UhcStoreSubscriptionCollection = {
  __typename?: 'UhcStoreSubscriptionCollection'
  pageCount?: Maybe<Scalars['Int']['output']>
  subscriptions: Array<UhcStoreSubscription>
  totalCount: Scalars['Int']['output']
}

export type UhcStoreSubscriptionDynamicFilter = {
  field: UhcStoreSubscriptionSubscriptionDynamicFilterField
  operation: DynamicFilterItemOperation
  value: Scalars['String']['input']
}

export type UhcStoreSubscriptionDynamicFilterItem = {
  items: Array<UhcStoreSubscriptionDynamicFilter>
  operator: DynamicFilterOperator
}

export type UhcStoreSubscriptionSort = {
  direction: SortDirection
  field: UhcStoreSubscriptionSubscriptionSortField
}

export type UhcStoreSubscriptionState = {
  __typename?: 'UhcStoreSubscriptionState'
  id: Scalars['ID']['output']
  kind: UhcStoreSubscriptionStateKind
  occurredAt: Scalars['ISO8601DateTime']['output']
  serviceValidUntil?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export enum UhcStoreSubscriptionStateKind {
  Active = 'active',
  Cancelled = 'cancelled',
}

export enum UhcStoreSubscriptionSubscriptionDynamicFilterField {
  Product = 'product',
  State = 'state',
}

export enum UhcStoreSubscriptionSubscriptionSortField {
  CreatedAt = 'created_at',
  Product = 'product',
  State = 'state',
}

export type UnifiedOnboardingUpsellOffer = {
  __typename?: 'UnifiedOnboardingUpsellOffer'
  completedText?: Maybe<Scalars['String']['output']>
  data: Scalars['JSON']['output']
  kind: UnifiedOnboardingUpsellOfferKind
  skippedText?: Maybe<Scalars['String']['output']>
}

export enum UnifiedOnboardingUpsellOfferKind {
  LabPanels = 'lab_panels',
  NutritionAppointment = 'nutrition_appointment',
  ReferAFriend = 'refer_a_friend',
  SteloCgm = 'stelo_cgm',
  StressManagementAppointment = 'stress_management_appointment',
  UpgradeSubscription = 'upgrade_subscription',
}

export type UnifiedOnboardingUpsellOffers = {
  __typename?: 'UnifiedOnboardingUpsellOffers'
  upsellOffers: Array<UnifiedOnboardingUpsellOffer>
}

export type UnitOption = {
  __typename?: 'UnitOption'
  increment: Scalars['Float']['output']
  max: Scalars['Float']['output']
  min: Scalars['Float']['output']
  units?: Maybe<Scalars['String']['output']>
}

export type UpgradedSubscription = {
  __typename?: 'UpgradedSubscription'
  subscription: Subscription
}

export type UpsellOffer = {
  __typename?: 'UpsellOffer'
  badge: Scalars['String']['output']
  benefits: Array<UpsellOfferBenefit>
  benefitsDescription: Scalars['String']['output']
  benefitsTitle?: Maybe<Scalars['String']['output']>
  billingProduct: BillingProduct
  billingProductName: Scalars['String']['output']
  billingProductPrice: Scalars['String']['output']
  cheaperSensors: Scalars['Boolean']['output']
  cheaperSensorsDescriptionMarkdown?: Maybe<Scalars['String']['output']>
  descriptionMarkdown: Scalars['String']['output']
  subscriptionId: Scalars['ID']['output']
  title: Scalars['String']['output']
  upgradeCallToAction: Scalars['String']['output']
  upgradeDescription: Scalars['String']['output']
}

export type UpsellOfferBenefit = {
  __typename?: 'UpsellOfferBenefit'
  description: Scalars['String']['output']
  icon: UiIcon
  title: Scalars['String']['output']
}

export type User = {
  __typename?: 'User'
  activeCoachingKinds: Array<CoachesCoachingKindDef>
  addonLimits: Array<AddonLimit>
  address?: Maybe<Address>
  age?: Maybe<Scalars['String']['output']>
  avatar?: Maybe<Scalars['String']['output']>
  berryStreetGetHealthieId?: Maybe<Scalars['Int']['output']>
  coachAssignmentInfo: CoachAssignmentInfo
  coachAssignments?: Maybe<Array<CoachAssignment>>
  /** @deprecated use mntChatConversation or stressChatConversation */
  coachChatConversation?: Maybe<ChatConversation>
  coachProfile?: Maybe<CoachProfile>
  compoundedSemaglutideConsent: Scalars['Boolean']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  dateOfBirth?: Maybe<Scalars['String']['output']>
  dexcomConnection?: Maybe<DexcomConnectionType>
  /** @deprecated dexcom research is deprecated */
  dexcomSensorPromptUiState?: Maybe<Scalars['Boolean']['output']>
  dexcomSteloConnection?: Maybe<DexcomConnectionType>
  eligibleForInsuranceCoverage: Scalars['Boolean']['output']
  email: Scalars['String']['output']
  features: Array<MobileAppFeature>
  firstName: Scalars['String']['output']
  floridaDigitalBillOfRightsConsent: Scalars['Boolean']['output']
  /** @deprecated use ehrAppointmentSchedulingInfo instead */
  followupSchedulingAvailable: Scalars['Boolean']['output']
  fulfillmentConfiguration: FulfillmentConfiguration
  fullName: Scalars['String']['output']
  futurePaymentsConsent: Scalars['Boolean']['output']
  goalMetrics: Array<GoalMetric>
  governmentIdCard?: Maybe<Scalars['String']['output']>
  /** @deprecated not used anymore */
  healthReject?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  intercomDigest?: Maybe<Scalars['String']['output']>
  kind: UserKind
  klaviyoId?: Maybe<Scalars['String']['output']>
  kustomerId?: Maybe<Scalars['String']['output']>
  /** @deprecated not used anymore */
  lastAnsweredHealthSurveyQuestionKey?: Maybe<SurveysQuestionKey>
  lastAnsweredMedicalHistorySurveyQuestionKey?: Maybe<SurveysQuestionKey>
  lastAppPlatform?: Maybe<Scalars['String']['output']>
  lastAppVersion?: Maybe<Scalars['String']['output']>
  lastAppointmentDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastAsyncChatAssignment?: Maybe<CoachAssignment>
  lastCoreSubscription?: Maybe<Subscription>
  lastDietitianSubscription?: Maybe<Subscription>
  lastDoctorAssignment?: Maybe<DoctorAssignment>
  lastDppApprovalRequest?: Maybe<ApprovalRequest>
  lastGlpApprovalRequest?: Maybe<ApprovalRequest>
  lastGlpRenewalApprovalRequest?: Maybe<ApprovalRequest>
  lastGovernmentIdApprovalRequest?: Maybe<ApprovalRequest>
  lastMedicalAppointment?: Maybe<EhrAppointment>
  lastName: Scalars['String']['output']
  lastOccurredCoachingAppointment?: Maybe<EhrAppointment>
  /** @deprecated prescriptions are not used anymore */
  lastPrescriptionApprovalRequest?: Maybe<ApprovalRequest>
  /** @deprecated dexcom research is deprecated */
  lastResearchApprovalRequest?: Maybe<ApprovalRequest>
  lastVideoChatAssignment?: Maybe<CoachAssignment>
  latestCgmOrderDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  mfaEnabled: Scalars['Boolean']['output']
  mntChatConversation?: Maybe<ChatConversation>
  nextAppointmentDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  /** @deprecated Use feature checks instead */
  nutrisenseAdmin: Scalars['Boolean']['output']
  nutrisenseGetHealthieId?: Maybe<Scalars['Int']['output']>
  onboardingExperience?: Maybe<OnboardingExperience>
  ongoingCareNonRefundableConsent: Scalars['Boolean']['output']
  ongoingCoreSubscription?: Maybe<Subscription>
  ongoingDietitianSubscription?: Maybe<Subscription>
  ongoingSubscriptions: Array<Subscription>
  organization: Organization
  paymentMethod?: Maybe<PaymentMethod>
  phoneNumber?: Maybe<Scalars['String']['output']>
  phoneNumberConsent?: Maybe<Scalars['Boolean']['output']>
  primaryCoachingKind: CoachesCoachingKindDef
  primaryGoal?: Maybe<Goal>
  purchasedSteloBiosensor: Scalars['Boolean']['output']
  referralPartner: UserReferralPartnerDef
  referralUrl: Scalars['String']['output']
  role: UserRole
  sensor?: Maybe<Sensor>
  sensorInfo?: Maybe<UserSensorInfo>
  settings: UserSettings
  sex?: Maybe<Scalars['String']['output']>
  /** @deprecated use uiFlags instead */
  showChurnFeedbackModal: Scalars['Boolean']['output']
  /** @deprecated use uiFlags instead */
  showReferredToPurchaseModal: Scalars['Boolean']['output']
  signUpSource?: Maybe<UserSignUpSource>
  stressChatConversation?: Maybe<ChatConversation>
  stripeCreditBalance: Scalars['Float']['output']
  stripeId?: Maybe<Scalars['String']['output']>
  subscriptions: Array<Subscription>
  surveyLinks: Array<SurveyLink>
  telehealthConsent: Scalars['Boolean']['output']
  timeZone: Scalars['String']['output']
  truepillPatientToken?: Maybe<Scalars['String']['output']>
  uhcMember?: Maybe<UhcMember>
  uiStates: Array<UiState>
  upsellOffer?: Maybe<UpsellOffer>
  userProperties?: Maybe<UserProperties>
  uxSensorMode: SensorMode
}

export enum UserApprovalRequestKind {
  Dpp = 'dpp',
  Glp = 'glp',
  GlpRenewal = 'glp_renewal',
  GovernmentId = 'government_id',
  Prescription = 'prescription',
  Research = 'research',
  Stelo = 'stelo',
}

export enum UserApprovalRequestState {
  Approved = 'approved',
  ConsentRejected = 'consent_rejected',
  ConsentWithdrawn = 'consent_withdrawn',
  DidNotComplete = 'did_not_complete',
  Init = 'init',
  PendingApproval = 'pending_approval',
  PendingMember = 'pending_member',
  PendingRejection = 'pending_rejection',
  PendingUpdate = 'pending_update',
  Rejected = 'rejected',
  Stale = 'stale',
}

export type UserAuth = {
  __typename?: 'UserAuth'
  /** @deprecated Use user_presenter instead */
  features: Array<MobileAppFeature>
  role?: Maybe<UserRole>
  status?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
  token?: Maybe<Scalars['String']['output']>
  user?: Maybe<User>
}

export type UserCalendar = {
  __typename?: 'UserCalendar'
  dates: Array<CalendarDate>
}

export enum UserChecklistItem {
  CompleteGoalsQuestionnaire = 'complete_goals_questionnaire',
  CompleteVideoCall = 'complete_video_call',
  LogMeal = 'log_meal',
  ProvideInsuranceInformation = 'provide_insurance_information',
  ShareLabResults = 'share_lab_results',
  SignInToTheApp = 'sign_in_to_the_app',
  StartLesson = 'start_lesson',
  ViewTrends = 'view_trends',
}

export enum UserChecklistItemsKind {
  Onboarding = 'onboarding',
}

export type UserCollection = {
  __typename?: 'UserCollection'
  users: Array<UserMin>
}

export type UserConversationMessagePreview = {
  __typename?: 'UserConversationMessagePreview'
  value: Scalars['String']['output']
}

export enum UserExperienceSensorModeKind {
  ActivePrescriptionDexcomG7 = 'active_prescription_dexcom_g7',
  ActiveResearchDexcom = 'active_research_dexcom',
  Default = 'default',
  DexcomStelo = 'dexcom_stelo',
  LibreLinkup = 'libre_linkup',
  Lingo = 'lingo',
  OwnSensorDexcomG6 = 'own_sensor_dexcom_g6',
  OwnSensorDexcomG7 = 'own_sensor_dexcom_g7',
  OwnSensorDexcomStelo = 'own_sensor_dexcom_stelo',
  OwnSensorLibre1 = 'own_sensor_libre1',
  OwnSensorLibre2 = 'own_sensor_libre2',
  OwnSensorLibre3 = 'own_sensor_libre3',
  PendingLibre3 = 'pending_libre3',
  PendingPrescriptionDexcomG7 = 'pending_prescription_dexcom_g7',
  PendingResearchDexcom = 'pending_research_dexcom',
}

export enum UserFileTag {
  BodyPhoto = 'body_photo',
  ChatbotAttachment = 'chatbot_attachment',
  DexcomResearchConsent = 'dexcom_research_consent',
  DppHbA1cEvidence = 'dpp_hb_a1c_evidence',
  DppWeightEvidence = 'dpp_weight_evidence',
  GlpLabWorkResults = 'glp_lab_work_results',
  GovernmentIdCard = 'government_id_card',
  HealthInsuranceCard = 'health_insurance_card',
  InsuranceCardBackPhoto = 'insurance_card_back_photo',
  InsuranceCardFrontPhoto = 'insurance_card_front_photo',
  IntercomAttachment = 'intercom_attachment',
  LabWorkResults = 'lab_work_results',
}

export enum UserGoalKind {
  ImproveGlucoseValues = 'improve_glucose_values',
  LearnAboutGlucoseLevels = 'learn_about_glucose_levels',
  LoseWeight = 'lose_weight',
  ManageChronicCondition = 'manage_chronic_condition',
  OptimizeFitnessPerformance = 'optimize_fitness_performance',
  Other = 'other',
  PreventDisease = 'prevent_disease',
  PromoteLongevity = 'promote_longevity',
}

export enum UserGoalMetricKind {
  GlucoseMax = 'glucose_max',
  GlucoseMean = 'glucose_mean',
  GlucoseMin = 'glucose_min',
  GlucoseMorningAverage = 'glucose_morning_average',
  GlucoseSleepAverage = 'glucose_sleep_average',
  GlucoseStandardDeviation = 'glucose_standard_deviation',
  GlucoseTimeWithinRange = 'glucose_time_within_range',
  JournalAppetite = 'journal_appetite',
  JournalEnergy = 'journal_energy',
  JournalFocus = 'journal_focus',
  JournalMood = 'journal_mood',
  JournalStress = 'journal_stress',
  MeasurementsWeight = 'measurements_weight',
}

export enum UserInsurancePolicyHolderRelationship {
  Child = 'child',
  Other = 'other',
  Self = 'self',
  Spouse = 'spouse',
}

export enum UserInsurancePolicyKind {
  Aetna = 'aetna',
  Anthem = 'anthem',
  BlueCrossBlueShield = 'blue_cross_blue_shield',
  Cigna = 'cigna',
  Empire = 'empire',
  Highmark = 'highmark',
  Horizon = 'horizon',
  SanaBenefits = 'sana_benefits',
  UnitedHealthcare = 'united_healthcare',
}

export type UserInsurancePolicyKindDef = {
  __typename?: 'UserInsurancePolicyKindDef'
  key: UserInsurancePolicyKind
  title: Scalars['String']['output']
}

export enum UserInsurancePolicyStateKind {
  Canceled = 'canceled',
  CanceledInsuranceNotAccepted = 'canceled_insurance_not_accepted',
  CanceledNoProvidersInn = 'canceled_no_providers_inn',
  Created = 'created',
  Eligible = 'eligible',
  EligiblePatientResponsibility = 'eligible_patient_responsibility',
  EligiblePreAuth = 'eligible_pre_auth',
  Hold = 'hold',
  InReview = 'in_review',
  NotEligible = 'not_eligible',
  NotSupported = 'not_supported',
}

export enum UserKind {
  Influencer = 'influencer',
  Internal = 'internal',
  Investor = 'investor',
  Regular = 'regular',
}

export type UserMin = {
  __typename?: 'UserMin'
  email: Scalars['String']['output']
  fullName: Scalars['String']['output']
  id: Scalars['ID']['output']
  phoneNumber: Scalars['String']['output']
  timeZone: Scalars['String']['output']
}

export type UserProperties = {
  __typename?: 'UserProperties'
  byosVideoCallsUpsell?: Maybe<MobileUserProperty>
  communicationFrequency?: Maybe<MobileUserProperty>
  complimentarySupportDecision?: Maybe<MobileUserProperty>
  dietitianRequest?: Maybe<MobileUserProperty>
  dietitianSensorCountNotes?: Maybe<MobileUserProperty>
  healthGoal?: Maybe<MobileUserProperty>
  insuranceSurveySkipReason?: Maybe<MobileUserProperty>
  mfpPromotionCardDismissalTimestamp?: Maybe<MobileUserProperty>
  nutritionistGroup?: Maybe<MobileUserProperty>
  oneMonthActiveFeedbackDietitian?: Maybe<MobileUserProperty>
  scheduledVideoCallStatus?: Maybe<MobileUserProperty>
  testGroup?: Maybe<MobileUserProperty>
  videoCallRescheduleFreePassUsed?: Maybe<MobileUserProperty>
  weightLossExperience?: Maybe<MobileUserProperty>
}

export enum UserPropertyKind {
  AbandonerInsurancePolicyId = 'abandoner_insurance_policy_id',
  ActiveInterventions = 'active_interventions',
  AppRating = 'app_rating',
  Background = 'background',
  BmiRange = 'bmi_range',
  ByosVideoCallsUpsell = 'byos_video_calls_upsell',
  Clinic = 'clinic',
  CoachRatingInitiatedRatingStatus = 'coach_rating_initiated_rating_status',
  CoachingStyle = 'coaching_style',
  CommunicationFrequency = 'communication_frequency',
  ComplimentarySupportDecision = 'complimentary_support_decision',
  CustomKeyPoint = 'custom_key_point',
  Diet = 'diet',
  DietitianNotes = 'dietitian_notes',
  DietitianRequest = 'dietitian_request',
  DietitianSensorCountNotes = 'dietitian_sensor_count_notes',
  DoNotSendWrapUpMessage = 'do_not_send_wrap_up_message',
  Education = 'education',
  FoodAllergies = 'food_allergies',
  FutureInterventions = 'future_interventions',
  GlucoseManagementKnowledge = 'glucose_management_knowledge',
  HealthConditions = 'health_conditions',
  HealthGoal = 'health_goal',
  Height = 'height',
  InferredSex = 'inferred_sex',
  InitialInsuranceCallDuration = 'initial_insurance_call_duration',
  InsuranceReimbursementInterest = 'insurance_reimbursement_interest',
  InsuranceSurveySkipReason = 'insurance_survey_skip_reason',
  InsuranceVideoCallGoal = 'insurance_video_call_goal',
  Libre_3Outage = 'libre_3_outage',
  Libre_3OutagePreShipmentNotice = 'libre_3_outage_pre_shipment_notice',
  Medications = 'medications',
  MfpPromotionCardDismissalTimestamp = 'mfp_promotion_card_dismissal_timestamp',
  NetPromoterScoreSurveyTriggeringMilestoneKind = 'net_promoter_score_survey_triggering_milestone_kind',
  NutritionistGroup = 'nutritionist_group',
  OnboardingExperience = 'onboarding_experience',
  OneMonthActiveFeedbackDietitian = 'one_month_active_feedback_dietitian',
  OwnCgmDevice = 'own_cgm_device',
  OwnGlucometer = 'own_glucometer',
  PrimaryJoiningGoal = 'primary_joining_goal',
  ScheduledVideoCallStatus = 'scheduled_video_call_status',
  StepsPerDay = 'steps_per_day',
  TestGroup = 'test_group',
  UpgradeSubscriptionAlertDismissedBillingProduct = 'upgrade_subscription_alert_dismissed_billing_product',
  VideoCallRescheduleFreePassUsed = 'video_call_reschedule_free_pass_used',
  VideoCallSteloUpsellModalDismissed = 'video_call_stelo_upsell_modal_dismissed',
  VideoCallSteloUpsellPersistent = 'video_call_stelo_upsell_persistent',
  VideoCallUpsell = 'video_call_upsell',
  Weight = 'weight',
  WeightLossExperience = 'weight_loss_experience',
}

export enum UserPropertyOnboardingExperienceKind {
  Other = 'other',
  PreDiabetes = 'pre_diabetes',
  WeightLoss = 'weight_loss',
  WomensHealth = 'womens_health',
}

export type UserPropertySubmission = {
  kind: UserPropertyKind
  value: Scalars['String']['input']
}

export enum UserReferralPartner {
  Agelessrx = 'agelessrx',
  Bf = 'bf',
  Bm = 'bm',
  Bodyspec = 'bodyspec',
  Bp = 'bp',
  Dadv = 'dadv',
  Dexcom = 'dexcom',
  Flore = 'flore',
  Forbes = 'forbes',
  Hhtelemed = 'hhtelemed',
  Influencer = 'influencer',
  It = 'it',
  Jh = 'jh',
  Kegg = 'kegg',
  Lg = 'lg',
  LoseIt = 'lose_it',
  Lpd = 'lpd',
  Mfp = 'mfp',
  MfpCredit = 'mfp_credit',
  Mindypelz = 'mindypelz',
  Miracare = 'miracare',
  NoPartner = 'no_partner',
  Northwestern = 'northwestern',
  Pnmag = 'pnmag',
  Proov = 'proov',
  Roswell = 'roswell',
  Sc = 'sc',
  Simple = 'simple',
  Stelo = 'stelo',
  Tovala = 'tovala',
  Trg = 'trg',
  Veracity = 'veracity',
  Vip = 'vip',
  Welltory = 'welltory',
  Wisp = 'wisp',
}

export type UserReferralPartnerDef = {
  __typename?: 'UserReferralPartnerDef'
  key: UserReferralPartner
  logoUrl?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  product?: Maybe<BillingProduct>
  requiresProtocol: Scalars['Boolean']['output']
  schedulingWithoutInsuranceInformation: Scalars['Boolean']['output']
  schedulingWithoutPaymentMethod: Scalars['Boolean']['output']
}

export enum UserRole {
  Admin = 'admin',
  Coach = 'coach',
  CoachManager = 'coach_manager',
  CustomerSupport = 'customer_support',
  Engineer = 'engineer',
  ExternalAdmin = 'external_admin',
  Operations = 'operations',
  User = 'user',
}

export type UserSensorInfo = {
  __typename?: 'UserSensorInfo'
  firstActivationDate?: Maybe<Scalars['ISO8601Date']['output']>
  firstStartTime?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastSensor?: Maybe<Sensor>
  replacementRequestsCount: Scalars['Int']['output']
  totalCount: Scalars['Int']['output']
}

export enum UserSensorKind {
  DexcomG7 = 'dexcom_g7',
  DexcomStelo = 'dexcom_stelo',
  Libre1 = 'libre1',
  Libre2 = 'libre2',
  Libre3 = 'libre3',
  PrescriptionDexcomG7 = 'prescription_dexcom_g7',
}

export type UserSettings = {
  __typename?: 'UserSettings'
  /** @deprecated Removed in v2.6.0 from mobile app */
  appVersionReminder: Scalars['Boolean']['output']
  dashboardGraph: Scalars['String']['output']
  dexcomSync: Scalars['Boolean']['output']
  displayActivityScore: Scalars['Boolean']['output']
  displayDailyScore: Scalars['Boolean']['output']
  displayMealScore: Scalars['Boolean']['output']
  fastingEnd: Scalars['Int']['output']
  fastingStart: Scalars['Int']['output']
  glucoseHighThreshold: Scalars['Int']['output']
  glucoseLowThreshold: Scalars['Int']['output']
  googleFitSync: Scalars['Boolean']['output']
  healthKitSync: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  integrationsSyncSettings: IntegrationsSync
  journalNotifications: Scalars['Boolean']['output']
  ketoMojoSync: Scalars['Boolean']['output']
  ketoneHighThreshold: Scalars['Float']['output']
  ketoneLowThreshold: Scalars['Float']['output']
  macroGoalsDaily: MacroGoals
  patternsNotifications: Scalars['Boolean']['output']
  reminders: Scalars['Boolean']['output']
  showNetCarbs: Scalars['Boolean']['output']
  statsSettings: Array<StatsSettings>
  /** @deprecated Removed in v2.6.0 from mobile app */
  trackingMode: TrackingMode
  unitSystem: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export enum UserSignUpSource {
  AmazonWebFlow = 'amazon_web_flow',
  Checkout = 'checkout',
  CoursesWebFlow = 'courses_web_flow',
  DppWebFlow = 'dpp_web_flow',
  GlpWebFlow = 'glp_web_flow',
  HealthPortal = 'health_portal',
  InsuranceFormSubmission = 'insurance_form_submission',
  InsuranceWebFlow = 'insurance_web_flow',
  MobileApp = 'mobile_app',
  OwnSensorWebFlow = 'own_sensor_web_flow',
  PartnerWebFlow = 'partner_web_flow',
  UhcSamlFlow = 'uhc_saml_flow',
}

export type UtteranceTranscription = {
  __typename?: 'UtteranceTranscription'
  id: Scalars['ID']['output']
  text: Scalars['String']['output']
}

export type ValuePair = NumericPair | RangePair | StringPair | TimePair

/** Autogenerated return type of VerifyMfaSmsCodeAction. */
export type VerifyMfaSmsCodeActionPayload = {
  __typename?: 'VerifyMfaSmsCodeActionPayload'
  mfaToken: Scalars['String']['output']
}

export enum WebMembersChatConversationEventSortField {
  SentAt = 'sent_at',
}

export type WebMembersChatConversationMessage = {
  __typename?: 'WebMembersChatConversationMessage'
  id: Scalars['ID']['output']
  senderAvatar?: Maybe<Scalars['String']['output']>
  senderId: Scalars['String']['output']
  senderKind: ChatConversationMessageSenderKind
  senderName: Scalars['String']['output']
  sentAt: Scalars['ISO8601DateTime']['output']
  value: Scalars['String']['output']
}

export type WebMembersChatConversationMessageSort = {
  direction: SortDirection
  field: WebMembersChatConversationEventSortField
}

export type WorkflowRun = {
  __typename?: 'WorkflowRun'
  errorMessage?: Maybe<Scalars['String']['output']>
  kind: WorkflowsRunKind
  runId: Scalars['String']['output']
  state: WorkflowsRunState
  subjectId: Scalars['ID']['output']
}

export enum WorkflowsRunKind {
  BillingOneTimePaymentCheckout = 'billing_one_time_payment_checkout',
}

export enum WorkflowsRunState {
  Completed = 'completed',
  Created = 'created',
  Failed = 'failed',
  Started = 'started',
}

export type Workout = {
  activityId?: InputMaybe<Scalars['Float']['input']>
  activityName: Scalars['String']['input']
  calories?: InputMaybe<Scalars['Float']['input']>
  device?: InputMaybe<Scalars['String']['input']>
  distance?: InputMaybe<Scalars['Float']['input']>
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  metadata?: InputMaybe<Scalars['JSON']['input']>
  sourceId?: InputMaybe<Scalars['String']['input']>
  sourceName?: InputMaybe<Scalars['String']['input']>
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  tracked?: InputMaybe<Scalars['Boolean']['input']>
}
